webpackJsonp([120],{

/***/ 1004:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1313);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(678)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(677)(false);
// imports


// module
exports.push([module.i, ":root{--color-primary:#ff7c80;--color-secondary:#a6a6a6;--color-border:#ccc;--color-text:#000;--color-text-bg:#fff;--size-gap:10px}.font-body{font-size:1.6rem}.font-body-imp{font-size:1.6rem!important}.font-header{font-size:1.8rem}.font-button{font-size:1.6rem}.font-button-imp{font-size:1.6rem!important}.ui.checkbox,.ui.dropdown,.ui.form,.ui.form .field>label,.ui.form textarea,.ui.input,.ui.input input,.ui[class*=\"left icon\"].input>input,a,body,button,div,h1,h2,h3,h4,h5,h6,p,select,span{font-family:rsu!important}a,h1,h2,h3,h4,h5,h6,p{margin:0}input{line-height:1!important}.ui.button:last-child{margin-right:0!important}.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-khtml-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}*{box-sizing:border-box!important}.text-overflow-1{-webkit-line-clamp:1}.text-overflow-1,.text-overflow-2{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-2{-webkit-line-clamp:2}.text-overflow-3{-webkit-line-clamp:3}.text-overflow-3,.text-overflow-4{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-4{-webkit-line-clamp:4}.text-overflow-5{-webkit-line-clamp:5}.text-overflow-5,.text-overflow-6{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-6{-webkit-line-clamp:6}.text-overflow-7{-webkit-line-clamp:7}.text-overflow-7,.text-overflow-8{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-8{-webkit-line-clamp:8}.text-overflow-9{-webkit-line-clamp:9}.text-overflow-9,.text-overflow-10{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-10{-webkit-line-clamp:10}.text-overflow-11{-webkit-line-clamp:11}.text-overflow-11,.text-overflow-12{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-12{-webkit-line-clamp:12}.text-overflow-13{-webkit-line-clamp:13}.text-overflow-13,.text-overflow-14{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-14{-webkit-line-clamp:14}.text-overflow-15{-webkit-line-clamp:15}.text-overflow-15,.text-overflow-16{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-16{-webkit-line-clamp:16}.text-overflow-17{-webkit-line-clamp:17}.text-overflow-17,.text-overflow-18{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-18{-webkit-line-clamp:18}.text-overflow-19{-webkit-line-clamp:19}.text-overflow-19,.text-overflow-20{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-20{-webkit-line-clamp:20}.text-overflow-21{-webkit-line-clamp:21}.text-overflow-21,.text-overflow-22{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-22{-webkit-line-clamp:22}.text-overflow-23{-webkit-line-clamp:23}.text-overflow-23,.text-overflow-24{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-24{-webkit-line-clamp:24}.text-overflow-25{-webkit-line-clamp:25}.text-overflow-25,.text-overflow-26{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-26{-webkit-line-clamp:26}.text-overflow-27{-webkit-line-clamp:27}.text-overflow-27,.text-overflow-28{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-28{-webkit-line-clamp:28}.text-overflow-29{-webkit-line-clamp:29}.text-overflow-29,.text-overflow-30{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.text-overflow-30{-webkit-line-clamp:30}.canvasjs-chart-credit{display:none!important}.btnc{min-width:100px!important}.grid-custom-nogap{margin:0!important}.grid-custom-nogap>.column,.grid-custom-nogap>.row,.grid-custom-nogap>.row>.column{padding:0!important}.module.layoutBlank{width:100%;height:100vh;height:calc(var(--vh, 1vh) * 100)}.module.layoutWithHeaderFooter .lwshf-body{z-index:2}.module.layoutWithHeaderFooter .lwshf-body .lwshf-menu-bottom{height:40px;background-color:#333;z-index:1}.module.layoutWithHeaderFooter .lwshf-body .lwshf-menu-bottom .menu-bottom-wrapper{width:100%;height:100%;display:flex;align-items:center;justify-content:center;position:relative}.module.layoutWithHeaderFooter .lwshf-body .lwshf-menu-bottom .menu-bottom-wrapper .text-page-footer,.module.layoutWithHeaderFooter .lwshf-body .lwshf-menu-bottom .menu-bottom-wrapper .text-version{color:#ccc}.module.layoutWithHeaderFooter .lwshf-body .lwshf-menu-bottom .menu-bottom-wrapper .text-page-footer p,.module.layoutWithHeaderFooter .lwshf-body .lwshf-menu-bottom .menu-bottom-wrapper .text-version p{font-size:18px}.module.layoutWithHeaderFooter .lwshf-body .lwshf-menu-bottom .menu-bottom-wrapper .text-version{position:absolute;right:1rem;top:50%;transform:translateY(-50%)}.module.layoutWithHeaderFooter .add-header{padding-top:100px}.module.layoutWithHeaderFooter .add-footer{padding-bottom:70px}.module.boxFixBody>.bfb-wrapper.h{height:calc((var(--vh, 1vh) * 100) - 100px)}.module.boxFixBody>.bfb-wrapper.f{height:calc((var(--vh, 1vh) * 100) - 70px)}.module.boxFixBody>.bfb-wrapper.hf{height:calc((var(--vh, 1vh) * 100) - 170px)}.module.header{height:70px;background-color:#333!important}.module.header .item-image{height:100%;padding:.5rem!important}.module.header .item-image .im-wrapper{height:100%;overflow:hidden;display:flex;align-items:center;justify-content:center}.module.header .item-image .im-wrapper img{max-height:100%}.module.header .menu-header,.module.header .menu-header:hover{border-radius:.28571429rem!important}.module.header .menu-header:hover{color:#fff!important;background-color:#445565!important}.module.header .header-group{text-decoration:underline;font-size:18px!important}.module.header .menu-overflow{max-height:80vh;overflow-x:hidden;overflow-y:auto}.module.moduleHeaderName{margin-bottom:10px}.module.loginForm{width:100%;height:100%;overflow:hidden;position:relative;display:flex;align-items:center;justify-content:center;flex-direction:column}.module.loginForm .box-switch-lang{position:absolute;right:0;top:0}.module.loginForm .divide-or:after,.module.loginForm .divide-or:before{top:0!important}.module.loginForm .box-logo{width:300px;height:80px}.module.loginForm .box-logo .logo-wrapper{width:100%;height:100%;display:flex;align-items:center;justify-content:center}.module.loginForm .box-logo .logo-wrapper img{max-width:100%;height:100%}.module.loginForm .box-login{width:30%;height:auto;margin-top:2rem}.module.loginForm .box-login .box-email{margin-bottom:1rem}.module.loginForm .box-login .login-wrapper{max-height:0;overflow:hidden;transition:max-height .3s ease-out;width:100%}.module.loginForm .box-login .login-wrapper.open{max-height:500px}.module.loginForm .box-login .login-wrapper .box-remember{margin:1rem 0}.module.home{width:100%;height:100%}.module.home>.ui.container{height:100%;overflow:hidden}.module.home .home-wrapper{width:100%;height:100%;display:flex}.module.home .home-wrapper>.box-status{width:30%;height:100%;flex:0 0 auto}.module.home .home-wrapper>.box-status .status-wrapper{width:100%;height:100%;display:flex;flex-direction:column}.module.home .home-wrapper>.box-status .status-wrapper .s-header{flex:0 0 auto}.module.home .home-wrapper>.box-status .status-wrapper .s-list{flex:1;overflow:hidden}.module.home .home-wrapper>.box-status .status-wrapper .s-list .list-wrapper{width:100%;height:100%;overflow-x:hidden;overflow-y:auto}.module.home .home-wrapper>.box-chart{flex:1;overflow:hidden;margin-left:2rem;padding-left:2rem;border-left:1px solid #ccc}.module.home .home-wrapper>.box-chart>.chart-wrapper,.module.peiChart{width:100%;height:100%}.module.peiChart .pc-wrapper{width:100%;height:100%;display:flex;flex-direction:column}.module.peiChart .pc-wrapper>.box-chart{flex:1;overflow:hidden}.module.peiChart .pc-wrapper>.box-chart>.chart-wrapper{width:100%;height:100%;display:flex;align-items:center;justify-content:center}.module.peiChart .pc-wrapper>.box-hint{flex:0 0 auto}.module.peiChart .pc-wrapper>.box-hint p{font-size:14px}.module.realStatus,.module.realStatus .rs-wrapper{width:100%;height:100%}.module.realStatus .rs-wrapper .item-room-status{margin-bottom:1rem}.module.realStatus .rs-wrapper .item-room-status .irs-wrapper{border:1px solid #ccc;border-radius:10px;overflow:hidden;cursor:pointer}.module.realStatus .rs-wrapper .item-room-status .irs-wrapper .header{padding:.5rem}.module.realStatus .rs-wrapper .item-room-status .irs-wrapper .header.free{background-color:#32cd32;color:#fff}.module.realStatus .rs-wrapper .item-room-status .irs-wrapper .header.waiting{background-color:#c99700;color:#fff}.module.realStatus .rs-wrapper .item-room-status .irs-wrapper .header.busy{background-color:#b93a32;color:#fff}.module.realStatus .rs-wrapper .item-room-status .irs-wrapper .header .h-wrapper p{font-weight:700}.module.realStatus .rs-wrapper .item-room-status .irs-wrapper .detail{padding:.5rem}.module.roomStatus{width:100%;height:100%}.module.roomStatus>.ui.container{height:100%;overflow:hidden}.module.roomStatus .rs-wrapper{width:100%;height:100%;display:flex;flex-direction:column}.module.roomStatus .rs-wrapper>.header{flex:0 0 auto}.module.roomStatus .rs-wrapper>.content{flex:1;overflow:hidden}.module.roomStatus .rs-wrapper>.content>.content-wrapper{width:100%;height:100%;display:flex}.module.roomStatus .rs-wrapper>.content>.content-wrapper>.box-status{width:30%;height:100%;flex:0 0 auto}.module.roomStatus .rs-wrapper>.content>.content-wrapper>.box-status .status-wrapper{width:100%;height:100%;display:flex;flex-direction:column}.module.roomStatus .rs-wrapper>.content>.content-wrapper>.box-status .status-wrapper .s-header{flex:0 0 auto}.module.roomStatus .rs-wrapper>.content>.content-wrapper>.box-status .status-wrapper .s-list{flex:1;overflow:hidden}.module.roomStatus .rs-wrapper>.content>.content-wrapper>.box-status .status-wrapper .s-list .list-wrapper{width:100%;height:100%;overflow-x:hidden;overflow-y:auto}.module.roomStatus .rs-wrapper>.content>.content-wrapper>.box-chart{flex:1;overflow:hidden;margin-left:2rem;padding-left:2rem;border-left:1px solid #ccc}.module.roomStatus .rs-wrapper>.content>.content-wrapper>.box-chart>.chart-wrapper{width:100%;height:100%}", ""]);

// exports


/***/ }),

/***/ 1314:
/***/ (function(module, exports) {

module.exports = {"account":"Login to Your Account","login":"Login","o365":"Sign in with O365","google":"Sign in with Google","exchange":"Sign in with Exchange","local":"Sign in Local","remember":"Remember","email":"Email","password":"Password","error":"Required!","emailerror":"Invalid Email Address","OR":"OR"}

/***/ }),

/***/ 1315:
/***/ (function(module, exports) {

module.exports = {"ok":"Ok","cancel":"Cancel","back":"Back","edit":"Edit","submit":"Submit","confirm":"Confirm","yes":"YES","no":"NO","done":"Done","AdvancedSearch":"Advanced Search","Update":"Update","Print":"Print","Enabled":"Enabled","Disable":"Disable","View":"View","QRCode":"QR Code","Delete":"Delete","Search":"Search","Clear":"Clear","UserO365":"Import User o365","Add":"Add","Next":"Next","Unregister":"Unregister","O365Rooms":"{name} Rooms","importRoom":"Import Room","searchString":"Search Text","create":"Create","update":"Update","close":"Close","save":"Save"}

/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

module.exports = {"masterData":"Master Data","rooms":"Rooms","roomMail":"Mail System Rooms","roomRegis":"Room Registration","roomSub":"Room Subscription","roomDis":"Room Disable","roomFormat":"Room Format","location":"Location","building":"Building","floor":"Floor","zone":"Zone","Users":"Users","adUsers":"AD User","userRegis":"User Registration","Department":"Department","userConcur":"User Login (Concurrent)","Role":"Role","Profile":"Profile","Background":"Background","Facilities":"Facilities","food":"Foods & Beverage","Category":"Category","Foods":"Foods","iotDisplay":"Display","iotRegis":"IoT Registration","iotRoomConfig":"IoT Room Config","eventType":"Event Type","Events":"Events","viewEvents":"View Events","Orders":"Orders","createOrder":"Create Order","Settings":"Settings","globalSetting":"Global Setting","Integration":"Integration","Terms":"Terms & Conditions","FAQ":"FAQ","Contact":"Contact Us","Report":"Report","Summary":"Summary","roomSummary":"Room Summary","userSummary":"User Summary","foodSummary":"Food Summary","facilitySummary":"Facility Summary","deleteEventSummary":"Delete Event Summary","reserveNotUse":"Reserve Not Use","Room":"Room","User":"User","Detail":"Detail","roomDetails":"Room Details","userDetails":"User Details","foodDetails":"Food Details By Event","facilityDetails":"Facility Details By Event","Monitor":"Monitor","Overview":"Overview","Status":"Status","topUser":"Top Users by Reservation","topRooms":"Top Rooms by Reservation","Hello":"Hello","UserInformation":"User Information","SignOut":"Sign Out","permission":"Permission","devices":"Devices","logo":"Logo","attendance":"User Attendance"}

/***/ }),

/***/ 1317:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Rooms":"Rooms","Page":"Page","of":"of","No":"No.","Name":"Name","Email":"Email","Sync":"Synchronize","AddNew":"Add New","Capacity":"Capacity","RoomType":"Room Type","Image":"Image","NotiUrl":"Notification Url","Expire":"Expire","Subject":"Subject","time":"Start - End","Room":"Room","Description":"Description","formatList":"Room Format List","Code":"Code","addCode":"Add Code","Create":"Create Room","Update":"Update Room","RoomEmail":"Room Email Address","AddRoomEmail":"Add Room Email Address","Roomname":"Room Name","AddRoomName":"Add Room Name","noSelect":"----  Not Select  ----","RoomCapacity":"Room Capacity","AddCapacity":"Add Room Capacity","BGImage":"Background Image","Timezone":"Timezone","Roomtype":"Room Type","SyncVC":"Sync VC Id","RoomImage":"Room Image","fileSize":"*File Size Limit = 10 MB","AutoCheckin":"Auto Checkin","AvailableReserve":"Available Items to Reserved","SelectAll":"Select All","ViewRoom":"View Room","Location":"Location","Facilities":"Facilities","Food":"Food & Berverage","DisplayBG":"Display Background","Profile":"Profile","Qrcode":"Room QR Code","Confirmation":"Confirmation","ModelDelete":"Do you want to delete this room ?","ModelDisable":"Do you want to disable this room ?","ModelEnable":"Do you want to enable this room ?","ModelDeleteDisable":"Do you want to delete this item ?","CreateDisable":"Create Room Disable","Start":"Start","End":"End","AllRoom":"All Room","UpdateDisable":"Update Room Disable","ViewDisable":"View Room Disable","CreateFormat":"Create Room Format","UpdateFormat":"Update Room Format","ViewFormat":"View Room Format","modelsubscribe":"Do you want to subscribe this room ?","modelUnsubscribe":"Do you want to unsubscribe this room ?","Subscribe":"Subscribe","selectRoom":"Select Room","search":"Search","AvailableReserveAmenity":"Available to Reserved Facilities","AvailableReserveFbs":"Available to Reserved Food & Berverage","isConference":"Is Conference","syncRoomPlatform":"Sync Room Platform","noRooms":"No Rooms"}

/***/ }),

/***/ 1318:
/***/ (function(module, exports) {

module.exports = {"Name":"Name","Email":"Email","Capacity":"Capacity","RoomType":"RoomType","Subject":"Subject","autoCheckIn":"Auto Checkin","SelectAll":"Select All","Yes":"Yes","No":"No","Building":"Building","Floor":"Floor","Zone":"Zone","Facilities":"Facilities","FirstName":"First Name","LastName":"Last Name","Backend":"Backend Accessible","Department":"Department","Description":"Description","Category":"Category","Start":"Start","End":"End","NameIOT":"Name","Room":"Room","Code":"Code","stringSearch":"Search Text"}

/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","BuildingList":"Building List","AddNewBuilding":"Add New","Confirmation":"Confirmation","deleteBuilding":"Do you want to delete this building ?","CreateBuilding":"Create Building","UpdateBuilding":"Update Building","Availablefor":"Available For Reserved","Facilities":"Facilities","Food":"Food & Berverage","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","FloorList":"Floor List","FloorListHead":"Floor List","CreateFloor":"Create Floor","UpdateFloor":"Update Floor","ViewFloor":"View Floor","Location":"Location","AddNewFloor":"Add New","Building":"Building","deleteFloor":"Do you want to delete this floor ?","floorNo":"No","pleaseSelect":"---- Plaese Select Location ----","ZoneList":"Zone List","ZoneListHead":"Zone List","CreateZone":"Create Zone","UpdateZone":"Update Zone","ViewZone":"View Zone","AddNewZone":"Add New","deleteZone":"Do you want to delete this zone ?","Floor":"Floor","selectBuilding":"---- Plaese Select Building ----","selectFloor":"---- Plaese Select Floor ----","noBuildingData":"No Building Data","noFloorData":"No Floor Data","noZoneData":"No Zone Data","syncBuildingPlatform":"Sync Building Platform","syncFloorPlatform":"Sync Floor Platform","syncZonePlatform":"Sync Zone Platform","code":"Code"}

/***/ }),

/***/ 1320:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Filesize":"*File Size Limit = 10 MB","UserRegis":"User Registration","CreateUser":"Create User","UpdateUser":"Update User","Users":"Users","Email":"Email","addEmail":"Add Email","Backend":"Backend Accessible","Resetpass":"Reset Password","Confirmation":"Confirmation","deleteUser":"Do you want to delete this user ?","resetPass":"Do you want to reset password for this user ?","ViewUser":"View User","UserDetail":"User Detail","PINCode":"PIN Code","RFID":"RFID","Status":"Status","TimeZone":"Time Zone","Department":"Department","Role":"Role","QRCode":"QR Code","MeetingDetail":"Meeting Detail","AutoLock":"Is Auto Lock","AvailableRooms":"Available Rooms for Reserve","AvailableRoomsRole":"Available Rooms for Reserve ( from Role )","UserName":"Username","Adduser":"Add User","Password":"Password","Addpass":"Add Password","ConfirmPass":"Confirm Password","Addsamepass":"Add Same Password","FirstName":"First Name","Addfirstname":"Add First Name","LastName":"Last Name","Addlastname":"Add Last Name","Addpincode":"Add Pin Code","Addrfid":"Add rfid","SelectStatus":"Select Status","SelectTimezone":"Select Timezone","SelectAll":"Select All","Require":"Require!!","Passatleast":"Password Has at Least 8 Character.","Passwordnotmatch.":"Password Does Not Match.","passwordNotMatchError":"Password Does Not Match.","importAD":"Import User AD","selectuser":"Please Select User","Select":"Select User","CurrentPass":"Current Password","NewPass":"New Password","passError1":"Contain at 4-50 Characters","passError2":"Contain at Least 1 Number","passError3":"Contain at Least 1 Lowercase Character (a-z)","passError4":"Contain at Least 1 Uppercase Character (A-Z)","passError5":"Contains Only 0-9a-zA-Z","NoUsers":"No Users","UserInfo":"User Information","Language":"Language","ChangePass":"Change Password","NewDepartment":"Add New","Groups":"Groups","Description":"Description","CreateDepartment":"Create Department","UpdateDepartment":"Update Department","Selected":"Selected","Add":"Add","Mobile":"Mobile","external":"User External","MobilePhone":"Mobile Phone","SelectUser":"Select User","Selectinternal":"Select User Internal","Internal":"Selected Internal","internal":"Internal","External":"External","Search":"Search","Update":"Update","UserGroup":"User in Group(s)","ViewDepartment":"View Department","deleteusergroup":"Do you want to delete this usergroup ?","specialcharactor":"Password wrong condition.","Items":"Items","Fullname":"Full Name","Platfrom":"Platfrom","Deleteitem":"Do you want to Delete this item ?","emailWrongformat":"Email Wrong Format.","Platform":"Platform","syncUserPlatform":"Sync User Platform","importUserMailSystem":"Import User Mail System","importUserExchange":"Import User Exchange","importUserGoogle":"Import User Google","employeeCode":"Employee Code","addEmployeeCode":"Add Employee Code","o365Information":"O365 Information","googleInformation":"Google Information","exchangeInformation":"Exchange Information","exchange":"Exchange","adInformation":"AD Information","integrationAD":"Integration AD","changeIntegrationAD":"Change Integration AD","userPrincipalName":"User Principal Name","syncDepartmentPlatform":"Sync Department Platform","noDepartmentData":"No Department Data"}

/***/ }),

/***/ 1321:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","AddNew":"Add New","RoleList":"Role List","UpdateRole":"Update Role","CreateRole":"Create Role","ViewRole":"View Role","Synco365":"Sync o365 Role","MaxBooking":"Max. Advanced Booking (Days)","MaxDuration":"Max. Duration Per Event (minutes)","Confirmation":"Confirmation","modelDelete":"Do you want to delete this role ?","AvailableRooms":"Available Rooms for Reserve","Require":"Require!!"}

/***/ }),

/***/ 1322:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!","ProfileList":"Profile List","CreateProfile":"Create Profile","UpdateProfile":"Update Profile","View":"View","usingprofile":"Room(s) Using This Profile","Action":"Action","Identify":"Identify","Department":"Department","Calendar":"Calendar","Order":"Order","Rules":"Rules","Norule":"No rule","ManageRule":"Manage Rule","confirm":"Confirmation","confirmmessage":"Do you want to delete this profile ?","noUse":"This profile doesn't use for any room."}

/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","BackgroundList":"Background List","Default":"Default","SetDefault":"Set Default","modelDelete":"Do you want to delete this background ?","CreateBackground":"Create Background","Updatebackground":"Update Background","Type":"Type","PleaseSelect":"--- Please Select ---","Video":"Video","Upload":"Upload","Viewbackground":"View Background","SizeHuge":"This Size Is Huge!!","filetype":"This File Type Is Not "}

/***/ }),

/***/ 1324:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","AddNewFood":"Add New","AddNewFoodList":"Add New","Require":"Require!!","modelDelete":"Do you want to delete this amenity ?","PleaseSelect":"--- Please Select ---","CreateFacility":"Create Facility","UpdateFacility":"Update Facility","FacilitiesList":"Facilities List","Amount":"Amount","ViewFacility":"View Facility","FoodCategory":"Food & Berverage Category List","modelDeleteFood":"Do you want to delete this category ?","DeleteFoodList":"Do you want to delete this food ?","CreateFood":"Create Food & Berverage Category","UpdateFood":"Update Food & Berverage Category","ViewFood":"View Food & Berverage Category","FoodList":"Food & Berverage List","Category":"Category","Price":"Price","CreateFoodList":"Create Food & Berverage","UpdateFoodList":"Update Food & Berverage","SelectCategory":"---- Plaese Select Category ----","SizeHuge":"This Size Is Huge!!","ViewFoodList":"View Food & Berverage","View":"View","Update":"Update","Delete":"Delete"}

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","Display":"Display","Devices":"Devices","License":"License","Mac":"Mac Address","Model":"Model","IP":"IP Address","Room":"Room","Status":"Status","Unregister":"Unregister","modelUnregis":"Do you want to un-register this item ?","modelDisable":"Do you want to disable this item ?","modelEnable":"Do you want to enable this item ?","IOTRegis":"IOT Registration","IOTRoom":"IOT Room Config","Items":"Items","RoomCode":"Room Code","SerialNumber":"Serial Number","modelDelete":"Do you want to delete this item ?","CreateIOT":"Create IOT Room Config","UpdateIOT":"Update IOT Room Registration","pleaseSelect":"----  Please Select  ----","selectLicense":"----  Please Select License Before ----","notSelect":"----  Not Select  ----","ViewIOT":"View IOT Registration"}

/***/ }),

/***/ 1326:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","EventType":"Event Type List","modelDelete":"Do you want to delete this event ?","CreateType":"Create Event Type","UpdateType":"Update Event Type","ViewType":"View Event Type","AllEvents":"All Events","Subject":"Subject & Organizer","Room":"Room","DateTime":"Date Time","Status":"Status","Organizer":"Organizer","Start":"Start","End":"End","Check-in":"Checkin","Check-out":"Checkout","modelCheckin":"Do you want to Checkin this events ?","modelCheckout":"Do you want to Checkout this events ?","allDay":"All day","resendPin":"Resend PIN","resendPinSuccess":"Resend PIN success.","resendPinFail":"Resend PIN fail.","modelResendPin":"Do you want to resend PIN ?","pin":"Event PIN"}

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","OrdersFood":"Orders Food","Start":"Start","End":"End","Subject":"Subject","StartTime":"Start Time","EndTime":"End Time","Status":"Status","OrdersFac":"Orders Facilities","AllEvent":"Create Order","Foods":"Foods & Beverage","Amenities":"Amenities","DateTime":"Date Time","Room":"Room","CreateAmenity":"Create Order Facilities","CreateFood":"Create Order Food","pcs.":"pcs.","Amenity":"Amenity","FoodEmpty":"Food's Empty","Remark":"Remark","updateFbs":"Update Order Food","updateAmenity":"Update Order Facilities","viewFbs":"View Order Food","viewAmenity":"View Order Facilities"}

/***/ }),

/***/ 1328:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","SettingInfo":"Global Setting","UpdateSetting":"Edit","GlobalSetting":"Global Setting","StartTime":"Start Working Time","EndTime":"End Working Time","MinOrder":"Min. Order Duration in Advance (hours)","SlotDuration":"Slot Duration (mins)","TokenExpire":"Token Expire (mins)","AdminEmail":"Administrator Email","AdminTel":"Administrator Tel","AdminID":"Mailbox Service ID","admin":"Administrator Email & Contact","AdvancedBooking":"Advanced Booking (days)","MaxBooking":"Maximum Booking Time (mins)","Check-in":"Checkin Time (mins)","ReleaseTime":"Release Time (mins)","IoTbefore":"IoT - Light on Before Event Starts (mins)","IoTafter":"IoT - Light off After Event Ends (mins)","Checkin":"Checkin Notification Enabled","HousekeeperAdmin":"Housekeeper Admin","HousekeeperName":"Housekeeper Name","HousekeeperEmail":"Housekeeper Email","HousekeeperTel":"Housekeeper Tel","LockedUser":"Locked User","Investigation":"Investigation Period (days)","Suspended":"Suspended Period (days)","Adsence":"No. of Absence (times)","SigninPermission":"Signin Permission","SigninUpsert":"Signin And Upsert User","AllowSignin":"Allow Signin Domain","Import":"Import","ImportO365":"Import User From O365","ImportExcel":"Import User From Excel","ImportAD":"Import User From AD","ImportUserSystem":"Import User Mail System","LightDimmer":"Light Dimmer (Display)","EnabledLight":"Enabled Light Dimmer","Start":"Start Time","End":"End Time","EventPIN":"Event PIN","EnabledEventPIN":"Enabled Event PIN","Concurrent":"Concurrent","EnabledCocurrent":"Enabled Concurrent","ActiveDirectory":"Active Directory","EnabledADLogin":"Enabled AD Login","IP":"IP","Port":"Port","User":"User","BaseDN":"Base DN","Domain":"Domain","Reminder":"Reminder","EnabledReminder":"Enabled Sending Reminder","AdvancedReminder":"Advanced Reminder (hours)","TMS":"TMS Information","EnabledTMS":"Enabled TMS Integration","Server":"Server","Password":"Password","UserPrefix":"User Prefix","ConferenceType":"Conference Type","CMR":"CMR Information","EnabledCMR":"Enabled CMR Information","BOT":"BOT Information","EnabledBOT":"Enabled BOT Integration","Webhook":"Web Hook","TestAD":"Test AD","SelectConference":"---- Plaese Select Conference Type ---","AutomaticCall":"Automatic Call Launch","OneButton":"One Button To Push","ManualCall":"Manual Call Launch","NoConnect":"No Connect","ReservationOnly":"Reservation Only","Default":"Default","TestTMS":"Test TMS","TestCMR":"Test CMR","TestBOT":"Test BOT","TestSuccessful":"Test Connection Successful","TestFailure":"Test Connection Failure","ChangeIntegration":"Change Integration Config","Integration":"Integration","Backend":"Backend","ClientId":"Client Id","ClientSecret":"Client Secret","TenantId":"Tenant Id","MobileURL":"Mobile Redirect URL","WebURL":"Web Redirect URL","Authen":"Authen","Yoursite":"Your Site Doesn't Set Integration.","SettingsUser":"Settings User","IntegrationO365":"Integration  o365","Registerapp":"Register Your Application","Pleaseregister":"Please Register Your Application With Global Administrator Via","AppPortal":"Application Registration Portal","YourClientId":"Your Client Id","AdminConsent":"Admin Consent","AllowApp":"Allow This App to Integration","Connect":"Connect","ConnectO365App":"Connect Your o365 App Integration to Roomminister","UseFrontend":"Use Frontend Integrations","Term":"Term & Conditions","TermTH":"Thai","TermEN":"English","EditTerm":"Edit Term & Conditions","Faq":"FAQ","FaqTH":"Thai","FaqEN":"English","EditFaq":"Edit FAQ","ContactUs":"Contact Us","ContactUsTH":"Thai","ContactUsEN":"English","EditContactUs":"Edit Contact Us","testConnection":"Test Connection","syncRoleAndPolicy":"Sync Role And Policy","isSyncRoleAndPolicy":"Enabled Sync Role And Policy","ewsUsername":"Username","ewsPassword":"Password","ewsHost":"Host","ewsAuthType":"Auth Type","defaultRoleId":"Default Role","android":{"name":"Android","packageName":"Package Name","signatureHash":"Signature Hash","authorizationUserAgent":"Authorization User Agent","redirectUri":"Redirect Uri","authorities":"Authorities","type":"Type","audience":"Audience","tenantId":"Tenant Id"},"ios":{"name":"iOS","bundleID":"Bundle ID","kClientID":"kClientID","kRedirectUri":"kRedirectUri","kAuthority":"kAuthority"}}

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","SummaryRoom":"Summary Room Report","Start":"Start","End":"End","Building":"Building","Floor":"Floor","Zone":"Zone","Room":"Room","ExportToExcel":"Export To Excel","SummaryUser":"Summary User Report","User":"User","SummaryFood":"Summary Food Report","SummaryDelete":"Summary Delete Event","SummaryFacility":"Summary Facility Report","ReserveRoom":"Reserve Not Use By Room Report","ReserveUser":"Reserve Not Use By User Report","DetailRoom":"Detail Room Report","NoSelect":"--- No Select ---","selectBuilding":"Please Select Building","selectFloor":"Please Select Floor","DetailUser":"Detail User Report","FoodDetail":"Food Detail By Event Report","FacilityDetail":"Facility Detail By Event Report","userAttendance":"Meeting Attendance by Event"}

/***/ }),

/***/ 1330:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","Date":"Date","Type":"Type","Room":"Room","Officehour":"Office Hour","Allday":"All Day","Search":"Search","Available":"*Available, Reserve are Calculated from Now to End of Day (In the Future)","NoUse":"*No Use, Occupied, Waiting are Calculated from Start of Day to Now (In the Past)","StatusSummary":"Status Summary","RoomStatus":"Room Status","FilterDate":"Filter Date and Time","Filter":"Filter","StartAndEnd":"Start And End (Date , Time)","startsearch":"* Start Search Hour","from":"from ","Booking":"Booking Transactions","Confirm":"Confirm Arrival Rate","Subject":"Subject","StartDate":"Start Date and Time","EndDate":"End Date and Time","Thisperiod":"This Period Doesn't Have Any Event","autorelease":"This Period Doesn't Have Event For Check in or Auto Release","Reserve":"*Reserve is Number of Times Reserved","Succescheckedin":"*Success is Number of Times Room has been Successfully Checkedin","Auto-release":"*Auto Release is Number of Times Room has been Auto Released","RealTime":"Real Time Room Status","AutoCheckIn":"Auto CheckIn","Location":"Location","Selectperiod":"Select Period of Time","Maximum":"Maximum Number of","TopUser":"Top User by Reserved: by ","TopRoom":"Top Room by Reserved: by ","day":"Day","advanceSearchGuideLine":" * Blank or 0 Will List All Of ","advanceSearchGuideLineTitle":" for Display","graphBookingTitle":"Amount of Booking(s)"}

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

module.exports = {"require":"This field is required"}

/***/ }),

/***/ 1332:
/***/ (function(module, exports) {

module.exports = {"confirmDeleteOrder":"Confirm to delete order.","fillInreason":"Please fill in your reason. "}

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

module.exports = {"404":"Page Not Found","90000000":"Image is Over Than 10 MB","systemMessage":"System Message","code":"Code","message":"Message","00000000":"Something went wrong. Please try again later.","00000001":"UnAuthorized to Access","00000002":"Token Has expired.","00000003":"Model is Not Found","00000004":"Failed to Find Data List","00000005":"ID Not Found","00000006":"Failed to Find Data","00000007":"Failed to Create Data","00000008":"Failed to Update Data","00000009":"Failed to Update Row of Data","00000010":"Failed to Delete Data","00000011":"Failed to Delete Row of Data","00000012":"Failed to Find Token in System","00000013":"Token Has expired. This Token's logout for a few Time.","00000014":"Token Has expired.","00000101":"Failed to Create location.","00000102":"Failed to Update location","00000201":"SID Create.","00000202":"SID Verify.","00000301":"Failed to Insert Log.","00000401":"Failed to Insert Log.","00000501":"Failed to Find Event.  ","00000502":"Failed to Find Event. ","00000503":"Failed to Checkin.","00000504":"Failed to Find Event.","00000505":"Failed to Checkin.","00000506":"Failed to Find Checkin Information.","00000507":"Event Time's Up.","00000601":"Failed to Find All Room.","00000602":"Failed to Find Room Information.","00000603":"Failed to Create Event.","00000604":"Failed to Update Event.","00000605":"Failed to Cancel Event.","00000701":"Failed to Create Food & Berverage Order.","00000702":"Failed to Update Food & Berverage Order.","00000703":"Failed to Delete Food & Berverage Order.","00000704":"Failed to Find Food & Berverage Order List.","00000705":"Failed to Find Food & Berverage Order.","00000801":"Failed to Find Food & Berverage Order Category.","00000802":"Failed to Find Food & Berverage Order Category List.","00000803":"Failed to Delete Food & Berverage Order Category.","00000804":"Failed to Create Food & Berverage Order Category.","00000805":"Failed to Update Food & Berverage Order Category.","00000806":"Failed to Find Food & Berverage Order Category List.","00000901":"Failed to Create Building.","00000902":"Failed to Update Building.","00000903":"Failed to Delete Building.","00000904":"Failed to Find Building List.","00000905":"Failed to Find Building.","00000906":"Failed to Create Building.; This Building's Name is Already Been Used.","00000907":"Failed to Update Building.; This Building's Name is Already Been Used","00000908":"Failed to Delete Building. This Building's Usage by Some Floor.","00001001":"o365: Access Denied.","00001002":"o365:  Failed to Get Token.","00001003":"o365:  Failed to Get Refresh Token.","00001004":"o365:  Failed to Update/Insert Tenant.","00001005":"o365:  Failed to Get Service Token.","00001006":"o365:  Failed to Get User Token.","00001007":"o365:  Failed to Get Integration Info.","00001008":"o365:  Failed to Get Event by IcalUId.","00001009":"o365:  Failed to Get Room in Event.","00001010":"o365:  Failed to Get Events by Floor.","00001011":"o365:  Failed to Get Events.","00001012":"365:  Failed to Get Frontend Integration Info.","00001101":"Failed to Delete Order.","00001102":"Failed to Find Order Facilities Event.","00001103":"Failed to Find Order Facilities Room.","00001104":"Order Facilities is Empty.","00001105":"Failed to Create Facilities Order Because Event Has Been Cancelled or Ended.","00001106":"Failed to Create Facilities Order","00001107":"Failed to Update Facilities Order","00001108":"Failed to Update Facilities Order.","00001109":"Failed to Update Facilities Order.","00001110":"Failed to Update Facilities Order.","00001111":"Failed to Cancel Facilities Order.","00001112":"Failed to Delete Facilities Order.","00001113":"Failed to Get Facilities Order.","00001114":"Failed to Cancel Facilities Order.","00001115":"Failed to Get Facilities Order.","00001116":"Failed to Get Facilities Order.","00001117":"Failed to Get Facilities Order.","00001118":"Failed to Get Facilities Order.","00001119":"Failed to Get Food & Berverage.","00001120":"Failed to Get Food & Berverage.","00001121":"Failed to Get Food & Berverage.","00001122":"Failed to Create Food & Berverage Because Event Has Been Cancelled or Ended.","00001123":"Failed to Update Food & Berverage.","00001124":"Failed to Create Food & Berverage.","00001125":"Failed to Update Food & Berverage.","00001126":"Failed to Update Food & Berverage.","00001127":"Failed to Update Food & Berverage.","00001128":"Failed to Cancel Food & Berverage.","00001129":"Failed to Delete Food & Berverage.","00001130":"Failed to Get Food & Berverage.","00001131":"Failed to Get Food & Berverage.","00001132":"Failed to Get Food & Berverage.","00001133":"Failed to Get Food & Berverage.","00001134":"Failed to Get Food & Berverage.","00001135":"Failed to Find Food & Berverage.","00001136":"Failed to Find Food & Berverage.","00001201":"Failed to Create Policy.","00001202":"Failed to Set Policy.","00001301":"Failed to Create Profile.","00001302":"Failed to Update Profile.","00001303":"Failed to Delete Profile.","00001304":"Failed to Find Profile.","00001305":"Failed to Create Profile.; The Specified Profile's Name is Already Been Used.","00001306":"Failed to Update Profile.; The Specified Profile's Name is Already Been Used.","00001401":"Failed to Create Floor.","00001402":"Failed to Update Floor.","00001403":"Failed to Delete Floor.","00001404":"Failed to Get Floor.","00001405":"Failed to Get Floor by Id.","00001406":"Failed to Create Floor.; The Specified Floor's Name is Already Been Used is Same Building.","00001407":"Failed to Update Floor.; The Specified Floor's Name is Already Been Used is Same Building.","00001408":"Failed to Delete Floor.  This Floor's Usage by Some Zone.","00001501":"Failed to Create Zone.","00001502":"Failed to Update Zone.","00001503":"Failed to Delete Zone.","00001504":"Failed to Get All Zone.","00001505":"Failed to Get Zone Information.","00001506":"Failed to Create Zone.; The Specitied Zone's Name is Already Been Used in Same Floor","00001507":"Failed to Update Zone.; The Specitied Zone's Name is Already Been Used in Same Floor","00001601":"Failed to Create Room.; The Specified Email Address Has Already Been Used Before.","00001602":"Failed to Create Room.","00001603":"Failed to Update Room.","00001604":"Failed to Get Room.","00001605":"Failed to Get Room Capacity.","00001606":"Failed to Get All Room.","00001607":"Failed to Delete Room.","00001608":"Failed to Delete Subscribed Room.","00001609":"Failed to Delete Room Info.","00001610":"Failed to Get Room Info.","00001611":"Failed to Get Room Info.","00001612":"Failed to Create Room.; The Specified Room's Name is Already Been Used.","00001613":"Failed to Update Room.; The Specified Room's Name is Already Been Used.","00001614":"Failed to Check Can Booking Room.","00001701":"Failed to Create Room Disable.","00001702":"Failed to Update Room Disable.","00001703":"Failed to Delete Room Info.","00001704":"Failed to Delete Room Info.","00001705":"Failed to Get Room Disable Info.","00001706":"Failed to Get Room Status.","00001707":"Failed to Get Room.","00001901":"Failed to Update Setting. ","00001902":"Failed to Get general Setting.","00001903":"Failed to Get All Setting. ","00001904":"Failed to Update Setting. ","00001905":"Failed to Get All Information.","00001906":"Failed to Create User Group.","00002101":"Failed to Verify User; User Not Found.","00002102":"Failed to Verify User; Wrong Password.","00002103":"Failed to Create User; The Specified Email Address Has Already Been Used Before.","00002104":"User UnAuthorized Action.","00002105":"User Invalid Credentials.","00002106":"Failed to Create User.","00002107":"Failed to Get User Token.","00002108":"Failed to Get User Token Info.","00002109":"Failed to Find User by Email.","00002110":"Verify Failed.","00002111":"Failed to Update User.","00002112":"Failed to Delete User.","00002113":"Password does Not Match","00002114":"Password does Not Match","00002115":"Password does Not Match","00002116":"Failed to Change User Password.","00002117":"Failed to Find User Token.","00002118":"Failed to Refresh User Token.","00002119":"Failed to Find User Group.","00002120":"Failed to Get User Company.","00002121":"User Company Empty.","00002122":"User Profile Empty.","00002123":"Verify Failed.","00002124":"Failed to Update User Token.","00002125":"User Service Token Empty.","00002126":"Failed to Remove User Token.","00002127":"Failed to Generate User Token.","00002128":"Failed to Sync User AD.","00002129":"Authenticate User AD Failed.","00002130":"Failed to Get User Setting AD.","00002131":"Failed to Get All User.","00002132":"User Not Integration.","00002133":"Failed to Create User; The Specified PIN Code Has Already Been Used Before.","00002134":"Failed to Add User Favorite Room.","00002135":"Failed to Delete User Favorite Room.","00002136":"Failed to Get User QR Code","00002137":"Failed to Update User; The Specified PIN Code Has Already Been Used Before.","00002138":"Failed to ReSet Password.","00002139":"Failed to Request Forgot Password.","00002140":"Request ReSet Password Fail. ","00002141":"Failed to Find User by ReSet Password Key.","00002142":"Failed to Find User Email. (User Never Login)","00002143":"Verify Failed. Already Login for Other Device.","00002144":"Failed to Refresh Token.","00002145":"Access Denied, Please Contact Administrator","00002146":"Failed to Get User Integration Data.","00002147":"Access Denied, User Inactive.","00002148":"Fail to Make Data.","00002149":"Fail to Re-Token.","00002150":"Fail to Find User.","00002201":"Failed to Create User Group.","00002202":"Failed to Update User Group ","00002203":"Failed to Delete User Group.","00002204":"Failed to Get User Group; User Group Data Empty.","00002205":"Failed to Find User Group.","00002206":"Failed to Find All User Group.","00002207":"Failed to Get User Group With Reserve.","00002208":"Failed to Create User Group. This Name's Already","00002209":"Failed to Find User Group.","00002210":"Failed to Find User Group by User Id.","00002301":"Failed to Create Image.","00002302":"Failed to Update Image.","00002401":"Failed to Create Background.","00002402":"Failed to Update Background.","00002403":"Failed to Delete Background.","00002404":"Failed to Set Default Background.","00002405":"Failed to Find All Background.","00002406":"Failed to Find Background.","00002407":"Failed to Create Background.; The Background's Name is Already Been Used","00002408":"Failed to Update Background.; The Background's Name is Already Been Used","00002501":"Failed to Find IoT Device.","00002502":"Failed to Create IoT Device.","00002503":"Failed to Update IoT Device.","00002504":"Failed to Get All IoT Device.","00002505":"Failed to Get IoT Device by Id.","00002506":"Failed to Change IoT Disable Status.","00002507":"Failed to Get RoomInfo by IoT MAC.","00002508":"Failed to Define Room IoT.","00002509":"Failed to Check IOT Config.","00002510":"Failed to Delete IOT Config from Profile Center.","00002511":"Failed to Find IoT Device from Profile Center.","00002512":"Failed to Delete IOT.","00002513":"Failed to UnRegister IOT.","00002514":"Failed to Find IOT.","00002601":"Failed to Create IoT Information.","00002602":"Failed to Get IoT Information.","00002701":"Failed to Get All Seat.","00002702":"Failed to Create Seat.","00002703":"Failed to Get Zone Information.","00002704":"Failed to Get Seat.","00002705":"Failed to Update Seat.","00002706":"Failed to Get All Favorite Seat.","00002707":"Failed to Get free Seat.","00002708":"Failed to Get Seat.","00002709":"Failed to Create Seat in Zone.","00002710":"Failed to Find Seat Zone","00002711":"Failed to Get Seat.","00002801":"Failed to Get All Disable Seat.","00002802":"Failed to Create Disable Seat.","00002803":"Failed to Get Zone Information.","00002804":"Failed to Get Disable Seat.","00002805":"Failed to Update Disable Seat.","00002806":"Failed to Get Disable Seat.","00002901":"Failed to Get Event Seat by date.","00002902":"Failed to Add Event Seat Action.","00002903":"Failed to Checkin Event Seat.","00002904":"Failed to Find Event Seat.","00002905":"This Event Seat  is Already Checkin.","00002906":"This Event Seat is Already Cancel.","00002907":"Please Checkin Event Seat  Before Checkout.","00002908":"Time Over, This Event Seat Can't Checkout.","00002909":"Failed to Update Event Seat.","00002910":"Failed to Get Event Seat by Group.","00002911":"Failed to Delete Event Seat.","00003001":"Failed to Create Event Seat Group.","00003002":"Failed to Update Event Seat Group.","00003003":"Failed to Cancel Event Seat Group.","00003004":"Failed to Get Event Seat Group by Id.","00003005":"Failed to Create Event Seat Group. Can't Booking Past Time.","00003006":"Failed to Create Event Seat Group. Can't Booking Same Time.","00003007":"Failed to Create Event Seat Group. Time Over lab.","00003101":"Failed to Register Display.","00003102":"Failed to Get Token Display.","00003103":"Failed to Get Status Display.","00003104":"Failed to Check Status Display.","00003105":"Model Not Match.","00003106":"License Type Not Match.","00003107":"Display Not Register.","00003108":"Failed to Refresh Token.","00003109":"Room Not Found.","00003110":"Failed to Delete Display from Profile Center.","00003111":"Failed to Find Display from Profile Center.","00003112":"Failed to Disable Display from Profile Center.","00003113":"Failed to Find Display .","00003201":"Incorrect parameters.","00003202":"Data Duplicated.","00003203":"Failed to Create IOT Room Config.","00003204":"IOT Controller Over limit.","00003205":"Failed to Delete IOT Room Config.","00003206":"Failed to Delete IOT Room Config from Profile Center.","00003207":"Failed to Find IOT Room Config from Profile Center.","00003301":"Failed to Create Concurrent","00003302":"Failed to Create ios Concurrent","00003303":"Failed to Create androId Concurrent","00003304":"Failed to Refresh Token","00003305":"Failed to Create web Concurrent","00003306":"Failed to auto Refresh Token","00003307":"Failed to Delete Token","00003308":"Failed to Find Token","00003401":"Failed to Find All Role","00003402":"Failed to Create Role","00003403":"Failed to Create Role, This Code's Already in system.","00003404":"Failed to Find Role","00003405":"Failed to Update Role","00003406":"Failed to Delete Role","00003407":"Failed to Delete Role, Some User Use This Role.","00003408":"Failed to Find Role.","00003501":"Failed to Create.","00003502":"Failed to Update.","00003503":"Failed to Delete.","00003504":"Failed to Find by Id.","00003505":"Failed to Find All.","00030000":"Failed to Access Calendar (Access Denied)","00030002":"Failed to Find Calendar Event ","00030003":"Failed to Find Calendar ","00030004":"Failed to Create Calendar Event.","00030005":"Failed to Authorize Calendar Action.","00030006":"Failed to Get Calendar Events.","00030007":"Failed to Map Calendar Event Data.","00030008":"Failed to Get Calendar Event Next.","00030009":"Failed to Get Calendar Event.","00030010":"Failed to Get Calendar Events.","00030011":"Failed to Get Calendar Event Day.","00030012":"Failed to Meet Now Calendar.","00030013":"Failed to Update Calendar Event.","00030014":"Failed to Extend Calendar Event.","00030015":"Failed to Close Calendar Event.","00030016":"Failed to Delete Calendar Event.","00030017":"Failed to Get Calendar Slot.","00030018":"Failed to Watch Calendar Core.","00030019":"Failed to Clean Calendar Slot.","00030020":"Failed to Map Calendar Slot.","00030021":"Failed to Match Calendar Slot.","00030022":"Failed to Make Calendar Slot.","00030023":"Failed to Delete All Event in Calendar.","00030024":"Failed to Get Token Calendar.","00030100":"Failed to Search People.","00030101":"Failed to Get People User Info.","00030102":"Failed to Get People User Photo.","00030103":"Failed to Get All People Users Info.","00030104":"Failed to Get People Users in Organization.","00030200":"Failed to Find Room.","00030201":"Failed to Get Room Status.","00040201":"Failed to Create Background.","00040202":"Failed to Update Background.","00040203":"Failed to Delete Background.","00040204":"Failed to Set Default Background.","00040205":"Failed to Find All Background.","00040206":"Failed to Find Background.","00040301":"Failed to Create Building.","00040302":"Failed to Update Building.","00040303":"Failed to Delete Building.","00040304":"Failed to Get All Building.","00040305":"Failed to Find Building.","00040401":"Failed to Checkin Action.","00040402":"Failed to Authorize Checkin Action.","00040403":"Failed to Find Checkin Action.","00040404":"Failed to Create Checkin Action.","00040601":"Failed to Create Food & Berverage","00040602":"Failed to Update Food & Berverage","00040603":"Failed to Delete Food & Berverage","00040604":"Failed to Find All Food & Berverage","00040605":"Failed to Find Food & Berverage","00040701":"Failed to Create Facilities.","00040702":"Failed to Update Facilities.","00040703":"Failed to Delete Facilities.","00040704":"Failed to Find All Facilities.","00040705":"Failed to Find Facilities.","00040706":"Failed to Create Facilities.; The Specified Facilities's Name is Already Been Used","00040707":"Failed to Update Facilities.; The Specified Facilities's Name is Already Been Used","00040802":"Failed to Create Food & Berverage Category ","00040803":"Failed to Delete Food & Berverage Category ","00040804":"Failed to Get Food & Berverage Category  ","00040901":"Failed to Create Floor.","00040902":"Failed to Update Floor.","00040903":"Failed to Delete Floor.","00040904":"Failed to Get All Floor.","00041001":"Failed to Find Room Info.","00041002":"Failed to Update Room Info.","00041003":"Failed to Delete Room Info Subscription.","00041004":"Failed to Delete Room Info.","00041104":"Failed to Authorize User Action.","00041105":"User Invalid Credentials.","00041106":"Failed to Verify User.","00041107":"Failed to Find User Group Id.","00041108":"Failed to Verify or Find User Company.","00041109":"Failed to Find User Company.","00041110":"Failed to Find or Verify User Profile.","00041111":"Failed to Verify User Profile.","00041201":"Failed to Create User Group.","00041202":"Failed to Update User Group ","00041203":"Failed to Delete User Group.","00041301":"Failed to Create Zone.","00041302":"Failed to Update Zone.","00041303":"Failed to Delete Zone.","00041304":"Failed to Get All Zone.","00020000":"Failed to Access o365 Calendar.","00020001":"Failed to Create o365 Calendar Room.","00020002":"Failed to Find o365 Calendar Event.","00020003":"Failed to Get o365 Calendar Event.","00020004":"Failed to Get o365 Calendar Event by iCalUId. ","00020005":"Failed to Get o365 Calendar Events.","00020006":"Failed to Get o365 Calendar Event Cross of Day.","00020007":"Failed to Find o365 Calendar Event Now.","00020008":"Failed to Get o365 Calendar All Events Cross of Day.","00020009":"Failed to Get o365 Calendar Event Now.","00020010":"Failed to o365 Calendar Next Event.","00020011":"Failed to Get o365 Calendar Next Events.","00020012":"Failed to Get o365 Calendar current Day Events.","00020013":"Failed to Get o365 Calendar Event Day.","00020014":"Failed to Get o365 Calendar Event Day.","00020015":"Failed to Get o365 Calendar Event Between Period.","00020016":"Failed to Get o365 Calendar Event Unique.","00020017":"Failed to Create o365 Calendar Event.","00020018":"Failed to Find o365 Calendar Get Available Slot for Booking.","00020019":"Failed to Create o365 Calendar Meet Now ; Room Busy.","00020020":"Failed to Create o365 Calendar Meet Now.","00020021":"Failed to Meet Now o365 Calendar.","00020022":"Failed to Update o365 Calendar Event.","00020023":"Failed to Extend o365 Calendar Event.","00020024":"Failed to Delete o365 Calendar Event.","00020025":"Failed to Get o365 Calendar Room Status.","00020026":"Failed to Accept o365 Calendar Event.","00020027":"Failed to Tentative o365 Calendar Event.","00020028":"Failed to Decline o365 Calendar Event.","00020029":"Failed to Get o365 Calendar Slot Event.","00020030":"Failed to Get o365 Calendar Slot Between Date.","00020031":"Failed to Verify o365 Calendar SID.","00020032":"Failed to Check out o365 Calendar Event.","00020033":"Failed to Clean o365 Calendar Slot.","00020034":"Failed to Clean o365 Calendar Start Event Before Start Working Time.","00020035":"Failed to Get o365 Calendar Slot Date.","00020036":"Failed to Watch o365 Calendar Core.","00020037":"Failed to load o365 Calendar general Core.","00020038":"Failed to Match o365 Calendar Event.","00020039":"Failed to Make Empty o365 Calendar Slot.","00020040":"Failed to Map o365 Calendar Slot.","00020041":"Failed to Make o365 Calendar.","00020042":"Failed to Match o365 Calendar Slot.","00020043":"Failed to Get o365 Calendar Flightboard Events.","00020044":"Failed to Get o365 Calendar Event Report.","00020045":"Failed to Send o365 Calendar Socket.","00020046":"Failed to Create o365 Calendar Socket.","00020047":"Failed to Close o365 Calendar Event Before Start Event ","00020048":"Action log is Not Found With Your Criteria","00020049":"Failed to Get o365 Calendar Event.","00020050":"Failed to Create o365 Calendar; Room Busy.","00020051":"Failed to Send Mail.","00020052":"The Room you are trying to book Has no VC Available. Please book again.","00020053":"Event Time's up.","00020101":"Failed to Find o365 Meeting.","00020102":"Failed to suggest o365 Meeting.","00020103":"Failed to Find o365 Meeting Empty Room.","00020104":"Failed to Find o365 Meeting Result.","00020105":"Failed to Find o365 Meeting All Events in Day.","00020106":"Failed to Match o365 Meeting Event.","00020107":"Failed to Find o365 Meeting Suggestion.","00020201":"Failed to Get o365 Order by Kitchen.","00020202":"Failed to Get o365 Order Event ","00020203":"Failed to Get o365 Order.","00020301":"Failed to Get o365 People.","00020302":"Failed to Search o365 People.","00020303":"Failed to Get o365 People User Information.","00020304":"Failed to Get o365 People User Image.","00020305":"Failed to Get o365 People User full Information.","00020306":"Failed to Get o365 People Users in Organization.","00020307":"o365 People User Not Integration.","00020401":"Failed to Find o365 Room.","00020402":"Failed to Find o365 Room List.","00020403":"Failed to Get o365 Room Name.","00020404":"Failed to Get o365 Room Information.","00020405":"Failed to Find o365 Room Service.","00020406":"Failed to Find o365 Room Service by AdministratorId.","00020501":"Failed to Find o365 Room List.","00050001":"Failed to Create o365 Noti","00050002":"Failed to Delete o365 Noti","00050003":"Failed to Delete o365 Noti","00050004":"Failed to Create o365 Noti (Can't insert)","00060001":"Failed to Find Exchange Room.","00060002":"Failed to Find Exchange Room List.","00060003":"Failed to Find Exchange People Service.","00060004":"Failed to Create Exchange Calendar Event.","00060005":"Failed to Find Exchange Calendar Event.","00060006":"Failed to Find Exchange Calendar Event.","00060007":"Failed to Find Exchange Calendar All Event.","00060008":"Failed to Update Exchange Calendar Event.","00060009":"Failed to Delete Exchange Calendar Event.","00060010":"Failed to Accept Exchange Calendar Event.","00060011":"Failed to Tentative Exchange Calendar Event.","00060012":"Failed to Decline Exchange Calendar Event.","00060013":"Failed to Find Exchange Subscription.","00060014":"Failed to Find Exchange All Subscriptions.","00060015":"Failed to Create Exchange Subscription.","00060016":"Failed to Delete Exchange Subscription.","00060017":"Failed to Delete Exchange Subscription.","00060018":"Failed to Extend Exchange Subscription.","00060019":"Failed to Unsubscribe Exchange Subscription.","00060020":"Failed to Integrate Exchange People.","00060021":"Failed to Map Exchange Calendar Email.","00060022":"Failed to Find Exchange Calendar Event.","00070001":"Failed to Find o365 Room.","00070002":"Failed to Find o365 People Service.","00070003":"Failed to Find o365 Calendar All Events.","00070004":"Failed to Map o365 Calendar Data.","00070005":"Failed to Request o365 Calendar batching Next Event.","00070006":"Failed to Find o365 Calendar Event.","00070007":"Failed to Find o365 Calendar Event.","00070008":"Failed to Create o365 Calendar Event.","00070009":"Failed to Update o365 Calendar Event.","00070010":"Failed to Delete o365 Calendar Event.","00070011":"Failed to Accept o365 Calendar Event.","00070012":"Failed to Tentative o365 Calendar Event.","00070013":"Failed to Decline o365 Calendar Event.","00070014":"Failed to Find o365 Subscription.","00070015":"Failed to Find o365 All Subscription.","00070016":"Failed to Create o365 Subscription.","00070017":"Failed to Delete o365 Subscription.","00070018":"Failed to Delete o365 Subscription.","00070019":"Failed to Get o365 System Token.","00070020":"Failed to Unsubscribe o365 Subscription.","00070021":"Failed to Extend o365 Subscription.","00070022":"Failed to Integrate o365 Subscription.","00070023":"Failed to Get o365 System Token Data.","00070024":"Failed to Get o365 System Token Data.","00070025":"Failed to Upsert o365 User","00070026":"Failed to Get o365 User Base Model","00070027":"Failed to Send o365 mail","00080001":"Failed to Find Common Calendar Event.","00080002":"Failed to Find Common Calendar Event.","00080003":"Failed to Find Common Calendar All Event.","00080004":"Failed to Create Common Calendar Event.","00080005":"Failed to Get Common Room Service.","00080006":"Failed to Find Common People Service.","00080007":"Failed to Update Common Calendar Event.","00080008":"Failed to Delete Common Calendar Event.","00080009":"Failed to Accept Common Calendar Event.","00080010":"Failed to Tentative Common Calendar Event.","00080011":"Failed to Decline Common Calendar Event.","00080012":"Failed to Find Common Subscription.","00080013":"Failed to Find All Common Subscription.","00080014":"Failed to Create Common Subscription.","00080015":"Failed to Delete Common Subscription.","00080016":"Failed to Delete Common Subscription.","00080017":"Failed to Get Common System Token.","00080018":"Failed to Get Common System Token Data.","00080019":"Failed to Get Common System Token Data.","00080020":"Failed to Get Common System Token Data.","00080021":"Failed to Extend Common Subscription.","00080022":"Failed to Integrate Common People.","00080023":"Failed to Send Mail.","00090001":"Failed to Find Google Room.","00090002":"Failed to Find Google People.","00090003":"Failed to Find Google Calendar Event.","00090004":"Failed to Find Google Calendar Event.","00090005":"Failed to Find Google Calendar All Event.","00090006":"Failed to Create Google Calendar Event.","00090007":"Failed to convert Google Calendar Event format.","00090008":"Failed to Update Google Calendar Event.","00090009":"Failed to Delete Google Calendar Event.","00090010":"Failed to Find Google Subscription.","00090011":"Failed to Find All Google Subscription.","00090012":"Failed to Create Google Subscription.","00090013":"Failed to Delete Google Subscription.","00090014":"Failed to Delete Google Subscription.","00090015":"Failed to Unsubscribe Google Subscription.","00090016":"Failed to Extend Google Subscription.","00090017":"Failed to Accept Google Calendar Event.","00090018":"Failed to Tentative Google Calendar Event.","00090019":"Failed to Decline Google Calendar Event.","00090020":"Failed to Integrate Google People.","00090021":"Failed to Create Google Calendar Recurrence Weekly Event.","00090022":"Failed to Create Google Calendar Recurrence Monthly Event.","00090023":"Failed to Get Common System Token.","00090024":"Failed to Get Common System Token Data.","00090025":"Failed to Get Common System Token Data.","00090026":"Failed to Get User by Email","00100000":"Failed to Get All Hot Seat","00100002":"Failed to Get History Hot Seat","00200000":"Get Re-Set Password Content Fail.","00200001":"Get Forgot Password Content Fail.","00200002":"Get Event PIN Content Fail.","00110000":"Create Conference Fail","00110001":"Update Conference Fail","00110002":"Get Conference by Id Fail","00110003":"Find Conference Fail","00110004":"End Conference Fail","00110005":"Delete Conference Fail","00110006":"Find With Regular Fail"}

/***/ }),

/***/ 1334:
/***/ (function(module, exports) {

module.exports = {"information":"Information","mailService":"Mail for Service","google":"Google Integration","exchange":"Exchange Integration","noIntegration":"Your site doesn't set integration.","integrate":"Integration","changeConfig":"Change Config"}

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

module.exports = {"account":"เข้าสู่ระบบ","login":"เข้าสู่ระบบ","o365":"เข้าสู่ระบบด้วย O365","google":"เข้าสู่ระบบด้วย Google","exchange":"เข้าสู่ระบบด้วย Exchange","local":"เข้าสู่ระบบด้วย Local","remember":"จำฉันไว้ในระบบ","email":"อีเมล","password":"รหัสผ่าน","error":"กรุณากรอกข้อมูล","emailerror":"กรุณากรอกอีเมล","OR":"หรือ"}

/***/ }),

/***/ 1336:
/***/ (function(module, exports) {

module.exports = {"ok":"ตกลง","cancel":"ยกเลิก","back":"ย้อนกลับ","edit":"แก้ไข","submit":"ยืนยัน","confirm":"ยืนยัน","yes":"ใช่","no":"ไม่","done":"เสร็จสิ้น","AdvancedSearch":"ค้นหาอย่างละเอียด","Update":"แก้ไข","Print":"พิมพ์","Enabled":"เปิดให้ใช้","Disable":"ปิดไม่ให้ใช้","View":"ดูข้อมูล","QRCode":"QR Code","Delete":"ลบ","Search":"ค้นหา","Clear":"ล้างค่า","UserO365":"นำเข้ารายชื่อจาก o365","Add":"เพิ่ม","Next":"ต่อไป","Unregister":"Unregister","O365Rooms":"ห้อง {name}","importRoom":"นำเข้าห้อง","searchString":"คำค้นหา","create":"เพิ่ม","update":"แก้ไข","close":"ปิด","save":"บันทึก"}

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

module.exports = {"masterData":"ข้อมูลหลัก","rooms":"ห้อง","roomMail":"อีเมลของห้อง","roomRegis":"รายชื่อห้องที่ลงทะเบียน","roomSub":"ห้องที่กำลังติดตาม","roomDis":"ห้องที่ไม่ให้ใช้งาน","roomFormat":"รูปแบบการจัดห้อง","location":"ตำแหน่งห้อง","building":"อาคาร","floor":"ชั้น","zone":"โซน","Users":"บัญชีผู้ใช้งาน","adUsers":"บัญชี AD","userRegis":"รายชื่อบัญชีที่ลงทะเบียน","Department":"ประเภทบัญชี","userConcur":"การใช้งานซ้ำ","Role":"ตำแหน่ง","Profile":"โปรไฟล์","Background":"พื้นหลัง","Facilities":"อุปกรณ์อำนวยความสะดวก","food":"อาหารและเครื่องดื่ม","Category":"ประเภทอาหาร","Foods":"อาหารและเครื่องดื่ม","iotDisplay":"หน้าจอแสดงผล","iotRegis":"อุปกรณ์ IoT ที่ลงทะเบียนแล้ว","iotRoomConfig":"IOT ที่ติดตั้งในห้อง","eventType":"ประเภทของการจอง","Events":"การจองห้อง","viewEvents":"ดูการจองทั้งหมด","Orders":"คำสั่งซื้อ","createOrder":"สร้างคำสั่งซื้อ","Settings":"การตั้งค่า","globalSetting":"การตั้งค่าพื้นฐาน","Integration":"การเชื่อมต่อบัญชี","Terms":"ข้อตกลงและเงื่อนไข","FAQ":"คำถามที่พบบ่อย","Contact":"ติดต่อเรา","Report":"รายงาน","Summary":"สรุป","roomSummary":"การใช้ห้อง","userSummary":"การใช้งานของบัญชี","foodSummary":"การสั่งอาหาร","facilitySummary":"การสั่งอุปกรณ์","deleteEventSummary":"การยกเลิกการจอง","reserveNotUse":"การจองแต่ไม่ได้ใช้งาน","Room":"ห้อง","User":"บัญชีผู้ใช้","Detail":"รายละเอียด","roomDetails":"รายละเอียดห้อง","userDetails":"รายละเอียดบัญชีผู้ใช้","foodDetails":"การสั่งอาหารในแต่ละการจอง","facilityDetails":"การสั่งอุปกรณ์ในแต่ละการจอง","Monitor":"สถิติ","Overview":"ภาพรวม","Status":"สถานะ","topUser":"บัญชีผู้ใช้ที่มีการจองมากที่สุด","topRooms":"ห้องที่มีการจองมากที่สุด","Hello":"สวัสดี","UserInformation":"ข้อมูลบัญชีผู้ใช้นี้","SignOut":"ออกจากระบบ","permission":"สิทธิ์การใช้งาน","devices":"อุปกรณ์","logo":"สัญลักษณ์","attendance":"เช็คชื่อเข้าใช้งานห้องประชุม"}

/***/ }),

/***/ 1338:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Rooms":"ห้อง","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Email":"อีเมล","Sync":"การเชื่อมต่อ","AddNew":"เพิ่มห้อง","Capacity":"ความจุ","RoomType":"ประเภทห้อง","Image":"รูป","NotiUrl":"Url สำหรับแจ้งเตือน","Expire":"หมดอายุ","Subject":"หัวข้อ","time":"เริ่ม - จบ","Room":"ห้อง","Description":"รายละเอียด","formatList":"รายชื่อรูปแบบการจัดห้อง","Code":"รหัส","addCode":"เพิ่มรหัส","Create":"สร้างห้อง","Update":"แก้ไขข้อมูลห้อง","RoomEmail":"อีเมลห้อง","AddRoomEmail":"เพิ่มอีเมลของห้อง","Roomname":"ชื่อห้อง","AddRoomName":"เพิ่มชื่อห้อง","noSelect":"----  ไม่ได้เลือก  ----","RoomCapacity":"ความจุของห้อง","AddCapacity":"เพิ่มความจุของห้อง","BGImage":"ภาพพื้นหลัง","Timezone":"เขตเวลา","Roomtype":"ประเภทห้อง","SyncVC":"เชื่อมต่อ VC Id","RoomImage":"รูปห้อง","fileSize":"*ขนาดของไฟล์ต้องไม่เกิน 10 MB","AutoCheckin":"เช็คอินอัตโนมัติ","AvailableReserve":"ของที่สั่งซื้อได้","SelectAll":"เลือกทั้งหมด","ViewRoom":"ข้อมูลห้อง","Location":"ตำแหน่งห้อง","Facilities":"อุปกรณ์","Food":"อาหารและเครื่องดื่ม","DisplayBG":"พื้นหลังที่ใช้","Profile":"โปรไฟล์","Qrcode":"QR Code ของห้อง","Confirmation":"ยืนยัน","ModelDelete":"คุณต้องการลบห้องนี้ออกใช่หรือไม่ ?","ModelDisable":"คุณต้องการปิดห้องนี้ใช่หรือไม่ ?","ModelEnable":"คุณต้องการเปิดใช้ห้องนี้ใช่หรือไม่ ?","ModelDeleteDisable":"คุณต้องการลบรายการนี้ใช่หรือไม่ ?","CreateDisable":"กำหนดเวลาที่ไม่ให้ใช้ห้อง","Start":"เริ่ม","End":"จบ","AllRoom":"ห้องทั้งหมด","UpdateDisable":"แก้ไขเวลาที่ไม่ให้ใช้ห้อง","ViewDisable":"ข้อมูลช่วงเวลาที่ไม่ให้ใช้ห้อง","CreateFormat":"สร้างรูปแบบการจัดห้อง","UpdateFormat":"แก้ไขข้อมูลรูปแบบการจัดห้อง","ViewFormat":"ข้อมูลรูปแบบห้อง","modelsubscribe":"คุณต้องการติดตามห้องนี้หรือไม่ ?","modelUnsubscribe":"คุณต้องการยกเลิกการติดตามห้องนี้หรือไม่ ?","Subscribe":"ติดตาม","selectRoom":"เลือกห้องที่ต้องการ","search":"ค้นหา","AvailableReserveAmenity":"อุปกรณ์ที่สามารถสั่งซื้อได้","AvailableReserveFbs":"อาหารและเครื่องดื่มที่สามารถสั่งซื้อได้","isConference":"ประชุมทางไกล","syncRoomPlatform":"นำเข้าห้องจาก Platform","noRooms":"ไม่มีห้อง"}

/***/ }),

/***/ 1339:
/***/ (function(module, exports) {

module.exports = {"Name":"ชื่อ","Email":"อีเมล","Capacity":"ความจุ","RoomType":"ประเภทห้อง","Subject":"หัวข้อ","autoCheckIn":"เช็คอินอัตโนมัติ","SelectAll":"เลือกทั้งหมด","Yes":"ใช่","No":"ไม่ใช่","Building":"อาคาร","Floor":"ชั้น","Zone":"โซน","Facilities":"อุปกรณ์","FirstName":"ชื่อ","LastName":"นามสกุล","Backend":"สิทธิในการเข้าถึง Backend","Department":"ตำแหน่ง","Description":"รายละเอียด","Category":"ประเภท","Start":"เริ่ม","End":"จบ","NameIOT":"ชื่อ","Room":"ห้อง","Code":"รหัส","stringSearch":"คำค้นหา"}

/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","BuildingList":"รายชื่ออาคาร","AddNewBuilding":"เพิ่มอาคาร","Confirmation":"ยืนยัน","deleteBuilding":"คุณต้องการลบอาคารนี้์หรือไม่ ?","CreateBuilding":"สร้างอาคาร","UpdateBuilding":"แก้ไขข้อมูลอาคาร","Availablefor":"ของที่สั่งซื้อได้","Facilities":"อุปกรณ์","Food":"อาหารและเครื่องดื่ม","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","FloorList":"ชั้นที่มี","FloorListHead":"รายชื่อชั้น","CreateFloor":"สร้างชั้น","UpdateFloor":"แก้ไขข้อมูลชั้น","ViewFloor":"ข้อมูลชั้น","Location":"ตำแหน่ง","AddNewFloor":"เพิ่มชั้น","Building":"อาคาร","deleteFloor":"คุณต้องการลบชั้นนี้์หรือไม่ ?","floorNo":"ชั้นที่","pleaseSelect":"---- กรุณาเลือกอาคาร ----","ZoneList":"โซนที่มี","ZoneListHead":"รายชื่อโซน","CreateZone":"สร้างโซน","UpdateZone":"แก้ไขข้อมูลโซน","ViewZone":"ข้อมูลโซน","AddNewZone":"เพิ่มโซน","deleteZone":"ตุณต้องการลบโซนนี้ใช่หรือไม่ ?","Floor":"ชั้น","selectBuilding":"---- กรุณาเลือกอาคาร ----","selectFloor":"---- กรุณาเลือกชั้น ----","noBuildingData":"ไม่มีข้อมูลอาคาร","noFloorData":"ไม่มีข้อมูลชั้น","noZoneData":"ไม่มีข้อมูลโซน","syncBuildingPlatform":"นำเข้าอาคารจาก Platform","syncFloorPlatform":"นำเข้าชั้นจาก Platform","syncZonePlatform":"นำเข้าโซนจาก Platform","code":"รหัส"}

/***/ }),

/***/ 1341:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","UserRegis":"รายชื่อบัญชีที่ลงทะเบียน","CreateUser":"เพิ่มบัญชีผู้ใช้งาน","UpdateUser":"แก้ไขข้อมูลบัญชีผู้ใช้งาน","Users":"บัญชี","Email":"อีเมล","addEmail":"เพิ่มอีเมล","Backend":"สิทธิในการเข้าถึง Backend","Resetpass":"รีเซ็ตรหัสผ่าน","Confirmation":"ยืนยัน","deleteUser":"คุณต้องการลบบัญชีนี้ใช่หรือไม่ ?","resetPass":"คุณต้องการรีเซ็ตรหัสผ่านของบัญชีนี้ใช่หรือไม่ ?","ViewUser":"ข้อมูลบัญชีผู้ใช้","UserDetail":"รายละเอียดบัญชี","PINCode":"PIN Code","RFID":"RFID","Status":"สถานะ","TimeZone":"เขตเวลา","Department":"ประเภทบัญชี","Role":"ตำแหน่ง","QRCode":"QR Code","MeetingDetail":"รายละเอียดการจอง","AutoLock":"ล็อกบัญชีอัตโนมัติ","AvailableRooms":"ห้องที่จองได้","AvailableRoomsRole":"ห้องที่จองได้ (จากตำแหน่ง)","UserName":"บัญชีผู้ใช้","Adduser":"เพิ่มบัญชี","Password":"รหัสผ่าน","Addpass":"กรอกรหัสผ่าน","ConfirmPass":"ยืนยันรหัสผ่าน","Addsamepass":"กรอกรหัสผ่าน","FirstName":"ชื่อ","Addfirstname":"กรอกชื่อ","LastName":"นามสกุล","Addlastname":"กรอกนามสกุล","Addpincode":"กรอก pin code","Addrfid":"กรอก rfid","SelectStatus":"เลือกสถานะ","SelectTimezone":"เลือกเขตเวลา","Require":"กรุณากรอกข้อมูล!!","Passatleast":"รหัสผ่านต้องยาวอย่างน้อย 8 ตัว","Passwordnotmatch.":"รหัสผ่านไม่ตรงกัน","passwordNotMatchError":"รหัสผ่านไม่ตรงกัน","importAD":"นำเข้าบัญชี AD","selectuser":"กรุณาเลือกบัญชีผู้ใช้","Select":"เลือกบัญชีผู้ใช้","CurrentPass":"รหัสผ่านปัจจุบัน","NewPass":"รหัสผ่านใหม่","passError1":"ต้องมีความยาว 4-50 ตัวอักษร","passError2":"ต้องมีเลขอย่างน้อย 1 ตัว","passError3":"ต้องมีอักษรตัวเล็กอย่างน้อย 1 ตัว (a-z)","passError4":"ต้องมีอักษรตัวใหญ่อย่างน้อย 1 ตัว (A-Z)","passError5":"ใช้ได้เฉพาะ 0-9a-zA-Z","NoUsers":"ไม่มีบัญชีผู้ใช้","UserInfo":"ข้อมูลบัญชีผู้ใช้","Language":"ภาษา","ChangePass":"เปลี่ยนรหัสผ่าน","NewDepartment":"เพิ่มหน่วยงานใหม่","Groups":"กลุ่ม","Description":"คำอธิบาย","CreateDepartment":"สร้างประเภทบัญชีใหม่","UpdateDepartment":"แก้ไขข้อมูลประเภทบัญชี","Selected":"เลือก","Add":"เพิ่ม","Mobile":"เบอร์โทรศัพท์","external":"บัญชีผู้ใช้ภายนอก","MobilePhone":"เบอร์โทรศัพท์มือถือ","SelectUser":"เลือกบัญชีผู้ใช้","Selectinternal":"เลือกบัญชีผู้ใช้ภายใน","Internal":"เลือกบัญชีภายใน","internal":"บัญชีภายใน","External":"บัญชีภายนอก","Search":"ค้นหา","Update":"แก้ไข","UserGroup":"บัญชีในกลุ่ม","ViewDepartment":"ข้อมูลประเภทบัญชี","deleteusergroup":"คุณต้องการลบประเภทบัญชีนี้หรือไม่","specialcharactor":"รหัสผ่านไม่ถูกต้องตามเงื่อนไข","Items":"อุปกรณ์","Fullname":"ชื่อ","Platfrom":"อุปกรณ์","Deleteitem":"คุณต้องการลบอุปกรณ์นี้รึเปล่า ?","emailWrongformat":"อีเมลไม่ถูกต้อง","Platform":"อุปกรณ์","syncUserPlatform":"นำเข้าบัญชีผู้ใช้จากจาก Platform","importUserMailSystem":"นำเข้าบัญชีผู้ใช้จากจาก Mail System","importUserExchange":"นำเข้าบัญชีผู้ใช้จากจาก Exchange","importUserGoogle":"นำเข้าบัญชีผู้ใช้จากจาก Google","employeeCode":"รหัสพนักงาน","addEmployeeCode":"เพิ่มรหัสพนักงาน","o365Information":"O365 Information","googleInformation":"Google Information","exchangeInformation":"Exchange Information","exchange":"Exchange","adInformation":"ข้อมูล AD","integrationAD":"เชื่อมต่อบัญชี","changeIntegrationAD":"เปลี่ยนบัญชี","userPrincipalName":"User Principal Name","syncDepartmentPlatform":"นำเข้าประเภทบัญชีจาก Platform","noDepartmentData":"ไม่มีข้อมูลประเภทบัญชี"}

/***/ }),

/***/ 1342:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","AddNew":"เพิ่มตำแหน่ง","RoleList":"รายชื่อตำแหน่งทั้งหมด","UpdateRole":"แก้ไขข้อมูลตำแหน่ง","CreateRole":"สร้างตำแหน่ง","ViewRole":"ข้อมูลตำแหน่ง","Synco365":"นำเข้าตำแหน่งจาก o365","MaxBooking":"ช่วงเวลาที่จองได้ล่วงหน้า (วัน)","MaxDuration":"ระยะเวลาที่จองได้สูงสุดในการจองแต่ละครั้ง (นาที)","Confirmation":"ยืนยัน","modelDelete":"คุณต้องการลบตำแหน่งนี้หรือไม่ ?","AvailableRooms":"ห้องที่สามารถจองได้","Require":"กรุณากรอกข้อมูล!!"}

/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มโปรไฟล์","Require":"กรุณากรอกข้อมูล!!","ProfileList":"รายชื่อโปรไฟล์","CreateProfile":"สร้างโปรไฟล์","UpdateProfile":"แก้ไขโปรไฟล์","View":"ข้อมูลของ","usingprofile":"ห้องที่ใช้โปรไฟล์นี้อยู่","Action":"สิ่งที่ทำได้","Identify":"การอนุญาต","Department":"หน่วยงาน","Calendar":"ปฏิทิน","Order":"คำสั่ง","Rules":"กฏ","Norule":"ไม่มีกฏ","ManageRule":"จัดการกฏ","confirm":"ยืนยัน","confirmmessage":"คุณต้องการลบโปรไฟล์นี้ใช่หรือไม่?","noUse":"โปรไฟล์นี้ไม่ถูกใช้งาน"}

/***/ }),

/***/ 1344:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","BackgroundList":"พื้นหลังทั้งหมด","Default":"ตั้งเป็นพื้นฐาน","SetDefault":"ตั้งเป็นพื้นฐาน","modelDelete":"คุณต้องการลบพื้นหลังอันนี้หรือไม่ ?","CreateBackground":"สร้างพื้นหลัง","Updatebackground":"แก้ไขพื้นหลัง","Type":"ประเภท","PleaseSelect":"--- กรุณาเลือก ---","Video":"วิดีโอ","Upload":"อัพโหลด","Viewbackground":"ดูพื้นหลัง","SizeHuge":"ไฟล์มีขนาดใหญ่เกินไป!!","filetype":"ประเภท"}

/***/ }),

/***/ 1345:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มอุปกรณ์","AddNewFood":"เพิ่มประเภท","AddNewFoodList":"เพิ่มเมนู","Require":"กรุณากรอกข้อมูล!!","modelDelete":"คุณต้องการลบอุปกรณ์อันนี้หรือไม่ ?","PleaseSelect":"--- กรุณาเลือก ---","CreateFacility":"เพิ่มอุปกรณ์","UpdateFacility":"แก้ไขอุปกรณ์","FacilitiesList":"รายชื่ออุปกรณ์ทั้งหมด","Amount":"จำนวน","ViewFacility":"ข้อมูลอุปกรณ์","FoodCategory":"ประเภทอาหารและเครื่องดื่ม","modelDeleteFood":"คุณต้องการลบประเภทอาหารชนิดนี้ใช่หรือไม่ ?","DeleteFoodList":"คุณต้องการลบอาหารชนิดนี้ใช่หรือไม่ ?","CreateFood":"สร้างประเภทอาหารและเครื่องดื่ม","UpdateFood":"แก้ไขประเภทอาหารและเครื่องดื่ม","ViewFood":"ข้อมูลประเภทอาหารและเครื่องดื่ม","FoodList":"รายการอาหารและเครื่องดื่ม","Category":"ประเภท","Price":"ราคา","CreateFoodList":"เพิ่มเมนูอาหารและเครื่องดื่ม","UpdateFoodList":"แก้ไขเมนูอาหารและเครื่องดื่ม","SelectCategory":"---- กรุณาเลือกประเภทของอาหาร ----","SizeHuge":"รูปมีขนาดใหญ่เกินไป!!","ViewFoodList":"ข้อมูลเมนูอาหารและเครื่องดื่ม","View":"ดูข้อมูล","Update":"แก้ไข","Delete":"ลบ"}

/***/ }),

/***/ 1346:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่ม","Require":"กรุณากรอกข้อมูล!!","Display":"หน้าจอแสดงผล","Devices":"อุปกรณ์","License":"รหัสใบอนุญาต","Mac":"Mac Address","Model":"รุ่น","IP":"IP Address","Room":"ห้อง","Status":"สถานะ","Unregister":"นำออก","modelUnregis":"คุณต้องการนำอุปกรณ์นี้ออกหรือไม่ ?","modelDisable":"คุณต้องการปิดอุปกรณ์ใช่หรือไม่ ?","modelEnable":"คุณต้องการเปิดอุปกรณ์ใช่หรือไม่ ?","IOTRegis":"อุปกรณ์ IOT","IOTRoom":"IOT ที่ติดตั้งในห้อง","Items":"รายการ","RoomCode":"รหัสห้อง","SerialNumber":"หมายเลขซีเรียล","modelDelete":"คุณต้องการลบอุปกรณ์นี้หรือไม่ ?","CreateIOT":"เพิ่มอุปกรณ์ IOT ที่ติดตั้งในห้อง","UpdateIOT":"แก้ไขอุปกรณ์ IOT ที่ติดตั้งในห้อง","pleaseSelect":"----  กรุณาเลือก  ----","selectLicense":"----  กรุณาเลือกรหัส ----","notSelect":"----  ไม่เลือก  ----","ViewIOT":"ข้อมูลอุปกรณ์"}

/***/ }),

/***/ 1347:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มประเภท","Require":"กรุณากรอกข้อมูล!!","EventType":"ประเภทของการจอง","modelDelete":"คุณต้องการลบประเภทการจองนี้หรือไม่ ?","CreateType":"สร้างประเภทการจอง","UpdateType":"แก้ไขประเภทการจอง","ViewType":"ข้อมูลประเภทของการจอง","AllEvents":"การจองทั้งหมด","Subject":"หัวข้อ & ผู้จอง","Room":"ห้อง","DateTime":"วัน เวลา","Status":"สถานะ","Organizer":"ผู้จอง","Start":"เริ่ม","End":"จบ","Check-in":"เช็คอิน","Check-out":"เช็คเอาท์","modelCheckin":"คุณต้องการ เช็คอิน ประเภทการจองนี้หรือไม่ ?","modelCheckout":"คุณต้องการ เช็คเอาท์ ประเภทการจองนี้หรือไม่ ?","allDay":"ทั้งวัน","resendPin":"ส่ง PIN ใหม่อีกครั้ง","resendPinSuccess":"ส่ง PIN สำเร็จ.","resendPinFail":"ส่ง PIN ไม่สำเร็จ.","modelResendPin":"คุณต้องการส่ง PIN ใหม่อีกครั้งหรือไม่","pin":"Event PIN"}

/***/ }),

/***/ 1348:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","OrdersFood":"รายการสั่งอาหาร","Start":"เริ่ม","End":"จบ","Subject":"หัวข้อ","StartTime":"เวลาเริ่ม","EndTime":"เวลาจบ","Status":"สถานะ","OrdersFac":"รายการสั่งอุปกรณ์","AllEvent":"สร้างคำสั่งซื้อ","Foods":"อาหารและเครื่องดื่ม","Amenities":"อุปกรณ์","DateTime":"วันเวลา","Room":"ห้อง","CreateAmenity":"เพิ่มการสั่งอุปกรณ์","CreateFood":"เพิ่มการสั่งอาหาร","pcs.":"ชิ้น","Amenity":"อุปกรณ์","FoodEmpty":"ไม่มีที่เลือกไว้","Remark":"เพิ่มเติม","updateFbs":"แก้ไขการสั่งอาหาร","updateAmenity":"แก้ไขการสั่งอุปกรณ์","viewFbs":"ดูการสั่งอาหาร","viewAmenity":"ดูการสั่งอุปกรณ์"}

/***/ }),

/***/ 1349:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","SettingInfo":"ข้อมูลการตั้งค่า","UpdateSetting":"แก้ไขการตั้งค่า","GlobalSetting":"การตั้งค่าทั่วไป","StartTime":"เวลาที่เริ่มจองได้","EndTime":"เวลาสุดท้ายที่จองได้","MinOrder":"เวลาที่สามารถสั่งอาหารล่วงหน้า (ชั่วโมง)","SlotDuration":"ระยะห่างของเวลาในการจอง (นาที)","TokenExpire":"Token หมดอายุ (นาที)","AdminEmail":"อีเมลของผู้ดูแลระบบ","AdminTel":"เบอร์โทรศัพท์ของผู้ดูแลระบบ","AdminID":"ID ของผู้ดูแลระบบ","admin":"ผู้ดูแลระบบ","AdvancedBooking":"วันที่จองได้ล่วงหน้า (วัน)","MaxBooking":"เวลาที่จองได้สูงสุด (นาที)","Check-in":"เวลาที่เช็คอินได้ (นาที)","ReleaseTime":"เวลาที่จะปล่อยห้องให้ว่าง (นาที)","IoTbefore":"IoT - ไฟจะเปิดก่อนการจองจะเริ่ม (นาที)","IoTafter":"IoT - ไฟจะปิดหลังจบการจบ (นาที)","Checkin":"การส่งอีเมลแจ้งเตือนการเช็คอิน","HousekeeperAdmin":"ผู้ดูแลระบบแม่บ้าน","HousekeeperName":"ชื่อผู้ดูแลระบบแม่บ้าน","HousekeeperEmail":"อีเมลผู้ดูแลระบบแม่บ้าน","HousekeeperTel":"เบอร์โทรศัพท์ผู้ดูแลระบบแม่บ้าน","LockedUser":"การล็อกบัญชีผู้ใช้","Investigation":"ระยะเวลาในการตรวจสอบ (วัน)","Suspended":"ระยะเวลาในการระงับการใช้งาน (วัน)","Adsence":"จำนวนครั้งที่ไม่มา (ครั้ง)","SigninPermission":"การอนุญาตเข้าสู่ระบบ","SigninUpsert":"การลงชื่อเข้าใช้และเพิ่มหรือแก้ไขบัญชีผู้ใช้","AllowSignin":"Domain ที่อนุญาตให้ลงชื่อเข้าใช้","Import":"นำเข้า","ImportO365":"นำเข้าบัญชีผู้ใช้จาก O365","ImportExcel":"นำเข้าบัญชีผู้ใช้จาก Excel","ImportAD":"นำเข้าบัญชีผู้ใช้จาก AD","ImportUserSystem":"นำเข้าบัญชีผู้ใช้จาก Mail System","LightDimmer":"ไฟหรี่ (จอแสดงผล)","EnabledLight":"อนุญาตให้ใช้ไฟหรี่","Start":"เวลาเริ่ม","End":"เวลาจบ","EventPIN":"PIN ของการจอง","EnabledEventPIN":"อนุญาตให้ใช้ PIN","Concurrent":"การลงชื่อเข้าใช้พร้อมกัน","EnabledCocurrent":"อนุญาตให้ลงชื่อเข้าใช้พร้อมกัน","ActiveDirectory":"การจัดการทรัพยากร","EnabledADLogin":"อนุญาตให้เข้าสู่ระบบด้วย AD","IP":"IP","Port":"พอร์ต","User":"บัญชีผู้ใช้","BaseDN":"Base DN","Domain":"Domain","Reminder":"การแจ้งเตือน","EnabledReminder":"อนุญาตให้แจ้งเตือน","AdvancedReminder":"การแจ้งเตือนล่วงหน้า (ชั่วโมง)","TMS":"ข้อมูล TMS","EnabledTMS":"อนุญาตให้เชื่อมต่อ TMS","Server":"เซิร์ฟเวอร์","Password":"รหัสผ่าน","UserPrefix":"คำนำหน้าผู้ใช้","ConferenceType":"ประเภทการประชุมทางไกล","CMR":"ข้อมูล CMR","EnabledCMR":"อนุญาตให้ใช้ข้อมูล CMR","BOT":"ข้อมูล BOT","EnabledBOT":"อนุญาตให้เชื่อมต่อ BOT","Webhook":"Web hook","TestAD":"ทดสอบ AD","SelectConference":"---- กรุณาเลือกประเภทการโทรทางไกล ----","AutomaticCall":"โทรโดยอัตโนมัติ","OneButton":"กดปุ่มครั้งเดียว","ManualCall":"โทรด้วยตัวเอง","NoConnect":"ไม่มีการเชื่อมต่อ","ReservationOnly":"การจองเท่านั้น","Default":"ค่าพื้นฐาน","TestTMS":"ทดสอบ TMS","TestCMR":"ทดสอบ CMR","TestBOT":"ทดสอบ BOT","TestSuccessful":"การทดสอบเชื่อมต่อสมบูรณ์","TestFailure":"การทดสอบเชื่อมต่อล้มเหลว","ChangeIntegration":"เปลี่ยนการตั้งค่าเชื่อมต่อ","Integration":"การเชื่อมต่อ","Backend":"Backend","ClientId":"Client Id","ClientSecret":"Client Secret","TenantId":"Tenant Id","MobileURL":"URL สำหรับมือถือ","WebURL":"URL สำหรับเว็บ","Authen":"Authen","Yoursite":"เว็บของคุณไม่มีการเชื่อมต่อ","SettingsUser":"ตั้งค่าบัญชีผู้ใช้","IntegrationO365":"การเชื่อมต่อ Office 365","Registerapp":"ลงทะเบียนแอปพลิเคชันของคุณ","Pleaseregister":"กรุณาลงทะเบียนแอปพลิเคชันของคุณกับผู้ดูแลระบบผ่านทาง","AppPortal":"ลงทะเบียนแอปพลิเคชันพอร์ทัล","YourClientId":"Client Id ของคุณ:","AdminConsent":"ความยินยอมของผู้ดูแลระบบ","AllowApp":"อนุญาตให้แอปนี้เชื่อมต่อ","Connect":"เชื่อมต่อ","ConnectO365App":"เชื่อมต่อแอป O365 ของคุณเข้ากับ Roomminister","UseFrontend":"การใช้งานเชื่อมต่อ Frontend","Term":"ข้อตกลงและเงื่อนไข","TermTH":"ภาษาไทย","TermEN":"ภาษาอังกฤษ","ContactUsTH":"ภาษาไทย","ContactUsEN":"ภาษาอังกฤษ","EditTerm":"แก้ไขข้อตกลงและเงื่อนไข","Faq":"คำถามที่พบบ่อย","FaqTH":"ภาษาไทย","FaqEN":"ภาษาอังกฤษ","EditFaq":"แก้ไข คำถามที่พบบ่อย","ContactUs":"ติดต่อเรา","ContactTH":"ภาษาไทย","ContactEN":"ภาษาอังกฤษ","EditContactUs":"แก้ไขการติดต่อ","testConnection":"ทดสอบการเชื่อมต่อ","syncRoleAndPolicy":"ซิงค์ตำแหน่งและข้อบังคับ","isSyncRoleAndPolicy":"อนุญาตซิงค์ตำแหน่งและข้อบังคับ","ewsUsername":"บัญชีผู้ใช้","ewsPassword":"รหัสผ่าน","ewsHost":"เซิร์ฟเวอร์","ewsAuthType":"ประเภทการให้สิทธิ์","defaultRoleId":"ตำแหน่งพื้นฐาน","android":{"name":"Android","packageName":"Package Name","signatureHash":"Signature Hash","authorizationUserAgent":"Authorization User Agent","redirectUri":"Redirect Uri","authorities":"Authorities","type":"Type","audience":"Audience","tenantId":"Tenant Id"},"ios":{"name":"iOS","bundleID":"Bundle ID","kClientID":"kClientID","kRedirectUri":"kRedirectUri","kAuthority":"kAuthority"}}

/***/ }),

/***/ 1350:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","SummaryRoom":"รายงานสรุปการใช้ห้อง","Start":"เริ่ม","End":"จบ","Building":"อาคาร","Floor":"ชั้น","Zone":"โซน","Room":"ห้อง","ExportToExcel":"ส่งออกเป็น Excel","SummaryUser":"รายงานสรุปบัญชีผู้ใช้","User":"บัญชีผู้ใช้งาน","SummaryFood":"รายงานสรุปการสั่งอาหาร","SummaryDelete":"รายงานสรุปการยกเลิกการจอง","SummaryFacility":"รายงานสรุปการสั่งอุปกรณ์","ReserveRoom":"รายงานการจองที่ไม่ได้ใช้จากห้อง","ReserveUser":"รายงานการจองที่ไม่ได้ใช้จากบัญชีผู้ใช้","DetailRoom":"รายงานรายละเอียดของห้อง","NoSelect":"--- ไม่ได้เลือก ---","selectBuilding":"กรุณาเลือกอาคาร","selectFloor":"กรุณาเลือกชั้น","DetailUser":"รายงานรายละเอียดบัญชีผู้ใช้","FoodDetail":"รายละเอียดการสั่งอาหารในแต่ละการจอง","FacilityDetail":"รายละเอียดการสั่งอุปกรณ์ในแต่ละการจอง","userAttendance":"Meeting Attendance by Event"}

/***/ }),

/***/ 1351:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","Date":"วันที่","Type":"ช่วงเวลา","Room":"ห้อง","Officehour":"ช่วงเวลาทำงาน","Allday":"ทั้งวัน","Search":"ค้นหา","Available":"*ว่าง, จอง คำนวณจากเวลาปัจจุบันจนถึงเวลาสิ้นสุดของวัน (ช่วงเวลาในอนาคต)","NoUse":"*ไม่ได้ใช้งาน, ใช้งาน, รอ คำนวณจากเวลาเริ่มต้นของวันถึงปัจจุบัน (ช่วงเวลาในอดีต)","StatusSummary":"สถานะโดยรวม","RoomStatus":"สถานะของห้อง","FilterDate":"กรองวันเวลา","Filter":"กรอง","StartAndEnd":"เวลาเริ่มกับเวลาจบ (วัน , เวลา)","startsearch":"* เริ่มต้นชั่วโมงค้นหา","from":"จาก ","Booking":"การจอง","Confirm":"ยืนยัน","Subject":"หัวข้อ","StartDate":"วันเวลาที่เริ่ม","EndDate":"วันเวลาที่จบ","Thisperiod":"ช่วงเวลานี้ไม่มีการจอง","autorelease":"ช่วงเวลานี้ไม่มีการเช็คอินหรือปล่อยห้องให้ว่าง","Reserve":"*การจอง คือจำนวนครั้งที่จองเอาไว้","Succescheckedin":"*ความสำเร็จ จำนวนครั้งที่ห้องมีการเช็คอินสำเร็จ","Auto-release":"*การปล่อยห้องให้ว่าง จำนวนครั้งที่ห้องมีการปล่อยให้ว่าง","RealTime":"สถานะของห้องเวลาจริง","AutoCheckIn":"เช็คอินอัตโนมัติ","Location":"สถานที่","Selectperiod":"เลือกช่วงเวลา","Maximum":"จำนวนสูงสุดของ","TopUser":"ผู้ใช้ที่จองมากที่สุด: ในแต่ละ","TopRoom":"ห้องที่มีการจองมากที่สุด: ในแต่ละ","day":"วัน","advanceSearchGuideLine":" * ค่าว่าง หรือ 0 เพื่อแสดงทั้งหมด ของ ","advanceSearchGuideLineTitle":" (จำนวน)","graphBookingTitle":"จำนวนการจอง"}

/***/ }),

/***/ 1352:
/***/ (function(module, exports) {

module.exports = {"require":"จำเป็นต้องระบุ"}

/***/ }),

/***/ 1353:
/***/ (function(module, exports) {

module.exports = {"confirmDeleteOrder":"ยืนยันลบรายการ","fillInreason":"ระบุเหตุผล"}

/***/ }),

/***/ 1354:
/***/ (function(module, exports) {

module.exports = {"404":"Page Not Found","90000000":"Image is Over Than 10 MB","systemMessage":"ข้อความจากระบบ","code":"รหัส","message":"ข้อความ","00000000":"Something went wrong. Please try again later.","00000001":"UnAuthorized to Access","00000002":"Token Has expired.","00000003":"Model is Not Found","00000004":"Failed to Find Data List","00000005":"ID Not Found","00000006":"Failed to Find Data","00000007":"Failed to Create Data","00000008":"Failed to Update Data","00000009":"Failed to Update Row of Data","00000010":"Failed to Delete Data","00000011":"Failed to Delete Row of Data","00000012":"Failed to Find Token in System","00000013":"Token Has expired. This Token's logout for a few Time.","00000014":"Token Has expired.","00000101":"Failed to Create location.","00000102":"Failed to Update location","00000201":"SID Create.","00000202":"SID Verify.","00000301":"Failed to Insert Log.","00000401":"Failed to Insert Log.","00000501":"Failed to Find Event.  ","00000502":"Failed to Find Event. ","00000503":"Failed to Checkin.","00000504":"Failed to Find Event.","00000505":"Failed to Checkin.","00000506":"Failed to Find Checkin Information.","00000507":"Event Time's Up.","00000601":"Failed to Find All Room.","00000602":"Failed to Find Room Information.","00000603":"Failed to Create Event.","00000604":"Failed to Update Event.","00000605":"Failed to Cancel Event.","00000701":"Failed to Create Food & Berverage Order.","00000702":"Failed to Update Food & Berverage Order.","00000703":"Failed to Delete Food & Berverage Order.","00000704":"Failed to Find Food & Berverage Order List.","00000705":"Failed to Find Food & Berverage Order.","00000801":"Failed to Find Food & Berverage Order Category.","00000802":"Failed to Find Food & Berverage Order Category List.","00000803":"Failed to Delete Food & Berverage Order Category.","00000804":"Failed to Create Food & Berverage Order Category.","00000805":"Failed to Update Food & Berverage Order Category.","00000806":"Failed to Find Food & Berverage Order Category List.","00000901":"Failed to Create Building.","00000902":"Failed to Update Building.","00000903":"Failed to Delete Building.","00000904":"Failed to Find Building List.","00000905":"Failed to Find Building.","00000906":"Failed to Create Building.; This Building's Name is Already Been Used.","00000907":"Failed to Update Building.; This Building's Name is Already Been Used","00000908":"Failed to Delete Building. This Building's Usage by Some Floor.","00001001":"o365: Access Denied.","00001002":"o365:  Failed to Get Token.","00001003":"o365:  Failed to Get Refresh Token.","00001004":"o365:  Failed to Update/Insert Tenant.","00001005":"o365:  Failed to Get Service Token.","00001006":"o365:  Failed to Get User Token.","00001007":"o365:  Failed to Get Integration Info.","00001008":"o365:  Failed to Get Event by IcalUId.","00001009":"o365:  Failed to Get Room in Event.","00001010":"o365:  Failed to Get Events by Floor.","00001011":"o365:  Failed to Get Events.","00001012":"365:  Failed to Get Frontend Integration Info.","00001101":"Failed to Delete Order.","00001102":"Failed to Find Order Facilities Event.","00001103":"Failed to Find Order Facilities Room.","00001104":"Order Facilities is Empty.","00001105":"Failed to Create Facilities Order Because Event Has Been Cancelled or Ended.","00001106":"Failed to Create Facilities Order","00001107":"Failed to Update Facilities Order","00001108":"Failed to Update Facilities Order.","00001109":"Failed to Update Facilities Order.","00001110":"Failed to Update Facilities Order.","00001111":"Failed to Cancel Facilities Order.","00001112":"Failed to Delete Facilities Order.","00001113":"Failed to Get Facilities Order.","00001114":"Failed to Cancel Facilities Order.","00001115":"Failed to Get Facilities Order.","00001116":"Failed to Get Facilities Order.","00001117":"Failed to Get Facilities Order.","00001118":"Failed to Get Facilities Order.","00001119":"Failed to Get Food & Berverage.","00001120":"Failed to Get Food & Berverage.","00001121":"Failed to Get Food & Berverage.","00001122":"Failed to Create Food & Berverage Because Event Has Been Cancelled or Ended.","00001123":"Failed to Update Food & Berverage.","00001124":"Failed to Create Food & Berverage.","00001125":"Failed to Update Food & Berverage.","00001126":"Failed to Update Food & Berverage.","00001127":"Failed to Update Food & Berverage.","00001128":"Failed to Cancel Food & Berverage.","00001129":"Failed to Delete Food & Berverage.","00001130":"Failed to Get Food & Berverage.","00001131":"Failed to Get Food & Berverage.","00001132":"Failed to Get Food & Berverage.","00001133":"Failed to Get Food & Berverage.","00001134":"Failed to Get Food & Berverage.","00001135":"Failed to Find Food & Berverage.","00001136":"Failed to Find Food & Berverage.","00001201":"Failed to Create Policy.","00001202":"Failed to Set Policy.","00001301":"Failed to Create Profile.","00001302":"Failed to Update Profile.","00001303":"Failed to Delete Profile.","00001304":"Failed to Find Profile.","00001305":"Failed to Create Profile.; The Specified Profile's Name is Already Been Used.","00001306":"Failed to Update Profile.; The Specified Profile's Name is Already Been Used.","00001401":"Failed to Create Floor.","00001402":"Failed to Update Floor.","00001403":"Failed to Delete Floor.","00001404":"Failed to Get Floor.","00001405":"Failed to Get Floor by Id.","00001406":"Failed to Create Floor.; The Specified Floor's Name is Already Been Used is Same Building.","00001407":"Failed to Update Floor.; The Specified Floor's Name is Already Been Used is Same Building.","00001408":"Failed to Delete Floor.  This Floor's Usage by Some Zone.","00001501":"Failed to Create Zone.","00001502":"Failed to Update Zone.","00001503":"Failed to Delete Zone.","00001504":"Failed to Get All Zone.","00001505":"Failed to Get Zone Information.","00001506":"Failed to Create Zone.; The Specitied Zone's Name is Already Been Used in Same Floor","00001507":"Failed to Update Zone.; The Specitied Zone's Name is Already Been Used in Same Floor","00001601":"Failed to Create Room.; The Specified Email Address Has Already Been Used Before.","00001602":"Failed to Create Room.","00001603":"Failed to Update Room.","00001604":"Failed to Get Room.","00001605":"Failed to Get Room Capacity.","00001606":"Failed to Get All Room.","00001607":"Failed to Delete Room.","00001608":"Failed to Delete Subscribed Room.","00001609":"Failed to Delete Room Info.","00001610":"Failed to Get Room Info.","00001611":"Failed to Get Room Info.","00001612":"Failed to Create Room.; The Specified Room's Name is Already Been Used.","00001613":"Failed to Update Room.; The Specified Room's Name is Already Been Used.","00001614":"Failed to Check Can Booking Room.","00001701":"Failed to Create Room Disable.","00001702":"Failed to Update Room Disable.","00001703":"Failed to Delete Room Info.","00001704":"Failed to Delete Room Info.","00001705":"Failed to Get Room Disable Info.","00001706":"Failed to Get Room Status.","00001707":"Failed to Get Room.","00001901":"Failed to Update Setting. ","00001902":"Failed to Get general Setting.","00001903":"Failed to Get All Setting. ","00001904":"Failed to Update Setting. ","00001905":"Failed to Get All Information.","00001906":"Failed to Create User Group.","00002101":"Failed to Verify User; User Not Found.","00002102":"Failed to Verify User; Wrong Password.","00002103":"Failed to Create User; The Specified Email Address Has Already Been Used Before.","00002104":"User UnAuthorized Action.","00002105":"User Invalid Credentials.","00002106":"Failed to Create User.","00002107":"Failed to Get User Token.","00002108":"Failed to Get User Token Info.","00002109":"Failed to Find User by Email.","00002110":"Verify Failed.","00002111":"Failed to Update User.","00002112":"Failed to Delete User.","00002113":"Password does Not Match","00002114":"Password does Not Match","00002115":"Password does Not Match","00002116":"Failed to Change User Password.","00002117":"Failed to Find User Token.","00002118":"Failed to Refresh User Token.","00002119":"Failed to Find User Group.","00002120":"Failed to Get User Company.","00002121":"User Company Empty.","00002122":"User Profile Empty.","00002123":"Verify Failed.","00002124":"Failed to Update User Token.","00002125":"User Service Token Empty.","00002126":"Failed to Remove User Token.","00002127":"Failed to Generate User Token.","00002128":"Failed to Sync User AD.","00002129":"Authenticate User AD Failed.","00002130":"Failed to Get User Setting AD.","00002131":"Failed to Get All User.","00002132":"User Not Integration.","00002133":"Failed to Create User; The Specified PIN Code Has Already Been Used Before.","00002134":"Failed to Add User Favorite Room.","00002135":"Failed to Delete User Favorite Room.","00002136":"Failed to Get User QR Code","00002137":"Failed to Update User; The Specified PIN Code Has Already Been Used Before.","00002138":"Failed to ReSet Password.","00002139":"Failed to Request Forgot Password.","00002140":"Request ReSet Password Fail. ","00002141":"Failed to Find User by ReSet Password Key.","00002142":"Failed to Find User Email. (User Never Login)","00002143":"Verify Failed. Already Login for Other Device.","00002144":"Failed to Refresh Token.","00002145":"Access Denied, Please Contact Administrator","00002146":"Failed to Get User Integration Data.","00002147":"Access Denied, User Inactive.","00002148":"Fail to Make Data.","00002149":"Fail to Re-Token.","00002150":"Fail to Find User.","00002201":"Failed to Create User Group.","00002202":"Failed to Update User Group ","00002203":"Failed to Delete User Group.","00002204":"Failed to Get User Group; User Group Data Empty.","00002205":"Failed to Find User Group.","00002206":"Failed to Find All User Group.","00002207":"Failed to Get User Group With Reserve.","00002208":"Failed to Create User Group. This Name's Already","00002209":"Failed to Find User Group.","00002210":"Failed to Find User Group by User Id.","00002301":"Failed to Create Image.","00002302":"Failed to Update Image.","00002401":"Failed to Create Background.","00002402":"Failed to Update Background.","00002403":"Failed to Delete Background.","00002404":"Failed to Set Default Background.","00002405":"Failed to Find All Background.","00002406":"Failed to Find Background.","00002407":"Failed to Create Background.; The Background's Name is Already Been Used","00002408":"Failed to Update Background.; The Background's Name is Already Been Used","00002501":"Failed to Find IoT Device.","00002502":"Failed to Create IoT Device.","00002503":"Failed to Update IoT Device.","00002504":"Failed to Get All IoT Device.","00002505":"Failed to Get IoT Device by Id.","00002506":"Failed to Change IoT Disable Status.","00002507":"Failed to Get RoomInfo by IoT MAC.","00002508":"Failed to Define Room IoT.","00002509":"Failed to Check IOT Config.","00002510":"Failed to Delete IOT Config from Profile Center.","00002511":"Failed to Find IoT Device from Profile Center.","00002512":"Failed to Delete IOT.","00002513":"Failed to UnRegister IOT.","00002514":"Failed to Find IOT.","00002601":"Failed to Create IoT Information.","00002602":"Failed to Get IoT Information.","00002701":"Failed to Get All Seat.","00002702":"Failed to Create Seat.","00002703":"Failed to Get Zone Information.","00002704":"Failed to Get Seat.","00002705":"Failed to Update Seat.","00002706":"Failed to Get All Favorite Seat.","00002707":"Failed to Get free Seat.","00002708":"Failed to Get Seat.","00002709":"Failed to Create Seat in Zone.","00002710":"Failed to Find Seat Zone","00002711":"Failed to Get Seat.","00002801":"Failed to Get All Disable Seat.","00002802":"Failed to Create Disable Seat.","00002803":"Failed to Get Zone Information.","00002804":"Failed to Get Disable Seat.","00002805":"Failed to Update Disable Seat.","00002806":"Failed to Get Disable Seat.","00002901":"Failed to Get Event Seat by date.","00002902":"Failed to Add Event Seat Action.","00002903":"Failed to Checkin Event Seat.","00002904":"Failed to Find Event Seat.","00002905":"This Event Seat  is Already Checkin.","00002906":"This Event Seat is Already Cancel.","00002907":"Please Checkin Event Seat  Before Checkout.","00002908":"Time Over, This Event Seat Can't Checkout.","00002909":"Failed to Update Event Seat.","00002910":"Failed to Get Event Seat by Group.","00002911":"Failed to Delete Event Seat.","00003001":"Failed to Create Event Seat Group.","00003002":"Failed to Update Event Seat Group.","00003003":"Failed to Cancel Event Seat Group.","00003004":"Failed to Get Event Seat Group by Id.","00003005":"Failed to Create Event Seat Group. Can't Booking Past Time.","00003006":"Failed to Create Event Seat Group. Can't Booking Same Time.","00003007":"Failed to Create Event Seat Group. Time Over lab.","00003101":"Failed to Register Display.","00003102":"Failed to Get Token Display.","00003103":"Failed to Get Status Display.","00003104":"Failed to Check Status Display.","00003105":"Model Not Match.","00003106":"License Type Not Match.","00003107":"Display Not Register.","00003108":"Failed to Refresh Token.","00003109":"Room Not Found.","00003110":"Failed to Delete Display from Profile Center.","00003111":"Failed to Find Display from Profile Center.","00003112":"Failed to Disable Display from Profile Center.","00003113":"Failed to Find Display .","00003201":"Incorrect parameters.","00003202":"Data Duplicated.","00003203":"Failed to Create IOT Room Config.","00003204":"IOT Controller Over limit.","00003205":"Failed to Delete IOT Room Config.","00003206":"Failed to Delete IOT Room Config from Profile Center.","00003207":"Failed to Find IOT Room Config from Profile Center.","00003301":"Failed to Create Concurrent","00003302":"Failed to Create ios Concurrent","00003303":"Failed to Create androId Concurrent","00003304":"Failed to Refresh Token","00003305":"Failed to Create web Concurrent","00003306":"Failed to auto Refresh Token","00003307":"Failed to Delete Token","00003308":"Failed to Find Token","00003401":"Failed to Find All Role","00003402":"Failed to Create Role","00003403":"Failed to Create Role, This Code's Already in system.","00003404":"Failed to Find Role","00003405":"Failed to Update Role","00003406":"Failed to Delete Role","00003407":"Failed to Delete Role, Some User Use This Role.","00003408":"Failed to Find Role.","00003501":"Failed to Create.","00003502":"Failed to Update.","00003503":"Failed to Delete.","00003504":"Failed to Find by Id.","00003505":"Failed to Find All.","00030000":"Failed to Access Calendar (Access Denied)","00030002":"Failed to Find Calendar Event ","00030003":"Failed to Find Calendar ","00030004":"Failed to Create Calendar Event.","00030005":"Failed to Authorize Calendar Action.","00030006":"Failed to Get Calendar Events.","00030007":"Failed to Map Calendar Event Data.","00030008":"Failed to Get Calendar Event Next.","00030009":"Failed to Get Calendar Event.","00030010":"Failed to Get Calendar Events.","00030011":"Failed to Get Calendar Event Day.","00030012":"Failed to Meet Now Calendar.","00030013":"Failed to Update Calendar Event.","00030014":"Failed to Extend Calendar Event.","00030015":"Failed to Close Calendar Event.","00030016":"Failed to Delete Calendar Event.","00030017":"Failed to Get Calendar Slot.","00030018":"Failed to Watch Calendar Core.","00030019":"Failed to Clean Calendar Slot.","00030020":"Failed to Map Calendar Slot.","00030021":"Failed to Match Calendar Slot.","00030022":"Failed to Make Calendar Slot.","00030023":"Failed to Delete All Event in Calendar.","00030024":"Failed to Get Token Calendar.","00030100":"Failed to Search People.","00030101":"Failed to Get People User Info.","00030102":"Failed to Get People User Photo.","00030103":"Failed to Get All People Users Info.","00030104":"Failed to Get People Users in Organization.","00030200":"Failed to Find Room.","00030201":"Failed to Get Room Status.","00040201":"Failed to Create Background.","00040202":"Failed to Update Background.","00040203":"Failed to Delete Background.","00040204":"Failed to Set Default Background.","00040205":"Failed to Find All Background.","00040206":"Failed to Find Background.","00040301":"Failed to Create Building.","00040302":"Failed to Update Building.","00040303":"Failed to Delete Building.","00040304":"Failed to Get All Building.","00040305":"Failed to Find Building.","00040401":"Failed to Checkin Action.","00040402":"Failed to Authorize Checkin Action.","00040403":"Failed to Find Checkin Action.","00040404":"Failed to Create Checkin Action.","00040601":"Failed to Create Food & Berverage","00040602":"Failed to Update Food & Berverage","00040603":"Failed to Delete Food & Berverage","00040604":"Failed to Find All Food & Berverage","00040605":"Failed to Find Food & Berverage","00040701":"Failed to Create Facilities.","00040702":"Failed to Update Facilities.","00040703":"Failed to Delete Facilities.","00040704":"Failed to Find All Facilities.","00040705":"Failed to Find Facilities.","00040706":"Failed to Create Facilities.; The Specified Facilities's Name is Already Been Used","00040707":"Failed to Update Facilities.; The Specified Facilities's Name is Already Been Used","00040802":"Failed to Create Food & Berverage Category ","00040803":"Failed to Delete Food & Berverage Category ","00040804":"Failed to Get Food & Berverage Category  ","00040901":"Failed to Create Floor.","00040902":"Failed to Update Floor.","00040903":"Failed to Delete Floor.","00040904":"Failed to Get All Floor.","00041001":"Failed to Find Room Info.","00041002":"Failed to Update Room Info.","00041003":"Failed to Delete Room Info Subscription.","00041004":"Failed to Delete Room Info.","00041104":"Failed to Authorize User Action.","00041105":"User Invalid Credentials.","00041106":"Failed to Verify User.","00041107":"Failed to Find User Group Id.","00041108":"Failed to Verify or Find User Company.","00041109":"Failed to Find User Company.","00041110":"Failed to Find or Verify User Profile.","00041111":"Failed to Verify User Profile.","00041201":"Failed to Create User Group.","00041202":"Failed to Update User Group ","00041203":"Failed to Delete User Group.","00041301":"Failed to Create Zone.","00041302":"Failed to Update Zone.","00041303":"Failed to Delete Zone.","00041304":"Failed to Get All Zone.","00020000":"Failed to Access o365 Calendar.","00020001":"Failed to Create o365 Calendar Room.","00020002":"Failed to Find o365 Calendar Event.","00020003":"Failed to Get o365 Calendar Event.","00020004":"Failed to Get o365 Calendar Event by iCalUId. ","00020005":"Failed to Get o365 Calendar Events.","00020006":"Failed to Get o365 Calendar Event Cross of Day.","00020007":"Failed to Find o365 Calendar Event Now.","00020008":"Failed to Get o365 Calendar All Events Cross of Day.","00020009":"Failed to Get o365 Calendar Event Now.","00020010":"Failed to o365 Calendar Next Event.","00020011":"Failed to Get o365 Calendar Next Events.","00020012":"Failed to Get o365 Calendar current Day Events.","00020013":"Failed to Get o365 Calendar Event Day.","00020014":"Failed to Get o365 Calendar Event Day.","00020015":"Failed to Get o365 Calendar Event Between Period.","00020016":"Failed to Get o365 Calendar Event Unique.","00020017":"Failed to Create o365 Calendar Event.","00020018":"Failed to Find o365 Calendar Get Available Slot for Booking.","00020019":"Failed to Create o365 Calendar Meet Now ; Room Busy.","00020020":"Failed to Create o365 Calendar Meet Now.","00020021":"Failed to Meet Now o365 Calendar.","00020022":"Failed to Update o365 Calendar Event.","00020023":"Failed to Extend o365 Calendar Event.","00020024":"Failed to Delete o365 Calendar Event.","00020025":"Failed to Get o365 Calendar Room Status.","00020026":"Failed to Accept o365 Calendar Event.","00020027":"Failed to Tentative o365 Calendar Event.","00020028":"Failed to Decline o365 Calendar Event.","00020029":"Failed to Get o365 Calendar Slot Event.","00020030":"Failed to Get o365 Calendar Slot Between Date.","00020031":"Failed to Verify o365 Calendar SID.","00020032":"Failed to Check out o365 Calendar Event.","00020033":"Failed to Clean o365 Calendar Slot.","00020034":"Failed to Clean o365 Calendar Start Event Before Start Working Time.","00020035":"Failed to Get o365 Calendar Slot Date.","00020036":"Failed to Watch o365 Calendar Core.","00020037":"Failed to load o365 Calendar general Core.","00020038":"Failed to Match o365 Calendar Event.","00020039":"Failed to Make Empty o365 Calendar Slot.","00020040":"Failed to Map o365 Calendar Slot.","00020041":"Failed to Make o365 Calendar.","00020042":"Failed to Match o365 Calendar Slot.","00020043":"Failed to Get o365 Calendar Flightboard Events.","00020044":"Failed to Get o365 Calendar Event Report.","00020045":"Failed to Send o365 Calendar Socket.","00020046":"Failed to Create o365 Calendar Socket.","00020047":"Failed to Close o365 Calendar Event Before Start Event ","00020048":"Action log is Not Found With Your Criteria","00020049":"Failed to Get o365 Calendar Event.","00020050":"Failed to Create o365 Calendar; Room Busy.","00020051":"Failed to Send Mail.","00020052":"The Room you are trying to book Has no VC Available. Please book again.","00020053":"Event Time's up.","00020101":"Failed to Find o365 Meeting.","00020102":"Failed to suggest o365 Meeting.","00020103":"Failed to Find o365 Meeting Empty Room.","00020104":"Failed to Find o365 Meeting Result.","00020105":"Failed to Find o365 Meeting All Events in Day.","00020106":"Failed to Match o365 Meeting Event.","00020107":"Failed to Find o365 Meeting Suggestion.","00020201":"Failed to Get o365 Order by Kitchen.","00020202":"Failed to Get o365 Order Event ","00020203":"Failed to Get o365 Order.","00020301":"Failed to Get o365 People.","00020302":"Failed to Search o365 People.","00020303":"Failed to Get o365 People User Information.","00020304":"Failed to Get o365 People User Image.","00020305":"Failed to Get o365 People User full Information.","00020306":"Failed to Get o365 People Users in Organization.","00020307":"o365 People User Not Integration.","00020401":"Failed to Find o365 Room.","00020402":"Failed to Find o365 Room List.","00020403":"Failed to Get o365 Room Name.","00020404":"Failed to Get o365 Room Information.","00020405":"Failed to Find o365 Room Service.","00020406":"Failed to Find o365 Room Service by AdministratorId.","00020501":"Failed to Find o365 Room List.","00050001":"Failed to Create o365 Noti","00050002":"Failed to Delete o365 Noti","00050003":"Failed to Delete o365 Noti","00050004":"Failed to Create o365 Noti (Can't insert)","00060001":"Failed to Find Exchange Room.","00060002":"Failed to Find Exchange Room List.","00060003":"Failed to Find Exchange People Service.","00060004":"Failed to Create Exchange Calendar Event.","00060005":"Failed to Find Exchange Calendar Event.","00060006":"Failed to Find Exchange Calendar Event.","00060007":"Failed to Find Exchange Calendar All Event.","00060008":"Failed to Update Exchange Calendar Event.","00060009":"Failed to Delete Exchange Calendar Event.","00060010":"Failed to Accept Exchange Calendar Event.","00060011":"Failed to Tentative Exchange Calendar Event.","00060012":"Failed to Decline Exchange Calendar Event.","00060013":"Failed to Find Exchange Subscription.","00060014":"Failed to Find Exchange All Subscriptions.","00060015":"Failed to Create Exchange Subscription.","00060016":"Failed to Delete Exchange Subscription.","00060017":"Failed to Delete Exchange Subscription.","00060018":"Failed to Extend Exchange Subscription.","00060019":"Failed to Unsubscribe Exchange Subscription.","00060020":"Failed to Integrate Exchange People.","00060021":"Failed to Map Exchange Calendar Email.","00060022":"Failed to Find Exchange Calendar Event.","00070001":"Failed to Find o365 Room.","00070002":"Failed to Find o365 People Service.","00070003":"Failed to Find o365 Calendar All Events.","00070004":"Failed to Map o365 Calendar Data.","00070005":"Failed to Request o365 Calendar batching Next Event.","00070006":"Failed to Find o365 Calendar Event.","00070007":"Failed to Find o365 Calendar Event.","00070008":"Failed to Create o365 Calendar Event.","00070009":"Failed to Update o365 Calendar Event.","00070010":"Failed to Delete o365 Calendar Event.","00070011":"Failed to Accept o365 Calendar Event.","00070012":"Failed to Tentative o365 Calendar Event.","00070013":"Failed to Decline o365 Calendar Event.","00070014":"Failed to Find o365 Subscription.","00070015":"Failed to Find o365 All Subscription.","00070016":"Failed to Create o365 Subscription.","00070017":"Failed to Delete o365 Subscription.","00070018":"Failed to Delete o365 Subscription.","00070019":"Failed to Get o365 System Token.","00070020":"Failed to Unsubscribe o365 Subscription.","00070021":"Failed to Extend o365 Subscription.","00070022":"Failed to Integrate o365 Subscription.","00070023":"Failed to Get o365 System Token Data.","00070024":"Failed to Get o365 System Token Data.","00070025":"Failed to Upsert o365 User","00070026":"Failed to Get o365 User Base Model","00070027":"Failed to Send o365 mail","00080001":"Failed to Find Common Calendar Event.","00080002":"Failed to Find Common Calendar Event.","00080003":"Failed to Find Common Calendar All Event.","00080004":"Failed to Create Common Calendar Event.","00080005":"Failed to Get Common Room Service.","00080006":"Failed to Find Common People Service.","00080007":"Failed to Update Common Calendar Event.","00080008":"Failed to Delete Common Calendar Event.","00080009":"Failed to Accept Common Calendar Event.","00080010":"Failed to Tentative Common Calendar Event.","00080011":"Failed to Decline Common Calendar Event.","00080012":"Failed to Find Common Subscription.","00080013":"Failed to Find All Common Subscription.","00080014":"Failed to Create Common Subscription.","00080015":"Failed to Delete Common Subscription.","00080016":"Failed to Delete Common Subscription.","00080017":"Failed to Get Common System Token.","00080018":"Failed to Get Common System Token Data.","00080019":"Failed to Get Common System Token Data.","00080020":"Failed to Get Common System Token Data.","00080021":"Failed to Extend Common Subscription.","00080022":"Failed to Integrate Common People.","00080023":"Failed to Send Mail.","00090001":"Failed to Find Google Room.","00090002":"Failed to Find Google People.","00090003":"Failed to Find Google Calendar Event.","00090004":"Failed to Find Google Calendar Event.","00090005":"Failed to Find Google Calendar All Event.","00090006":"Failed to Create Google Calendar Event.","00090007":"Failed to convert Google Calendar Event format.","00090008":"Failed to Update Google Calendar Event.","00090009":"Failed to Delete Google Calendar Event.","00090010":"Failed to Find Google Subscription.","00090011":"Failed to Find All Google Subscription.","00090012":"Failed to Create Google Subscription.","00090013":"Failed to Delete Google Subscription.","00090014":"Failed to Delete Google Subscription.","00090015":"Failed to Unsubscribe Google Subscription.","00090016":"Failed to Extend Google Subscription.","00090017":"Failed to Accept Google Calendar Event.","00090018":"Failed to Tentative Google Calendar Event.","00090019":"Failed to Decline Google Calendar Event.","00090020":"Failed to Integrate Google People.","00090021":"Failed to Create Google Calendar Recurrence Weekly Event.","00090022":"Failed to Create Google Calendar Recurrence Monthly Event.","00090023":"Failed to Get Common System Token.","00090024":"Failed to Get Common System Token Data.","00090025":"Failed to Get Common System Token Data.","00090026":"Failed to Get User by Email","00100000":"Failed to Get All Hot Seat","00100002":"Failed to Get History Hot Seat","00200000":"Get Re-Set Password Content Fail.","00200001":"Get Forgot Password Content Fail.","00200002":"Get Event PIN Content Fail.","00110000":"Create Conference Fail","00110001":"Update Conference Fail","00110002":"Get Conference by Id Fail","00110003":"Find Conference Fail","00110004":"End Conference Fail","00110005":"Delete Conference Fail","00110006":"Find With Regular Fail"}

/***/ }),

/***/ 1355:
/***/ (function(module, exports) {

module.exports = {"information":"รายละเอียด","mailService":"อีเมล์ บริการ","google":"การเชื่อมต่อบัญชี Google","exchange":"การเชื่อมต่อบัญชี Exchange","noIntegration":"ไม่มีข้อมูล การเชื่อมต่อบัญชี","integrate":"เชื่อมต่อบัญชี","changeConfig":"แก้ไข การเชื่อมต่อบัญชี"}

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(667);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__api__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__api__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__api__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__api__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__api__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__api__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(681);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["s"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setting__ = __webpack_require__(679);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__setting__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__setting__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__setting__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_2__setting__["e"]; });




/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_412", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_465", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_450", function() { return O365_REGISTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_451", function() { return O365_REGISTER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_449", function() { return O365_REGISTER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_432", function() { return O365_LOAD_EVENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_433", function() { return O365_LOAD_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_431", function() { return O365_LOAD_EVENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_435", function() { return O365_LOAD_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_436", function() { return O365_LOAD_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_434", function() { return O365_LOAD_EVENT_FAILURE; });
/* unused harmony export O365_LOAD_EDIT_EVENT_REQUEST */
/* unused harmony export O365_LOAD_EDIT_EVENT_SUCCESS */
/* unused harmony export O365_LOAD_EDIT_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_447", function() { return O365_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_448", function() { return O365_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_446", function() { return O365_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_417", function() { return O365_CREATE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_418", function() { return O365_CREATE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_416", function() { return O365_CREATE_EVENT_FAILURE; });
/* unused harmony export O365_UPDATE_EVENT_REQUEST */
/* unused harmony export O365_UPDATE_EVENT_SUCCESS */
/* unused harmony export O365_UPDATE_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_426", function() { return O365_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_427", function() { return O365_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_425", function() { return O365_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BSRS_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BSRS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSRS_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_463", function() { return PROFILE_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_464", function() { return PROFILE_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_462", function() { return PROFILE_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_414", function() { return O365_ACCEPT_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_415", function() { return O365_ACCEPT_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_413", function() { return O365_ACCEPT_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_456", function() { return O365_TENTATIVE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_457", function() { return O365_TENTATIVE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_455", function() { return O365_TENTATIVE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_423", function() { return O365_DECLINE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_424", function() { return O365_DECLINE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_422", function() { return O365_DECLINE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return CORE_LOAD_ORDERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return CORE_LOAD_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return CORE_LOAD_ORDERS_FAILURE; });
/* unused harmony export CORE_LOAD_ORDER_DETAIL_REQUEST */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_SUCCESS */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_FAILURE */
/* unused harmony export CORE_CHANGE_ORDER_AMOUNT */
/* unused harmony export CORE_UPSERT_ORDERS_REQUEST */
/* unused harmony export CORE_UPSERT_ORDERS_SUCCESS */
/* unused harmony export CORE_UPSERT_ORDERS_FAILURE */
/* unused harmony export CORE_LOAD_CHEKIN_REQUEST */
/* unused harmony export CORE_LOAD_CHEKIN_SUCCESS */
/* unused harmony export CORE_LOAD_CHEKIN_FAILURE */
/* unused harmony export CORE_CREATE_CHECKIN_REQUEST */
/* unused harmony export CORE_CREATE_CHECKIN_SUCCESS */
/* unused harmony export CORE_CREATE_CHECKIN_FAILURE */
/* unused harmony export O365_CHECKOUT_EVENT_REQUEST */
/* unused harmony export O365_CHECKOUT_EVENT_SUCCESS */
/* unused harmony export O365_CHECKOUT_EVENT_FAILURE */
/* unused harmony export O365_LOAD_PEOPLE_REQUEST */
/* unused harmony export O365_LOAD_PEOPLE_SUCCESS */
/* unused harmony export O365_LOAD_PEOPLE_FAILURE */
/* unused harmony export O365_LOAD_LOCATION_REQUEST */
/* unused harmony export O365_LOAD_LOCATION_SUCCESS */
/* unused harmony export O365_LOAD_LOCATION_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return CORE_LOAD_LOCATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return CORE_LOAD_LOCATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return CORE_LOAD_LOCATIONS_FAILURE; });
/* unused harmony export O365_SEARCH_SLOT_REQUEST */
/* unused harmony export O365_SEARCH_SLOT_SUCCESS */
/* unused harmony export O365_SEARCH_SLOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_INTEGRATION_O365_GO_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_INTEGRATION_O365_GO_SAVE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_INTEGRATION_O365_ADD_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_INTEGRATION_O365_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_INTEGRATION_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_INTEGRATION_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_INTEGRATION_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_CREATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_CREATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_CREATE_ROOM_FAILURE; });
/* unused harmony export CORE_LOAD_ROOM_REQUEST */
/* unused harmony export CORE_LOAD_ROOM_SUCCESS */
/* unused harmony export CORE_LOAD_ROOM_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_FIND_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_FIND_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_FIND_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_398", function() { return CORE_UPDATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_399", function() { return CORE_UPDATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_397", function() { return CORE_UPDATE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_DELETE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_DELETE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_DELETE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_429", function() { return O365_DELETE_ROOM_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_430", function() { return O365_DELETE_ROOM_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_428", function() { return O365_DELETE_ROOM_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_420", function() { return O365_CREATE_ROOM_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_421", function() { return O365_CREATE_ROOM_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_419", function() { return O365_CREATE_ROOM_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_441", function() { return O365_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_442", function() { return O365_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_440", function() { return O365_LOAD_ROOMS_FAILURE; });
/* unused harmony export O365_LOAD_ROOMS_INFO_REQUEST */
/* unused harmony export O365_LOAD_ROOMS_INFO_SUCCESS */
/* unused harmony export O365_LOAD_ROOMS_INFO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_444", function() { return O365_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_445", function() { return O365_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_443", function() { return O365_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BSRS_SERVICE_TOKEN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BSRS_SERVICE_TOKEN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BSRS_SERVICE_TOKEN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return CORE_LOAD_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return CORE_LOAD_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return CORE_LOAD_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return CORE_LOAD_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return CORE_LOAD_LOCATIONS_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return CORE_LOAD_LOCATIONS_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return CORE_LOAD_LOCATIONS_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_CREATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_CREATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return CORE_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return CORE_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return CORE_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_299", function() { return CORE_LOAD_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_300", function() { return CORE_LOAD_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return CORE_LOAD_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_407", function() { return CORE_UPDATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_408", function() { return CORE_UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_406", function() { return CORE_UPDATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_DELETE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_DELETE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_DELETE_USER_FAILURE; });
/* unused harmony export CORE_USER_CHANGEPASS_REQUEST */
/* unused harmony export CORE_USER_CHANGEPASS_SUCCESS */
/* unused harmony export CORE_USER_CHANGEPASS_FAILURE */
/* unused harmony export CORE_EDIT_USER_REQUEST */
/* unused harmony export CORE_EDIT_USER_SUCCESS */
/* unused harmony export CORE_EDIT_USER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return CORE_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_298", function() { return CORE_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return CORE_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_GET_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_GET_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_GET_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return CORE_LOAD_SETTING_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return CORE_LOAD_SETTING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return CORE_LOAD_SETTING_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CHANGE_SETTING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CHANGE_SETTING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CHANGE_SETTING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return CORE_LOAD_USERREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return CORE_LOAD_USERREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return CORE_LOAD_USERREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return CORE_LOAD_ROOMREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return CORE_LOAD_ROOMREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return CORE_LOAD_ROOMREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return CORE_LOAD_USERSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return CORE_LOAD_USERSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return CORE_LOAD_USERSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return CORE_LOAD_ROOMSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return CORE_LOAD_ROOMSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return CORE_LOAD_ROOMSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return CORE_LOAD_REPORTSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return CORE_LOAD_REPORTSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return CORE_LOAD_REPORTSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_LOAD_ALLAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_LOAD_ALLAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_LOAD_ALLAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_DELETE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_DELETE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_DELETE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return CORE_LOAD_AMENITYINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return CORE_LOAD_AMENITYINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return CORE_LOAD_AMENITYINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_CREATE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_CREATE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CREATE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_347", function() { return CORE_UPDATE_AMENITYINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_348", function() { return CORE_UPDATE_AMENITYINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_346", function() { return CORE_UPDATE_AMENITYINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return CORE_LOAD_ALL_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return CORE_LOAD_ALL_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return CORE_LOAD_ALL_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return CORE_LOAD_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return CORE_LOAD_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return CORE_LOAD_PROFILE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_CREATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_CREATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_CREATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_389", function() { return CORE_UPDATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_390", function() { return CORE_UPDATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_388", function() { return CORE_UPDATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_DELETE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_DELETE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_DELETE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return CORE_LOAD_USERGROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return CORE_LOAD_USERGROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return CORE_LOAD_USERGROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return CORE_LOAD_LIST_USERGROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return CORE_LOAD_LIST_USERGROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return CORE_LOAD_LIST_USERGROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return CORE_LOAD_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return CORE_LOAD_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return CORE_LOAD_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_CREATE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_CREATE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_CREATE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_404", function() { return CORE_UPDATE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_405", function() { return CORE_UPDATE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_403", function() { return CORE_UPDATE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_DELETE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_DELETE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_DELETE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_LOAD_ACTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_LOAD_ACTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_LOAD_ACTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_LOAD_ALLFBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_LOAD_ALLFBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_LOAD_ALLFBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_DELETE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_DELETE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_DELETE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return CORE_LOAD_FBSINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return CORE_LOAD_FBSINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return CORE_LOAD_FBSINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_CREATE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_CREATE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_CREATE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_374", function() { return CORE_UPDATE_FBSINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_375", function() { return CORE_UPDATE_FBSINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_373", function() { return CORE_UPDATE_FBSINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_GET_INTEGRATION_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_GET_INTEGRATION_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_GET_INTEGRATION_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return CORE_LOAD_STATUSUSER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return CORE_LOAD_STATUSUSER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return CORE_LOAD_STATUSUSER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return CORE_LOAD_USERSUM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return CORE_LOAD_USERSUM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return CORE_LOAD_USERSUM_FAILURE; });
/* unused harmony export CORE_LOAD_ROOMSUM_REQUEST */
/* unused harmony export CORE_LOAD_ROOMSUM_SUCCESS */
/* unused harmony export CORE_LOAD_ROOMSUM_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return CORE_LOAD_ROOMTEMP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return CORE_LOAD_ROOMTEMP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return CORE_LOAD_ROOMTEMP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return CORE_LOAD_TOPROOMRESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return CORE_LOAD_TOPROOMRESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return CORE_LOAD_TOPROOMRESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return CORE_LOAD_TOPUSERRESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return CORE_LOAD_TOPUSERRESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return CORE_LOAD_TOPUSERRESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return CORE_LOAD_ROOMDETAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return CORE_LOAD_ROOMDETAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return CORE_LOAD_ROOMDETAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return CORE_LOAD_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return CORE_LOAD_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return CORE_LOAD_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_401", function() { return CORE_UPDATE_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_402", function() { return CORE_UPDATE_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_400", function() { return CORE_UPDATE_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return CORE_LOAD_FAQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return CORE_LOAD_FAQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return CORE_LOAD_FAQ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_371", function() { return CORE_UPDATE_FAQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_372", function() { return CORE_UPDATE_FAQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_370", function() { return CORE_UPDATE_FAQ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return CORE_LOAD_CONTACT_US_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return CORE_LOAD_CONTACT_US_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return CORE_LOAD_CONTACT_US_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_356", function() { return CORE_UPDATE_CONTACT_US_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_357", function() { return CORE_UPDATE_CONTACT_US_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_355", function() { return CORE_UPDATE_CONTACT_US_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return CORE_LOAD_REPORTROOMSTATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return CORE_LOAD_REPORTROOMSTATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return CORE_LOAD_REPORTROOMSTATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return CORE_LOAD_ALL_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return CORE_LOAD_ALL_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return CORE_LOAD_ALL_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_LOAD_ALLBUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_LOAD_ALLBUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_LOAD_ALLBUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_DELETE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_DELETE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_DELETE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return CORE_LOAD_BUILDINGINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return CORE_LOAD_BUILDINGINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return CORE_LOAD_BUILDINGINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_353", function() { return CORE_UPDATE_BUILDINGINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_354", function() { return CORE_UPDATE_BUILDINGINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_352", function() { return CORE_UPDATE_BUILDINGINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_CREATE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_CREATE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_CREATE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_LOAD_ALLFLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_LOAD_ALLFLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_LOAD_ALLFLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_DELETE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_DELETE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_DELETE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return CORE_LOAD_FLOORINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return CORE_LOAD_FLOORINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return CORE_LOAD_FLOORINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_380", function() { return CORE_UPDATE_FLOORINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_381", function() { return CORE_UPDATE_FLOORINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_379", function() { return CORE_UPDATE_FLOORINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_CREATE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_CREATE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_CREATE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_LOAD_ALLZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_LOAD_ALLZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_LOAD_ALLZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_DELETE_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_DELETE_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_DELETE_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_305", function() { return CORE_LOAD_ZONEINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_306", function() { return CORE_LOAD_ZONEINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_304", function() { return CORE_LOAD_ZONEINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_410", function() { return CORE_UPDATE_ZONEINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_411", function() { return CORE_UPDATE_ZONEINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_409", function() { return CORE_UPDATE_ZONEINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_CREATE_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_CREATE_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_CREATE_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_LOAD_ALLBACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_LOAD_ALLBACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_LOAD_ALLBACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_DELETE_BACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_DELETE_BACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_DELETE_BACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return CORE_LOAD_BACKGROUNDINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return CORE_LOAD_BACKGROUNDINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return CORE_LOAD_BACKGROUNDINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_350", function() { return CORE_UPDATE_BACKGROUNDINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_351", function() { return CORE_UPDATE_BACKGROUNDINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_349", function() { return CORE_UPDATE_BACKGROUNDINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_CREATE_BACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_CREATE_BACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_CREATE_BACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_359", function() { return CORE_UPDATE_DEFAULTBACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_360", function() { return CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_358", function() { return CORE_UPDATE_DEFAULTBACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_GET_CATEGORY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_GET_CATEGORY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_GET_CATEGORY_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_377", function() { return CORE_UPDATE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_378", function() { return CORE_UPDATE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_376", function() { return CORE_UPDATE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_CREATE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_CREATE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_CREATE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_DELETE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_DELETE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_DELETE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return CORE_LOAD_ALL_USERSAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return CORE_LOAD_ALL_USERSAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return CORE_LOAD_ALL_USERSAD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CHECK_AD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CHECK_AD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CHECK_AD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CHECK_TMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CHECK_TMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CHECK_TMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CHECK_CMR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CHECK_CMR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CHECK_CMR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CHECK_BOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CHECK_BOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CHECK_BOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return CORE_LOAD_TIMEZOZE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return CORE_LOAD_TIMEZOZE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return CORE_LOAD_TIMEZOZE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_EDIT_GOOGLE_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_EDIT_GOOGLE_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_329", function() { return CORE_SEARCH_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_330", function() { return CORE_SEARCH_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_328", function() { return CORE_SEARCH_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_326", function() { return CORE_SEARCH_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_327", function() { return CORE_SEARCH_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_325", function() { return CORE_SEARCH_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_335", function() { return CORE_SEARCH_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_336", function() { return CORE_SEARCH_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_334", function() { return CORE_SEARCH_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_332", function() { return CORE_SEARCH_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_333", function() { return CORE_SEARCH_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_331", function() { return CORE_SEARCH_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_323", function() { return CORE_SEARCH_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_324", function() { return CORE_SEARCH_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_322", function() { return CORE_SEARCH_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CHECKIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CHECKIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CHECKIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CHECKOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CHECKOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CHECKOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_308", function() { return CORE_RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_309", function() { return CORE_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_307", function() { return CORE_RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return CORE_LOAD_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return CORE_LOAD_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return CORE_LOAD_DISPLAY_FAILURE; });
/* unused harmony export CORE_GET_DISPLAY_INFO_REQUEST */
/* unused harmony export CORE_GET_DISPLAY_INFO_SUCCESS */
/* unused harmony export CORE_GET_DISPLAY_INFO_FAILURE */
/* unused harmony export CORE_CREATE_DISPLAY_REQUEST */
/* unused harmony export CORE_CREATE_DISPLAY_SUCCESS */
/* unused harmony export CORE_CREATE_DISPLAY_FAILURE */
/* unused harmony export CORE_DELETE_DISPLAY_REQUEST */
/* unused harmony export CORE_DELETE_DISPLAY_SUCCESS */
/* unused harmony export CORE_DELETE_DISPLAY_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_362", function() { return CORE_UPDATE_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_363", function() { return CORE_UPDATE_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_361", function() { return CORE_UPDATE_DISPLAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_458", function() { return PROFILE_CENTER_LOAD_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_459", function() { return PROFILE_CENTER_LOAD_INFO_SUCCESS; });
/* unused harmony export PROFILE_CENTER_LOAD_INFO_FAILURE */
/* unused harmony export PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST */
/* unused harmony export PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS */
/* unused harmony export PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_460", function() { return PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_461", function() { return PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS; });
/* unused harmony export PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return CORE_LOAD_ALL_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return CORE_LOAD_ALL_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return CORE_LOAD_ALL_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return CORE_LOAD_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return CORE_LOAD_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return CORE_LOAD_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_CREATE_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_CREATE_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_CREATE_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_395", function() { return CORE_UPDATE_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_396", function() { return CORE_UPDATE_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_394", function() { return CORE_UPDATE_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_DELETE_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_DELETE_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_DELETE_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_302", function() { return CORE_LOAD_VC_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_303", function() { return CORE_LOAD_VC_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_301", function() { return CORE_LOAD_VC_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return CORE_LOAD_CONCURRENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return CORE_LOAD_CONCURRENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return CORE_LOAD_CONCURRENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_DELETE_CONCURRENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_DELETE_CONCURRENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_DELETE_CONCURRENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return CORE_LOAD_ROLES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return CORE_LOAD_ROLES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return CORE_LOAD_ROLES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_CREATE_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_CREATE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_CREATE_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return CORE_LOAD_ROLE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return CORE_LOAD_ROLE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return CORE_LOAD_ROLE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_392", function() { return CORE_UPDATE_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_393", function() { return CORE_UPDATE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_391", function() { return CORE_UPDATE_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_DELETE_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_DELETE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_DELETE_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_368", function() { return CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_369", function() { return CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_367", function() { return CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return CORE_LOAD_ORDER_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return CORE_LOAD_ORDER_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return CORE_LOAD_ORDER_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_DELETE_ORDER_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_DELETE_ORDER_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_DELETE_ORDER_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return CORE_LOAD_ORDER_FBS_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return CORE_LOAD_ORDER_FBS_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return CORE_LOAD_ORDER_FBS_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_386", function() { return CORE_UPDATE_ORDER_FBS_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_387", function() { return CORE_UPDATE_ORDER_FBS_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_385", function() { return CORE_UPDATE_ORDER_FBS_INFO_FAILURE; });
/* unused harmony export CORE_CREATE_ORDER_FBS_REQUEST */
/* unused harmony export CORE_CREATE_ORDER_FBS_SUCCESS */
/* unused harmony export CORE_CREATE_ORDER_FBS_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return CORE_LOAD_ORDER_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return CORE_LOAD_ORDER_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return CORE_LOAD_ORDER_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_DELETE_ORDER_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_DELETE_ORDER_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_DELETE_ORDER_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return CORE_LOAD_ORDER_AMENITY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return CORE_LOAD_ORDER_AMENITY_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_383", function() { return CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_384", function() { return CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_382", function() { return CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_438", function() { return O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_439", function() { return O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_437", function() { return O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_CREATE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_CREATE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_CREATE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return CORE_LOAD_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return CORE_LOAD_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return CORE_LOAD_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return CORE_LOAD_EVENTTYPE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return CORE_LOAD_EVENTTYPE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return CORE_LOAD_EVENTTYPE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_CREATE_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_CREATE_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_CREATE_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_365", function() { return CORE_UPDATE_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_366", function() { return CORE_UPDATE_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_364", function() { return CORE_UPDATE_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_DELETE_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_DELETE_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_DELETE_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_341", function() { return CORE_UNREGISTER_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_342", function() { return CORE_UNREGISTER_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_340", function() { return CORE_UNREGISTER_DISPLAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_344", function() { return CORE_UNREGISTER_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_345", function() { return CORE_UNREGISTER_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_343", function() { return CORE_UNREGISTER_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_IMPORT_USER_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_IMPORT_USER_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_IMPORT_USER_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_338", function() { return CORE_SYNC_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_339", function() { return CORE_SYNC_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_337", function() { return CORE_SYNC_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_LOAD_ALL_AD_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return CORE_LOAD_ALL_AD_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_LOAD_ALL_AD_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_IMPORT_USER_AD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_IMPORT_USER_AD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_IMPORT_USER_AD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_311", function() { return CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_312", function() { return CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_310", function() { return CORE_SEARCH_ALL_FBS_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_317", function() { return CORE_SEARCH_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_318", function() { return CORE_SEARCH_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_316", function() { return CORE_SEARCH_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_314", function() { return CORE_SEARCH_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_315", function() { return CORE_SEARCH_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_313", function() { return CORE_SEARCH_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_320", function() { return CORE_SEARCH_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_321", function() { return CORE_SEARCH_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_319", function() { return CORE_SEARCH_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_453", function() { return O365_RESEND_EVENT_PIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_454", function() { return O365_RESEND_EVENT_PIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_452", function() { return O365_RESEND_EVENT_PIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return CORE_LOAD_INTEGRATION_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return CORE_LOAD_INTEGRATION_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return CORE_LOAD_INTEGRATION_DATA_FAILURE; });
var LOGOUT = 'LOGOUT';
var SET_ERROR = 'SET_ERROR';

var O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST';
var O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS';
var O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE';

var O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST';
var O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS';
var O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE';

var O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST';
var O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS';
var O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE';

var O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST';
var O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS';
var O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE';

var O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST';
var O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS';
var O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE';

var O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST';
var O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS';
var O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE';

var O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST';
var O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS';
var O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE';

var O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST';
var O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS';
var O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE';

var BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST';
var BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS';
var BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE';

var PROFILE_LOGIN_REQUEST = 'PROFILE_LOGIN_REQUEST';
var PROFILE_LOGIN_SUCCESS = 'PROFILE_LOGIN_SUCCESS';
var PROFILE_LOGIN_FAILURE = 'PROFILE_LOGIN_FAILURE';

var O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST';
var O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS';
var O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE';

var O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST';
var O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS';
var O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE';

var O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST';
var O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS';
var O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE';

var CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST';
var CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS';
var CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE';

var CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST';
var CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS';
var CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE';

var CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT';

var CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST';
var CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS';
var CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE';

var CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST';
var CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS';
var CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE';

var CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST';
var CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS';
var CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE';

var O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST';
var O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS';
var O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE';

var O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST';
var O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS';
var O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE';

var O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST';
var O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS';
var O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE';

var CORE_LOAD_LOCATIONS_REQUEST = 'CORE_LOAD_LOCATIONS_REQUEST';
var CORE_LOAD_LOCATIONS_SUCCESS = 'CORE_LOAD_LOCATIONS_SUCCESS';
var CORE_LOAD_LOCATIONS_FAILURE = 'CORE_LOAD_LOCATIONS_FAILURE';

var O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST';
var O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS';
var O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE';

var CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_GO_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_GO_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_GO_SAVE_DATA = 'CORE_INTEGRATION_O365_GO_SAVE_DATA';

var CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST';
var CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS';
var CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE';

var CORE_CREATE_ROOM_REQUEST = 'CORE_CREATE_ROOM_REQUEST';
var CORE_CREATE_ROOM_SUCCESS = 'CORE_CREATE_ROOM_SUCCESS';
var CORE_CREATE_ROOM_FAILURE = 'CORE_CREATE_ROOM_FAILURE';

var CORE_LOAD_ROOM_REQUEST = 'CORE_LOAD_ROOM_REQUEST';
var CORE_LOAD_ROOM_SUCCESS = 'CORE_LOAD_ROOM_SUCCESS';
var CORE_LOAD_ROOM_FAILURE = 'CORE_LOAD_ROOM_FAILURE';

var CORE_FIND_ROOM_REQUEST = 'CORE_FIND_ROOM_REQUEST';
var CORE_FIND_ROOM_SUCCESS = 'CORE_FIND_ROOM_SUCCESS';
var CORE_FIND_ROOM_FAILURE = 'CORE_FIND_ROOM_FAILURE';

var CORE_UPDATE_ROOM_REQUEST = 'CORE_UPDATE_ROOM_REQUEST';
var CORE_UPDATE_ROOM_SUCCESS = 'CORE_UPDATE_ROOM_SUCCESS';
var CORE_UPDATE_ROOM_FAILURE = 'CORE_UPDATE_ROOM_FAILURE';

var CORE_DELETE_ROOM_REQUEST = 'CORE_DELETE_ROOM_REQUEST';
var CORE_DELETE_ROOM_SUCCESS = 'CORE_DELETE_ROOM_SUCCESS';
var CORE_DELETE_ROOM_FAILURE = 'CORE_DELETE_ROOM_FAILURE';

var O365_DELETE_ROOM_SUBSCRIBE_REQUEST = 'O365_DELETE_ROOM_SUBSCRIBE_REQUEST';
var O365_DELETE_ROOM_SUBSCRIBE_SUCCESS = 'O365_DELETE_ROOM_SUBSCRIBE_SUCCESS';
var O365_DELETE_ROOM_SUBSCRIBE_FAILURE = 'O365_DELETE_ROOM_SUBSCRIBE_FAILURE';

var O365_CREATE_ROOM_SUBSCRIBE_REQUEST = 'O365_CREATE_ROOM_SUBSCRIBE_REQUEST';
var O365_CREATE_ROOM_SUBSCRIBE_SUCCESS = 'O365_CREATE_ROOM_SUBSCRIBE_SUCCESS';
var O365_CREATE_ROOM_SUBSCRIBE_FAILURE = 'O365_CREATE_ROOM_SUBSCRIBE_FAILURE';

var O365_LOAD_ROOMS_REQUEST = 'O365_LOAD_ROOMS_REQUEST';
var O365_LOAD_ROOMS_SUCCESS = 'O365_LOAD_ROOMS_SUCCESS';
var O365_LOAD_ROOMS_FAILURE = 'O365_LOAD_ROOMS_FAILURE';

var O365_LOAD_ROOMS_INFO_REQUEST = 'O365_LOAD_ROOMS_INFO_REQUEST';
var O365_LOAD_ROOMS_INFO_SUCCESS = 'O365_LOAD_ROOMS_INFO_SUCCESS';
var O365_LOAD_ROOMS_INFO_FAILURE = 'O365_LOAD_ROOMS_INFO_FAILURE';

var O365_LOAD_USERS_REQUEST = 'O365_LOAD_USERS_REQUEST';
var O365_LOAD_USERS_SUCCESS = 'O365_LOAD_USERS_SUCCESS';
var O365_LOAD_USERS_FAILURE = 'O365_LOAD_USERS_FAILURE';

var BSRS_SERVICE_TOKEN_REQUEST = 'BSRS_SERVICE_TOKEN_REQUEST';
var BSRS_SERVICE_TOKEN_SUCCESS = 'BSRS_SERVICE_TOKEN_SUCCESS';
var BSRS_SERVICE_TOKEN_FAILURE = 'BSRS_SERVICE_TOKEN_FAILURE';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

var CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST = 'CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST';
var CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS = 'CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS';
var CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE = 'CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE';

var CORE_LOAD_REPORT_REQUEST = 'CORE_LOAD_REPORT_REQUEST';
var CORE_LOAD_REPORT_SUCCESS = 'CORE_LOAD_REPORT_SUCCESS';
var CORE_LOAD_REPORT_FAILURE = 'CORE_LOAD_REPORT_FAILURE';

var CORE_LOAD_LOCATIONS_REPORT_REQUEST = 'CORE_LOAD_LOCATIONS_REPORT_REQUEST';
var CORE_LOAD_LOCATIONS_REPORT_SUCCESS = 'CORE_LOAD_LOCATIONS_REPORT_SUCCESS';
var CORE_LOAD_LOCATIONS_REPORT_FAILURE = 'CORE_LOAD_LOCATIONS_REPORT_FAILURE';

var CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST';
var CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS';
var CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE';

var CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST';
var CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS';
var CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE';

var CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST';
var CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS';
var CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE';

var CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST';
var CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS';
var CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE';

var CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST';
var CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS';
var CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE';

var CORE_USER_CHANGEPASS_REQUEST = 'CORE_USER_CHANGEPASS_REQUEST';
var CORE_USER_CHANGEPASS_SUCCESS = 'CORE_USER_CHANGEPASS_SUCCESS';
var CORE_USER_CHANGEPASS_FAILURE = 'CORE_USER_CHANGEPASS_FAILURE';

var CORE_EDIT_USER_REQUEST = 'CORE_EDIT_USER_REQUEST';
var CORE_EDIT_USER_SUCCESS = 'CORE_EDIT_USER_SUCCESS';
var CORE_EDIT_USER_FAILURE = 'CORE_EDIT_USER_FAILURE';

var CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST';
var CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS';
var CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE';

var CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST';
var CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS';
var CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE';

var CORE_GET_INTEGRATION_REQUEST = 'CORE_GET_INTEGRATION_REQUEST';
var CORE_GET_INTEGRATION_SUCCESS = 'CORE_GET_INTEGRATION_SUCCESS';
var CORE_GET_INTEGRATION_FAILURE = 'CORE_GET_INTEGRATION_FAILURE';

var CORE_LOAD_SETTING_INFO_REQUEST = 'CORE_LOAD_SETTING_INFO_REQUEST';
var CORE_LOAD_SETTING_INFO_SUCCESS = 'CORE_LOAD_SETTING_INFO_SUCCESS';
var CORE_LOAD_SETTING_INFO_FAILURE = 'CORE_LOAD_SETTING_INFO_FAILURE';

var CORE_CHANGE_SETTING_REQUEST = 'CORE_CHANGE_SETTING_REQUEST';
var CORE_CHANGE_SETTING_SUCCESS = 'CORE_CHANGE_SETTING_SUCCESS';
var CORE_CHANGE_SETTING_FAILURE = 'CORE_CHANGE_SETTING_FAILURE';

var CORE_LOAD_USERREPORT_REQUEST = 'CORE_LOAD_USERREPORT_REQUEST';
var CORE_LOAD_USERREPORT_SUCCESS = 'CORE_LOAD_USERREPORT_SUCCESS';
var CORE_LOAD_USERREPORT_FAILURE = 'CORE_LOAD_USERREPORT_FAILURE';

var CORE_LOAD_ROOMREPORT_REQUEST = 'CORE_LOAD_ROOMREPORT_REQUEST';
var CORE_LOAD_ROOMREPORT_SUCCESS = 'CORE_LOAD_ROOMREPORT_SUCCESS';
var CORE_LOAD_ROOMREPORT_FAILURE = 'CORE_LOAD_ROOMREPORT_FAILURE';

var CORE_LOAD_USERSUMMARY_REQUEST = 'CORE_LOAD_USERSUMMARY_REQUEST';
var CORE_LOAD_USERSUMMARY_SUCCESS = 'CORE_LOAD_USERSUMMARY_SUCCESS';
var CORE_LOAD_USERSUMMARY_FAILURE = 'CORE_LOAD_USERSUMMARY_FAILURE';

var CORE_LOAD_ROOMSUMMARY_REQUEST = 'CORE_LOAD_ROOMSUMMARY_REQUEST';
var CORE_LOAD_ROOMSUMMARY_SUCCESS = 'CORE_LOAD_ROOMSUMMARY_SUCCESS';
var CORE_LOAD_ROOMSUMMARY_FAILURE = 'CORE_LOAD_ROOMSUMMARY_FAILURE';

var CORE_LOAD_REPORTSUMMARY_REQUEST = 'CORE_LOAD_REPORTSUMMARY_REQUEST';
var CORE_LOAD_REPORTSUMMARY_SUCCESS = 'CORE_LOAD_REPORTSUMMARY_SUCCESS';
var CORE_LOAD_REPORTSUMMARY_FAILURE = 'CORE_LOAD_REPORTSUMMARY_FAILURE';

var CORE_LOAD_ALLAMENITY_REQUEST = 'CORE_LOAD_ALLAMENITY_REQUEST';
var CORE_LOAD_ALLAMENITY_SUCCESS = 'CORE_LOAD_ALLAMENITY_SUCCESS';
var CORE_LOAD_ALLAMENITY_FAILURE = 'CORE_LOAD_ALLAMENITY_FAILURE';

var CORE_DELETE_AMENITY_REQUEST = 'CORE_DELETE_AMENITY_REQUEST';
var CORE_DELETE_AMENITY_SUCCESS = 'CORE_DELETE_AMENITY_SUCCESS';
var CORE_DELETE_AMENITY_FAILURE = 'CORE_DELETE_AMENITY_FAILURE';

var CORE_LOAD_AMENITYINFO_REQUEST = 'CORE_LOAD_AMENITYINFO_REQUEST';
var CORE_LOAD_AMENITYINFO_SUCCESS = 'CORE_LOAD_AMENITYINFO_SUCCESS';
var CORE_LOAD_AMENITYINFO_FAILURE = 'CORE_LOAD_AMENITYINFO_FAILURE';

var CORE_CREATE_AMENITY_REQUEST = 'CORE_CREATE_AMENITY_REQUEST';
var CORE_CREATE_AMENITY_SUCCESS = 'CORE_CREATE_AMENITY_SUCCESS';
var CORE_CREATE_AMENITY_FAILURE = 'CORE_CREATE_AMENITY_FAILURE';

var CORE_UPDATE_AMENITYINFO_REQUEST = 'CORE_UPDATE_AMENITYINFO_REQUEST';
var CORE_UPDATE_AMENITYINFO_SUCCESS = 'CORE_UPDATE_AMENITYINFO_SUCCESS';
var CORE_UPDATE_AMENITYINFO_FAILURE = 'CORE_UPDATE_AMENITYINFO_FAILURE';

var CORE_LOAD_ALL_PROFILE_REQUEST = 'CORE_LOAD_ALL_PROFILE_REQUEST';
var CORE_LOAD_ALL_PROFILE_SUCCESS = 'CORE_LOAD_ALL_PROFILE_SUCCESS';
var CORE_LOAD_ALL_PROFILE_FAILURE = 'CORE_LOAD_ALL_PROFILE_FAILURE';

var CORE_LOAD_PROFILE_INFO_REQUEST = 'CORE_LOAD_PROFILE_INFO_REQUEST';
var CORE_LOAD_PROFILE_INFO_SUCCESS = 'CORE_LOAD_PROFILE_INFO_SUCCESS';
var CORE_LOAD_PROFILE_INFO_FAILURE = 'CORE_LOAD_PROFILE_INFO_FAILURE';

var CORE_CREATE_PROFILE_REQUEST = 'CORE_CREATE_PROFILE_REQUEST';
var CORE_CREATE_PROFILE_SUCCESS = 'CORE_CREATE_PROFILE_SUCCESS';
var CORE_CREATE_PROFILE_FAILURE = 'CORE_CREATE_PROFILE_FAILURE';

var CORE_UPDATE_PROFILE_REQUEST = 'CORE_UPDATE_PROFILE_REQUEST';
var CORE_UPDATE_PROFILE_SUCCESS = 'CORE_UPDATE_PROFILE_SUCCESS';
var CORE_UPDATE_PROFILE_FAILURE = 'CORE_UPDATE_PROFILE_FAILURE';

var CORE_DELETE_PROFILE_REQUEST = 'CORE_DELETE_PROFILE_REQUEST';
var CORE_DELETE_PROFILE_SUCCESS = 'CORE_DELETE_PROFILE_SUCCESS';
var CORE_DELETE_PROFILE_FAILURE = 'CORE_DELETE_PROFILE_FAILURE';

var CORE_LOAD_USERGROUPS_REQUEST = 'CORE_LOAD_USERGROUPS_REQUEST';
var CORE_LOAD_USERGROUPS_SUCCESS = 'CORE_LOAD_USERGROUPS_SUCCESS';
var CORE_LOAD_USERGROUPS_FAILURE = 'CORE_LOAD_USERGROUPS_FAILURE';

var CORE_LOAD_LIST_USERGROUPS_REQUEST = 'CORE_LOAD_LIST_USERGROUPS_REQUEST';
var CORE_LOAD_LIST_USERGROUPS_SUCCESS = 'CORE_LOAD_LIST_USERGROUPS_SUCCESS';
var CORE_LOAD_LIST_USERGROUPS_FAILURE = 'CORE_LOAD_LIST_USERGROUPS_FAILURE';

var CORE_LOAD_USERGROUP_REQUEST = 'CORE_LOAD_USERGROUP_REQUEST';
var CORE_LOAD_USERGROUP_SUCCESS = 'CORE_LOAD_USERGROUP_SUCCESS';
var CORE_LOAD_USERGROUP_FAILURE = 'CORE_LOAD_USERGROUP_FAILURE';

var CORE_CREATE_USERGROUP_REQUEST = 'CORE_CREATE_USERGROUP_REQUEST';
var CORE_CREATE_USERGROUP_SUCCESS = 'CORE_CREATE_USERGROUP_SUCCESS';
var CORE_CREATE_USERGROUP_FAILURE = 'CORE_CREATE_USERGROUP_FAILURE';

var CORE_UPDATE_USERGROUP_REQUEST = 'CORE_UPDATE_USERGROUP_REQUEST';
var CORE_UPDATE_USERGROUP_SUCCESS = 'CORE_UPDATE_USERGROUP_SUCCESS';
var CORE_UPDATE_USERGROUP_FAILURE = 'CORE_UPDATE_USERGROUP_FAILURE';

var CORE_DELETE_USERGROUP_REQUEST = 'CORE_DELETE_USERGROUP_REQUEST';
var CORE_DELETE_USERGROUP_SUCCESS = 'CORE_DELETE_USERGROUP_SUCCESS';
var CORE_DELETE_USERGROUP_FAILURE = 'CORE_DELETE_USERGROUP_FAILURE';

var CORE_LOAD_ACTIONS_REQUEST = 'CORE_LOAD_ACTIONS_REQUEST';
var CORE_LOAD_ACTIONS_SUCCESS = 'CORE_LOAD_ACTIONS_SUCCESS';
var CORE_LOAD_ACTIONS_FAILURE = 'CORE_LOAD_ACTIONS_FAILURE';

var CORE_LOAD_ALLFBS_REQUEST = 'CORE_LOAD_ALLFBS_REQUEST';
var CORE_LOAD_ALLFBS_SUCCESS = 'CORE_LOAD_ALLFBS_SUCCESS';
var CORE_LOAD_ALLFBS_FAILURE = 'CORE_LOAD_ALLFBS_FAILURE';

var CORE_DELETE_FBS_REQUEST = 'CORE_DELETE_FBS_REQUEST';
var CORE_DELETE_FBS_SUCCESS = 'CORE_DELETE_FBS_SUCCESS';
var CORE_DELETE_FBS_FAILURE = 'CORE_DELETE_FBS_FAILURE';

var CORE_LOAD_FBSINFO_REQUEST = 'CORE_LOAD_FBSINFO_REQUEST';
var CORE_LOAD_FBSINFO_SUCCESS = 'CORE_LOAD_FBSINFO_SUCCESS';
var CORE_LOAD_FBSINFO_FAILURE = 'CORE_LOAD_FBSINFO_FAILURE';

var CORE_CREATE_FBS_REQUEST = 'CORE_CREATE_FBS_REQUEST';
var CORE_CREATE_FBS_SUCCESS = 'CORE_CREATE_FBS_SUCCESS';
var CORE_CREATE_FBS_FAILURE = 'CORE_CREATE_FBS_FAILURE';

var CORE_UPDATE_FBSINFO_REQUEST = 'CORE_UPDATE_FBSINFO_REQUEST';
var CORE_UPDATE_FBSINFO_SUCCESS = 'CORE_UPDATE_FBSINFO_SUCCESS';
var CORE_UPDATE_FBSINFO_FAILURE = 'CORE_UPDATE_FBSINFO_FAILURE';

var CORE_GET_INTEGRATION_INFO_REQUEST = 'CORE_GET_INTEGRATION_INFO_REQUEST';
var CORE_GET_INTEGRATION_INFO_SUCCESS = 'CORE_GET_INTEGRATION_INFO_SUCCESS';
var CORE_GET_INTEGRATION_INFO_FAILURE = 'CORE_GET_INTEGRATION_INFO_FAILURE';

var CORE_LOAD_STATUSUSER_REQUEST = 'CORE_LOAD_STATUSUSER_REQUEST';
var CORE_LOAD_STATUSUSER_SUCCESS = 'CORE_LOAD_STATUSUSER_SUCCESS';
var CORE_LOAD_STATUSUSER_FAILURE = 'CORE_LOAD_STATUSUSER_FAILURE';

var CORE_LOAD_USERSUM_REQUEST = 'CORE_LOAD_USERSUM_REQUEST';
var CORE_LOAD_USERSUM_SUCCESS = 'CORE_LOAD_USERSUM_SUCCESS';
var CORE_LOAD_USERSUM_FAILURE = 'CORE_LOAD_USERSUM_FAILURE';

var CORE_LOAD_ROOMSUM_REQUEST = 'CORE_LOAD_ROOMSUM_REQUEST';
var CORE_LOAD_ROOMSUM_SUCCESS = 'CORE_LOAD_ROOMSUM_SUCCESS';
var CORE_LOAD_ROOMSUM_FAILURE = 'CORE_LOAD_ROOMSUM_FAILURE';

var CORE_LOAD_ROOMTEMP_REQUEST = 'CORE_LOAD_ROOMTEMP_REQUEST';
var CORE_LOAD_ROOMTEMP_SUCCESS = 'CORE_LOAD_ROOMTEMP_SUCCESS';
var CORE_LOAD_ROOMTEMP_FAILURE = 'CORE_LOAD_ROOMTEMP_FAILURE';

var CORE_LOAD_TOPROOMRESERVE_REQUEST = 'CORE_LOAD_TOPROOMRESERVE_REQUEST';
var CORE_LOAD_TOPROOMRESERVE_SUCCESS = 'CORE_LOAD_TOPROOMRESERVE_SUCCESS';
var CORE_LOAD_TOPROOMRESERVE_FAILURE = 'CORE_LOAD_TOPROOMRESERVE_FAILURE';

var CORE_LOAD_TOPUSERRESERVE_REQUEST = 'CORE_LOAD_TOPUSERRESERVE_REQUEST';
var CORE_LOAD_TOPUSERRESERVE_SUCCESS = 'CORE_LOAD_TOPUSERRESERVE_SUCCESS';
var CORE_LOAD_TOPUSERRESERVE_FAILURE = 'CORE_LOAD_TOPUSERRESERVE_FAILURE';

var CORE_LOAD_ROOMDETAIL_REQUEST = 'CORE_LOAD_ROOMDETAIL_REQUEST';
var CORE_LOAD_ROOMDETAIL_SUCCESS = 'CORE_LOAD_ROOMDETAIL_SUCCESS';
var CORE_LOAD_ROOMDETAIL_FAILURE = 'CORE_LOAD_ROOMDETAIL_FAILURE';

var CORE_LOAD_TERM_REQUEST = 'CORE_LOAD_TERM_REQUEST';
var CORE_LOAD_TERM_SUCCESS = 'CORE_LOAD_TERM_SUCCESS';
var CORE_LOAD_TERM_FAILURE = 'CORE_LOAD_TERM_FAILURE';

var CORE_UPDATE_TERM_REQUEST = 'CORE_UPDATE_TERM_REQUEST';
var CORE_UPDATE_TERM_SUCCESS = 'CORE_UPDATE_TERM_SUCCESS';
var CORE_UPDATE_TERM_FAILURE = 'CORE_UPDATE_TERM_FAILURE';

var CORE_LOAD_FAQ_REQUEST = 'CORE_LOAD_FAQ_REQUEST';
var CORE_LOAD_FAQ_SUCCESS = 'CORE_LOAD_FAQ_SUCCESS';
var CORE_LOAD_FAQ_FAILURE = 'CORE_LOAD_FAQ_FAILURE';

var CORE_UPDATE_FAQ_REQUEST = 'CORE_UPDATE_FAQ_REQUEST';
var CORE_UPDATE_FAQ_SUCCESS = 'CORE_UPDATE_FAQ_SUCCESS';
var CORE_UPDATE_FAQ_FAILURE = 'CORE_UPDATE_FAQ_FAILURE';

var CORE_LOAD_CONTACT_US_REQUEST = 'CORE_LOAD_CONTACT_US_REQUEST';
var CORE_LOAD_CONTACT_US_SUCCESS = 'CORE_LOAD_CONTACT_US_SUCCESS';
var CORE_LOAD_CONTACT_US_FAILURE = 'CORE_LOAD_CONTACT_US_FAILURE';

var CORE_UPDATE_CONTACT_US_REQUEST = 'CORE_UPDATE_CONTACT_US_REQUEST';
var CORE_UPDATE_CONTACT_US_SUCCESS = 'CORE_UPDATE_CONTACT_US_SUCCESS';
var CORE_UPDATE_CONTACT_US_FAILURE = 'CORE_UPDATE_CONTACT_US_FAILURE';

var CORE_LOAD_REPORTROOMSTATUS_REQUEST = 'CORE_LOAD_REPORTROOMSTATUS_REQUEST';
var CORE_LOAD_REPORTROOMSTATUS_SUCCESS = 'CORE_LOAD_REPORTROOMSTATUS_SUCCESS';
var CORE_LOAD_REPORTROOMSTATUS_FAILURE = 'CORE_LOAD_REPORTROOMSTATUS_FAILURE';

var CORE_LOAD_ALL_CATEGORY_REQUEST = 'CORE_LOAD_ALL_CATEGORY_REQUEST';
var CORE_LOAD_ALL_CATEGORY_SUCCESS = 'CORE_LOAD_ALL_CATEGORY_SUCCESS';
var CORE_LOAD_ALL_CATEGORY_FAILURE = 'CORE_LOAD_ALL_CATEGORY_FAILURE';

var CORE_LOAD_ALLBUILDING_REQUEST = 'CORE_LOAD_ALLBUILDING_REQUEST';
var CORE_LOAD_ALLBUILDING_SUCCESS = 'CORE_LOAD_ALLBUILDING_SUCCESS';
var CORE_LOAD_ALLBUILDING_FAILURE = 'CORE_LOAD_ALLBUILDING_FAILURE';

var CORE_DELETE_BUILDING_REQUEST = 'CORE_DELETE_BUILDING_REQUEST';
var CORE_DELETE_BUILDING_SUCCESS = 'CORE_DELETE_BUILDING_SUCCESS';
var CORE_DELETE_BUILDING_FAILURE = 'CORE_DELETE_BUILDING_FAILURE';

var CORE_LOAD_BUILDINGINFO_REQUEST = 'CORE_LOAD_BUILDINGINFO_REQUEST';
var CORE_LOAD_BUILDINGINFO_SUCCESS = 'CORE_LOAD_BUILDINGINFO_SUCCESS';
var CORE_LOAD_BUILDINGINFO_FAILURE = 'CORE_LOAD_BUILDINGINFO_FAILURE';

var CORE_UPDATE_BUILDINGINFO_REQUEST = 'CORE_UPDATE_BUILDINGINFO_REQUEST';
var CORE_UPDATE_BUILDINGINFO_SUCCESS = 'CORE_UPDATE_BUILDINGINFO_SUCCESS';
var CORE_UPDATE_BUILDINGINFO_FAILURE = 'CORE_UPDATE_BUILDINGINFO_FAILURE';

var CORE_CREATE_BUILDING_REQUEST = 'CORE_CREATE_BUILDING_REQUEST';
var CORE_CREATE_BUILDING_SUCCESS = 'CORE_CREATE_BUILDING_SUCCESS';
var CORE_CREATE_BUILDING_FAILURE = 'CORE_CREATE_BUILDING_FAILURE';

var CORE_LOAD_ALLFLOOR_REQUEST = 'CORE_LOAD_ALLFLOOR_REQUEST';
var CORE_LOAD_ALLFLOOR_SUCCESS = 'CORE_LOAD_ALLFLOOR_SUCCESS';
var CORE_LOAD_ALLFLOOR_FAILURE = 'CORE_LOAD_ALLFLOOR_FAILURE';

var CORE_DELETE_FLOOR_REQUEST = 'CORE_DELETE_FLOOR_REQUEST';
var CORE_DELETE_FLOOR_SUCCESS = 'CORE_DELETE_FLOOR_SUCCESS';
var CORE_DELETE_FLOOR_FAILURE = 'CORE_DELETE_FLOOR_FAILURE';

var CORE_LOAD_FLOORINFO_REQUEST = 'CORE_LOAD_FLOORINFO_REQUEST';
var CORE_LOAD_FLOORINFO_SUCCESS = 'CORE_LOAD_FLOORINFO_SUCCESS';
var CORE_LOAD_FLOORINFO_FAILURE = 'CORE_LOAD_FLOORINFO_FAILURE';

var CORE_UPDATE_FLOORINFO_REQUEST = 'CORE_UPDATE_FLOORINFO_REQUEST';
var CORE_UPDATE_FLOORINFO_SUCCESS = 'CORE_UPDATE_FLOORINFO_SUCCESS';
var CORE_UPDATE_FLOORINFO_FAILURE = 'CORE_UPDATE_FLOORINFO_FAILURE';

var CORE_CREATE_FLOOR_REQUEST = 'CORE_CREATE_FLOOR_REQUEST';
var CORE_CREATE_FLOOR_SUCCESS = 'CORE_CREATE_FLOOR_SUCCESS';
var CORE_CREATE_FLOOR_FAILURE = 'CORE_CREATE_FLOOR_FAILURE';

var CORE_LOAD_ALLZONE_REQUEST = 'CORE_LOAD_ALLZONE_REQUEST';
var CORE_LOAD_ALLZONE_SUCCESS = 'CORE_LOAD_ALLZONE_SUCCESS';
var CORE_LOAD_ALLZONE_FAILURE = 'CORE_LOAD_ALLZONE_FAILURE';

var CORE_DELETE_ZONE_REQUEST = 'CORE_DELETE_ZONE_REQUEST';
var CORE_DELETE_ZONE_SUCCESS = 'CORE_DELETE_ZONE_SUCCESS';
var CORE_DELETE_ZONE_FAILURE = 'CORE_DELETE_ZONE_FAILURE';

var CORE_LOAD_ZONEINFO_REQUEST = 'CORE_LOAD_ZONEINFO_REQUEST';
var CORE_LOAD_ZONEINFO_SUCCESS = 'CORE_LOAD_ZONEINFO_SUCCESS';
var CORE_LOAD_ZONEINFO_FAILURE = 'CORE_LOAD_ZONEINFO_FAILURE';

var CORE_UPDATE_ZONEINFO_REQUEST = 'CORE_UPDATE_ZONEINFO_REQUEST';
var CORE_UPDATE_ZONEINFO_SUCCESS = 'CORE_UPDATE_ZONEINFO_SUCCESS';
var CORE_UPDATE_ZONEINFO_FAILURE = 'CORE_UPDATE_ZONEINFO_FAILURE';

var CORE_CREATE_ZONE_REQUEST = 'CORE_CREATE_ZONE_REQUEST';
var CORE_CREATE_ZONE_SUCCESS = 'CORE_CREATE_ZONE_SUCCESS';
var CORE_CREATE_ZONE_FAILURE = 'CORE_CREATE_ZONE_FAILURE';

var CORE_LOAD_ALLBACKGROUND_REQUEST = 'CORE_LOAD_ALLBACKGROUND_REQUEST';
var CORE_LOAD_ALLBACKGROUND_SUCCESS = 'CORE_LOAD_ALLBACKGROUND_SUCCESS';
var CORE_LOAD_ALLBACKGROUND_FAILURE = 'CORE_LOAD_ALLBACKGROUND_FAILURE';

var CORE_DELETE_BACKGROUND_REQUEST = 'CORE_DELETE_BACKGROUND_REQUEST';
var CORE_DELETE_BACKGROUND_SUCCESS = 'CORE_DELETE_BACKGROUND_SUCCESS';
var CORE_DELETE_BACKGROUND_FAILURE = 'CORE_DELETE_BACKGROUND_FAILURE';

var CORE_LOAD_BACKGROUNDINFO_REQUEST = 'CORE_LOAD_BACKGROUNDINFO_REQUEST';
var CORE_LOAD_BACKGROUNDINFO_SUCCESS = 'CORE_LOAD_BACKGROUNDINFO_SUCCESS';
var CORE_LOAD_BACKGROUNDINFO_FAILURE = 'CORE_LOAD_BACKGROUNDINFO_FAILURE';

var CORE_UPDATE_BACKGROUNDINFO_REQUEST = 'CORE_UPDATE_BACKGROUNDINFO_REQUEST';
var CORE_UPDATE_BACKGROUNDINFO_SUCCESS = 'CORE_UPDATE_BACKGROUNDINFO_SUCCESS';
var CORE_UPDATE_BACKGROUNDINFO_FAILURE = 'CORE_UPDATE_BACKGROUNDINFO_FAILURE';

var CORE_CREATE_BACKGROUND_REQUEST = 'CORE_CREATE_BACKGROUND_REQUEST';
var CORE_CREATE_BACKGROUND_SUCCESS = 'CORE_CREATE_BACKGROUND_SUCCESS';
var CORE_CREATE_BACKGROUND_FAILURE = 'CORE_CREATE_BACKGROUND_FAILURE';

var CORE_UPDATE_DEFAULTBACKGROUND_REQUEST = 'CORE_UPDATE_DEFAULTBACKGROUND_REQUEST';
var CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS = 'CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS';
var CORE_UPDATE_DEFAULTBACKGROUND_FAILURE = 'CORE_UPDATE_DEFAULTBACKGROUND_FAILURE';

var CORE_GET_CATEGORY_INFO_REQUEST = 'CORE_GET_CATEGORY_INFO_REQUEST';
var CORE_GET_CATEGORY_INFO_SUCCESS = 'CORE_GET_CATEGORY_INFO_SUCCESS';
var CORE_GET_CATEGORY_INFO_FAILURE = 'CORE_GET_CATEGORY_INFO_FAILURE';

var CORE_UPDATE_FB_CATEGORY_REQUEST = 'CORE_UPDATE_FB_CATEGORY_REQUEST';
var CORE_UPDATE_FB_CATEGORY_SUCCESS = 'CORE_UPDATE_FB_CATEGORY_SUCCESS';
var CORE_UPDATE_FB_CATEGORY_FAILURE = 'CORE_UPDATE_FB_CATEGORY_FAILURE';

var CORE_CREATE_FB_CATEGORY_REQUEST = 'CORE_CREATE_FB_CATEGORY_REQUEST';
var CORE_CREATE_FB_CATEGORY_SUCCESS = 'CORE_CREATE_FB_CATEGORY_SUCCESS';
var CORE_CREATE_FB_CATEGORY_FAILURE = 'CORE_CREATE_FB_CATEGORY_FAILURE';

var CORE_DELETE_FB_CATEGORY_REQUEST = 'CORE_DELETE_FB_CATEGORY_REQUEST';
var CORE_DELETE_FB_CATEGORY_SUCCESS = 'CORE_DELETE_FB_CATEGORY_SUCCESS';
var CORE_DELETE_FB_CATEGORY_FAILURE = 'CORE_DELETE_FB_CATEGORY_FAILURE';

var CORE_LOAD_ALL_USERSAD_REQUEST = 'CORE_LOAD_ALL_USERSAD_REQUEST';
var CORE_LOAD_ALL_USERSAD_SUCCESS = 'CORE_LOAD_ALL_USERSAD_SUCCESS';
var CORE_LOAD_ALL_USERSAD_FAILURE = 'CORE_LOAD_ALL_USERSAD_FAILURE';

var CORE_CHECK_AD_REQUEST = 'CORE_CHECK_AD_REQUEST';
var CORE_CHECK_AD_SUCCESS = 'CORE_CHECK_AD_SUCCESS';
var CORE_CHECK_AD_FAILURE = 'CORE_CHECK_AD_FAILURE';

var CORE_CHECK_TMS_REQUEST = 'CORE_CHECK_TMS_REQUEST';
var CORE_CHECK_TMS_SUCCESS = 'CORE_CHECK_TMS_SUCCESS';
var CORE_CHECK_TMS_FAILURE = 'CORE_CHECK_TMS_FAILURE';

var CORE_CHECK_CMR_REQUEST = 'CORE_CHECK_CMR_REQUEST';
var CORE_CHECK_CMR_SUCCESS = 'CORE_CHECK_CMR_SUCCESS';
var CORE_CHECK_CMR_FAILURE = 'CORE_CHECK_CMR_FAILURE';

var CORE_CHECK_BOT_REQUEST = 'CORE_CHECK_BOT_REQUEST';
var CORE_CHECK_BOT_SUCCESS = 'CORE_CHECK_BOT_SUCCESS';
var CORE_CHECK_BOT_FAILURE = 'CORE_CHECK_BOT_FAILURE';

var CORE_LOAD_TIMEZOZE_REQUEST = 'CORE_LOAD_TIMEZOZE_REQUEST';
var CORE_LOAD_TIMEZOZE_SUCCESS = 'CORE_LOAD_TIMEZOZE_SUCCESS';
var CORE_LOAD_TIMEZOZE_FAILURE = 'CORE_LOAD_TIMEZOZE_FAILURE';

var CORE_EDIT_GOOGLE_INTEGRATION_REQUEST = 'CORE_EDIT_GOOGLE_INTEGRATION_REQUEST';
var CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS = 'CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS';
var CORE_EDIT_GOOGLE_INTEGRATION_FAILURE = 'CORE_EDIT_GOOGLE_INTEGRATION_FAILURE';

var CORE_SEARCH_ROOMS_REQUEST = 'CORE_SEARCH_ROOMS_REQUEST';
var CORE_SEARCH_ROOMS_SUCCESS = 'CORE_SEARCH_ROOMS_SUCCESS';
var CORE_SEARCH_ROOMS_FAILURE = 'CORE_SEARCH_ROOMS_FAILURE';

var CORE_SEARCH_FLOOR_REQUEST = 'CORE_SEARCH_FLOOR_REQUEST';
var CORE_SEARCH_FLOOR_SUCCESS = 'CORE_SEARCH_FLOOR_SUCCESS';
var CORE_SEARCH_FLOOR_FAILURE = 'CORE_SEARCH_FLOOR_FAILURE';

var CORE_SEARCH_ZONE_REQUEST = 'CORE_SEARCH_ZONE_REQUEST';
var CORE_SEARCH_ZONE_SUCCESS = 'CORE_SEARCH_ZONE_SUCCESS';
var CORE_SEARCH_ZONE_FAILURE = 'CORE_SEARCH_ZONE_FAILURE';

var CORE_SEARCH_USERS_REQUEST = 'CORE_SEARCH_USERS_REQUEST';
var CORE_SEARCH_USERS_SUCCESS = 'CORE_SEARCH_USERS_SUCCESS';
var CORE_SEARCH_USERS_FAILURE = 'CORE_SEARCH_USERS_FAILURE';

var CORE_SEARCH_FBS_REQUEST = 'CORE_SEARCH_FBS_REQUEST';
var CORE_SEARCH_FBS_SUCCESS = 'CORE_SEARCH_FBS_SUCCESS';
var CORE_SEARCH_FBS_FAILURE = 'CORE_SEARCH_FBS_FAILURE';

var CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST';
var CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS';
var CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE';

var CORE_CHECKOUT_REQUEST = 'CORE_CHECKOUT_REQUEST';
var CORE_CHECKOUT_SUCCESS = 'CORE_CHECKOUT_SUCCESS';
var CORE_CHECKOUT_FAILURE = 'CORE_CHECKOUT_FAILURE';

var CORE_DELETE_EVENT_REQUEST = 'CORE_DELETE_EVENT_REQUEST';
var CORE_DELETE_EVENT_SUCCESS = 'CORE_DELETE_EVENT_SUCCESS';
var CORE_DELETE_EVENT_FAILURE = 'CORE_DELETE_EVENT_FAILURE';

var CORE_RESET_PASSWORD_REQUEST = 'CORE_RESET_PASSWORD_REQUEST';
var CORE_RESET_PASSWORD_SUCCESS = 'CORE_RESET_PASSWORD_SUCCESS';
var CORE_RESET_PASSWORD_FAILURE = 'CORE_RESET_PASSWORD_FAILURE';

var CORE_LOAD_DISPLAY_REQUEST = 'CORE_LOAD_DISPLAY_REQUEST';
var CORE_LOAD_DISPLAY_SUCCESS = 'CORE_LOAD_DISPLAY_SUCCESS';
var CORE_LOAD_DISPLAY_FAILURE = 'CORE_LOAD_DISPLAY_FAILURE';

var CORE_GET_DISPLAY_INFO_REQUEST = 'CORE_GET_DISPLAY_INFO_REQUEST';
var CORE_GET_DISPLAY_INFO_SUCCESS = 'CORE_GET_DISPLAY_INFO_SUCCESS';
var CORE_GET_DISPLAY_INFO_FAILURE = 'CORE_GET_DISPLAY_INFO_FAILURE';

var CORE_CREATE_DISPLAY_REQUEST = 'CORE_CREATE_DISPLAY_REQUEST';
var CORE_CREATE_DISPLAY_SUCCESS = 'CORE_CREATE_DISPLAY_SUCCESS';
var CORE_CREATE_DISPLAY_FAILURE = 'CORE_CREATE_DISPLAY_FAILURE';

var CORE_DELETE_DISPLAY_REQUEST = 'CORE_DELETE_DISPLAY_REQUEST';
var CORE_DELETE_DISPLAY_SUCCESS = 'CORE_DELETE_DISPLAY_SUCCESS';
var CORE_DELETE_DISPLAY_FAILURE = 'CORE_DELETE_DISPLAY_FAILURE';

var CORE_UPDATE_DISPLAY_REQUEST = 'CORE_UPDATE_DISPLAY_REQUEST';
var CORE_UPDATE_DISPLAY_SUCCESS = 'CORE_UPDATE_DISPLAY_SUCCESS';
var CORE_UPDATE_DISPLAY_FAILURE = 'CORE_UPDATE_DISPLAY_FAILURE';

var PROFILE_CENTER_LOAD_INFO_REQUEST = 'PROFILE_CENTER_LOAD_INFO_REQUEST';
var PROFILE_CENTER_LOAD_INFO_SUCCESS = 'PROFILE_CENTER_LOAD_INFO_SUCCESS';
var PROFILE_CENTER_LOAD_INFO_FAILURE = 'PROFILE_CENTER_LOAD_INFO_FAILURE';

var PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST';
var PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS';
var PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE';

var PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST';
var PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS';
var PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE';

var CORE_LOAD_ALL_ROOMDISABLE_REQUEST = 'CORE_LOAD_ALL_ROOMDISABLE_REQUEST';
var CORE_LOAD_ALL_ROOMDISABLE_SUCCESS = 'CORE_LOAD_ALL_ROOMDISABLE_SUCCESS';
var CORE_LOAD_ALL_ROOMDISABLE_FAILURE = 'CORE_LOAD_ALL_ROOMDISABLE_FAILURE';

var CORE_LOAD_ROOMDISABLE_REQUEST = 'CORE_LOAD_ROOMDISABLE_REQUEST';
var CORE_LOAD_ROOMDISABLE_SUCCESS = 'CORE_LOAD_ROOMDISABLE_SUCCESS';
var CORE_LOAD_ROOMDISABLE_FAILURE = 'CORE_LOAD_ROOMDISABLE_FAILURE';

var CORE_CREATE_ROOMDISABLE_REQUEST = 'CORE_CREATE_ROOMDISABLE_REQUEST';
var CORE_CREATE_ROOMDISABLE_SUCCESS = 'CORE_CREATE_ROOMDISABLE_SUCCESS';
var CORE_CREATE_ROOMDISABLE_FAILURE = 'CORE_CREATE_ROOMDISABLE_FAILURE';

var CORE_UPDATE_ROOMDISABLE_REQUEST = 'CORE_UPDATE_ROOMDISABLE_REQUEST';
var CORE_UPDATE_ROOMDISABLE_SUCCESS = 'CORE_UPDATE_ROOMDISABLE_SUCCESS';
var CORE_UPDATE_ROOMDISABLE_FAILURE = 'CORE_UPDATE_ROOMDISABLE_FAILURE';

var CORE_DELETE_ROOMDISABLE_REQUEST = 'CORE_DELETE_ROOMDISABLE_REQUEST';
var CORE_DELETE_ROOMDISABLE_SUCCESS = 'CORE_DELETE_ROOMDISABLE_SUCCESS';
var CORE_DELETE_ROOMDISABLE_FAILURE = 'CORE_DELETE_ROOMDISABLE_FAILURE';

var CORE_LOAD_VC_LIST_REQUEST = 'CORE_LOAD_VC_LIST_REQUEST';
var CORE_LOAD_VC_LIST_SUCCESS = 'CORE_LOAD_VC_LIST_SUCCESS';
var CORE_LOAD_VC_LIST_FAILURE = 'CORE_LOAD_VC_LIST_FAILURE';

var CORE_LOAD_CONCURRENT_REQUEST = 'CORE_LOAD_CONCURRENT_REQUEST';
var CORE_LOAD_CONCURRENT_SUCCESS = 'CORE_LOAD_CONCURRENT_SUCCESS';
var CORE_LOAD_CONCURRENT_FAILURE = 'CORE_LOAD_CONCURRENT_FAILURE';

var CORE_DELETE_CONCURRENT_REQUEST = 'CORE_DELETE_CONCURRENT_REQUEST';
var CORE_DELETE_CONCURRENT_SUCCESS = 'CORE_DELETE_CONCURRENT_SUCCESS';
var CORE_DELETE_CONCURRENT_FAILURE = 'CORE_DELETE_CONCURRENT_FAILURE';

var CORE_LOAD_ROLES_REQUEST = 'CORE_LOAD_ROLES_REQUEST';
var CORE_LOAD_ROLES_SUCCESS = 'CORE_LOAD_ROLES_SUCCESS';
var CORE_LOAD_ROLES_FAILURE = 'CORE_LOAD_ROLES_FAILURE';

var CORE_CREATE_ROLE_REQUEST = 'CORE_CREATE_ROLE_REQUEST';
var CORE_CREATE_ROLE_SUCCESS = 'CORE_CREATE_ROLE_SUCCESS';
var CORE_CREATE_ROLE_FAILURE = 'CORE_CREATE_ROLE_FAILURE';

var CORE_LOAD_ROLE_INFO_REQUEST = 'CORE_LOAD_ROLE_INFO_REQUEST';
var CORE_LOAD_ROLE_INFO_SUCCESS = 'CORE_LOAD_ROLE_INFO_SUCCESS';
var CORE_LOAD_ROLE_INFO_FAILURE = 'CORE_LOAD_ROLE_INFO_FAILURE';

var CORE_UPDATE_ROLE_REQUEST = 'CORE_UPDATE_ROLE_REQUEST';
var CORE_UPDATE_ROLE_SUCCESS = 'CORE_UPDATE_ROLE_SUCCESS';
var CORE_UPDATE_ROLE_FAILURE = 'CORE_UPDATE_ROLE_FAILURE';

var CORE_DELETE_ROLE_REQUEST = 'CORE_DELETE_ROLE_REQUEST';
var CORE_DELETE_ROLE_SUCCESS = 'CORE_DELETE_ROLE_SUCCESS';
var CORE_DELETE_ROLE_FAILURE = 'CORE_DELETE_ROLE_FAILURE';

var CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST = 'CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST';
var CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS';
var CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE = 'CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE';

var CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST = 'CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST';
var CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS';
var CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE = 'CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE';

var CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST';
var CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS';
var CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE';

var CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST';
var CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS';
var CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE';

var CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST = 'CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST';
var CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS';
var CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE = 'CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE';

var CORE_LOAD_ORDER_FBS_REQUEST = 'CORE_LOAD_ORDER_FBS_REQUEST';
var CORE_LOAD_ORDER_FBS_SUCCESS = 'CORE_LOAD_ORDER_FBS_SUCCESS';
var CORE_LOAD_ORDER_FBS_FAILURE = 'CORE_LOAD_ORDER_FBS_FAILURE';

var CORE_DELETE_ORDER_FBS_REQUEST = 'CORE_DELETE_ORDER_FBS_REQUEST';
var CORE_DELETE_ORDER_FBS_SUCCESS = 'CORE_DELETE_ORDER_FBS_SUCCESS';
var CORE_DELETE_ORDER_FBS_FAILURE = 'CORE_DELETE_ORDER_FBS_FAILURE';

var CORE_LOAD_ORDER_FBS_INFO_REQUEST = 'CORE_LOAD_ORDER_FBS_INFO_REQUEST';
var CORE_LOAD_ORDER_FBS_INFO_SUCCESS = 'CORE_LOAD_ORDER_FBS_INFO_SUCCESS';
var CORE_LOAD_ORDER_FBS_INFO_FAILURE = 'CORE_LOAD_ORDER_FBS_INFO_FAILURE';

var CORE_UPDATE_ORDER_FBS_INFO_REQUEST = 'CORE_UPDATE_ORDER_FBS_INFO_REQUEST';
var CORE_UPDATE_ORDER_FBS_INFO_SUCCESS = 'CORE_UPDATE_ORDER_FBS_INFO_SUCCESS';
var CORE_UPDATE_ORDER_FBS_INFO_FAILURE = 'CORE_UPDATE_ORDER_FBS_INFO_FAILURE';

var CORE_CREATE_ORDER_FBS_REQUEST = 'CORE_CREATE_ORDER_FBS_REQUEST';
var CORE_CREATE_ORDER_FBS_SUCCESS = 'CORE_CREATE_ORDER_FBS_SUCCESS';
var CORE_CREATE_ORDER_FBS_FAILURE = 'CORE_CREATE_ORDER_FBS_FAILURE';

var CORE_LOAD_ORDER_AMENITY_REQUEST = 'CORE_LOAD_ORDER_AMENITY_REQUEST';
var CORE_LOAD_ORDER_AMENITY_SUCCESS = 'CORE_LOAD_ORDER_AMENITY_SUCCESS';
var CORE_LOAD_ORDER_AMENITY_FAILURE = 'CORE_LOAD_ORDER_AMENITY_FAILURE';

var CORE_DELETE_ORDER_AMENITY_REQUEST = 'CORE_DELETE_ORDER_AMENITY_REQUEST';
var CORE_DELETE_ORDER_AMENITY_SUCCESS = 'CORE_DELETE_ORDER_AMENITY_SUCCESS';
var CORE_DELETE_ORDER_AMENITY_FAILURE = 'CORE_DELETE_ORDER_AMENITY_FAILURE';

var CORE_LOAD_ORDER_AMENITY_INFO_REQUEST = 'CORE_LOAD_ORDER_AMENITY_INFO_REQUEST';
var CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS = 'CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS';
var CORE_LOAD_ORDER_AMENITY_INFO_FAILURE = 'CORE_LOAD_ORDER_AMENITY_INFO_FAILURE';

var CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST = 'CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST';
var CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS = 'CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS';
var CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE = 'CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE';

var O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST = 'O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST';
var O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS = 'O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS';
var O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE = 'O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE';

var CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST = 'CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST';
var CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS = 'CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS';
var CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE = 'CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE';

var CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST';
var CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS';
var CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE';

var CORE_LOAD_EVENTTYPE_REQUEST = 'CORE_LOAD_EVENTTYPE_REQUEST';
var CORE_LOAD_EVENTTYPE_SUCCESS = 'CORE_LOAD_EVENTTYPE_SUCCESS';
var CORE_LOAD_EVENTTYPE_FAILURE = 'CORE_LOAD_EVENTTYPE_FAILURE';

var CORE_LOAD_EVENTTYPE_INFO_REQUEST = 'CORE_LOAD_EVENTTYPE_INFO_REQUEST';
var CORE_LOAD_EVENTTYPE_INFO_SUCCESS = 'CORE_LOAD_EVENTTYPE_INFO_SUCCESS';
var CORE_LOAD_EVENTTYPE_INFO_FAILURE = 'CORE_LOAD_EVENTTYPE_INFO_FAILURE';

var CORE_CREATE_EVENTTYPE_REQUEST = 'CORE_CREATE_EVENTTYPE_REQUEST';
var CORE_CREATE_EVENTTYPE_SUCCESS = 'CORE_CREATE_EVENTTYPE_SUCCESS';
var CORE_CREATE_EVENTTYPE_FAILURE = 'CORE_CREATE_EVENTTYPE_FAILURE';

var CORE_UPDATE_EVENTTYPE_REQUEST = 'CORE_UPDATE_EVENTTYPE_REQUEST';
var CORE_UPDATE_EVENTTYPE_SUCCESS = 'CORE_UPDATE_EVENTTYPE_SUCCESS';
var CORE_UPDATE_EVENTTYPE_FAILURE = 'CORE_UPDATE_EVENTTYPE_FAILURE';

var CORE_DELETE_EVENTTYPE_REQUEST = 'CORE_DELETE_EVENTTYPE_REQUEST';
var CORE_DELETE_EVENTTYPE_SUCCESS = 'CORE_DELETE_EVENTTYPE_SUCCESS';
var CORE_DELETE_EVENTTYPE_FAILURE = 'CORE_DELETE_EVENTTYPE_FAILURE';

var CORE_UNREGISTER_DISPLAY_REQUEST = 'CORE_UNREGISTER_DISPLAY_REQUEST';
var CORE_UNREGISTER_DISPLAY_SUCCESS = 'CORE_UNREGISTER_DISPLAY_SUCCESS';
var CORE_UNREGISTER_DISPLAY_FAILURE = 'CORE_UNREGISTER_DISPLAY_FAILURE';

var CORE_UNREGISTER_PROFILE_REQUEST = 'CORE_UNREGISTER_PROFILE_REQUEST';
var CORE_UNREGISTER_PROFILE_SUCCESS = 'CORE_UNREGISTER_PROFILE_SUCCESS';
var CORE_UNREGISTER_PROFILE_FAILURE = 'CORE_UNREGISTER_PROFILE_FAILURE';

var CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST = 'CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST';
var CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS = 'CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS';
var CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE = 'CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE';

var CORE_IMPORT_USER_O365_REQUEST = 'CORE_IMPORT_USER_O365_REQUEST';
var CORE_IMPORT_USER_O365_SUCCESS = 'CORE_IMPORT_USER_O365_SUCCESS';
var CORE_IMPORT_USER_O365_FAILURE = 'CORE_IMPORT_USER_O365_FAILURE';

var CORE_SYNC_ROLE_REQUEST = 'CORE_SYNC_ROLE_REQUEST';
var CORE_SYNC_ROLE_SUCCESS = 'CORE_SYNC_ROLE_SUCCESS';
var CORE_SYNC_ROLE_FAILURE = 'CORE_SYNC_ROLE_FAILURE';

var CORE_LOAD_ALL_AD_LIST_REQUEST = 'CORE_LOAD_ALL_AD_LIST_REQUEST';
var CORE_LOAD_ALL_AD_LIST_SUCCESS = 'CORE_LOAD_ALL_AD_LIST_SUCCESS';
var CORE_LOAD_ALL_AD_LIST_FAILURE = 'CORE_LOAD_ALL_AD_LIST_FAILURE';

var CORE_IMPORT_USER_AD_REQUEST = 'CORE_IMPORT_USER_AD_REQUEST';
var CORE_IMPORT_USER_AD_SUCCESS = 'CORE_IMPORT_USER_AD_SUCCESS';
var CORE_IMPORT_USER_AD_FAILURE = 'CORE_IMPORT_USER_AD_FAILURE';

var CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST = "CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST";
var CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS = "CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS";
var CORE_SEARCH_ALL_FBS_CATEGORY_FAILURE = "CORE_SEARCH_ALL_FBS_CATEGORY_FAILURE";

var CORE_SEARCH_BUILDING_REQUEST = 'CORE_SEARCH_BUILDING_REQUEST';
var CORE_SEARCH_BUILDING_SUCCESS = 'CORE_SEARCH_BUILDING_SUCCESS';
var CORE_SEARCH_BUILDING_FAILURE = 'CORE_SEARCH_BUILDING_FAILURE';

var CORE_SEARCH_AMENITY_REQUEST = "CORE_SEARCH_AMENITY_REQUEST";
var CORE_SEARCH_AMENITY_SUCCESS = "CORE_SEARCH_AMENITY_SUCCESS";
var CORE_SEARCH_AMENITY_FAILURE = "CORE_SEARCH_AMENITY_FAILURE";

var CORE_SEARCH_EVENTTYPE_REQUEST = 'CORE_SEARCH_EVENTTYPE_REQUEST';
var CORE_SEARCH_EVENTTYPE_SUCCESS = 'CORE_SEARCH_EVENTTYPE_SUCCESS';
var CORE_SEARCH_EVENTTYPE_FAILURE = 'CORE_SEARCH_EVENTTYPE_FAILURE';

var O365_RESEND_EVENT_PIN_REQUEST = 'O365_RESEND_EVENT_PIN_REQUEST';
var O365_RESEND_EVENT_PIN_SUCCESS = 'O365_RESEND_EVENT_PIN_SUCCESS';
var O365_RESEND_EVENT_PIN_FAILURE = 'O365_RESEND_EVENT_PIN_FAILURE';

var CORE_LOAD_INTEGRATION_DATA_REQUEST = 'CORE_LOAD_INTEGRATION_DATA_REQUEST';
var CORE_LOAD_INTEGRATION_DATA_SUCCESS = 'CORE_LOAD_INTEGRATION_DATA_SUCCESS';
var CORE_LOAD_INTEGRATION_DATA_FAILURE = 'CORE_LOAD_INTEGRATION_DATA_FAILURE';

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 413, 500];

function getAction(type, action, state, res) {
	return new Promise(function (resolve, reject) {
		if (!res) return resolve({ type: type });

		if (resStatusError.includes(res.status)) {
			if (res.status === 422) {
				return res.json().then(function (json) {
					var message = "";
					for (var key in json) {
						if (json.hasOwnProperty(key)) {
							var element = json[key];
							for (var k in element) {
								if (element.hasOwnProperty(k)) {
									var ele = element[k];
									message += "" + ele.msg;
									if (ele.param) message += "Param : " + ele.param + " ";
									message += "\n";
								}
							}
						}
					}

					return reject({
						statusText: res.statusText, data: {
							code: res.status.toString(),
							message: message
						}
					});
				});
			} else if (res.status === 404) {
				return reject({
					statusText: 404, data: {
						code: "404",
						message: "404 (Not Found)"
					}
				});
			} else {
				return res.json().then(function (data) {
					return reject({ statusText: res.statusText, data: data });
				});
			}
		}

		if ((typeof type === "undefined" ? "undefined" : _typeof(type)) === 'object') {
			if (type.payload) {
				var payload = type.payload(action, state, res);
				if (typeof payload.then === 'function') {
					//promise
					return payload.then(function (data) {
						return resolve({ type: type.type, payload: data });
					}).catch(function (err) {
						return reject({
							statusText: "00000001",
							data: {
								code: "00000001",
								message: "Something went wrong. Please try again later."
							}
						});
					});
				} else {
					return resolve({ type: type.type, payload: payload });
				}
			}

			return resolve({ type: type.type });
		}

		res.json().then(function (payload) {
			return resolve({ type: type, payload: payload });
		});
	});
}

/* harmony default export */ var api = (function (_ref) {
	var getState = _ref.getState;
	return function (next) {
		return function (action) {
			if (_typeof(action[CALL_API]) !== 'object') return next(action);
			var _action$CALL_API = action[CALL_API],
			    endpoint = _action$CALL_API.endpoint,
			    _action$CALL_API$meth = _action$CALL_API.method,
			    method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
			    headers = _action$CALL_API.headers,
			    body = _action$CALL_API.body,
			    types = _action$CALL_API.types;

			var _types = _slicedToArray(types, 3),
			    request = _types[0],
			    success = _types[1],
			    failure = _types[2];

			var callBack = success.callBack;

			var state = getState();

			getAction(request, action, state).then(function (action) {
				return next(action);
			});

			if (callBack) {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					callBack(action);
					next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true, errorData: err.data });
				});
			} else {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true, errorData: err.data });
				});
			}
		};
	};
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(675);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/lib/index.js
var lib = __webpack_require__(165);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(676);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var _this = this;

var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
                var entry, allToken, expires, userId, refreshToken, duration, options, res, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                entry = action[CALL_API], allToken = Object(lib["i" /* getAllToken */])(), expires = allToken.expires_on, userId = allToken.userId, refreshToken = allToken.refresh_token;

                                if (!((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object' || !expires)) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return', next(action));

                            case 4:
                                duration = moment_timezone_default.a.unix(expires).diff(moment_timezone_default()(), "m");

                                if (!(duration <= lib["b" /* MIN_EXPIRE_TOKEN */])) {
                                    _context.next = 25;
                                    break;
                                }

                                options = {
                                    method: "POST",
                                    url: lib["a" /* CORE_API_ENDPOINT */] + '/user/refreshtoken',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    data: {
                                        refreshToken: refreshToken,
                                        userId: userId
                                    }
                                };
                                _context.next = 9;
                                return axios_default()(options);

                            case 9:
                                res = _context.sent;

                                if (!(!!res && !!res.data)) {
                                    _context.next = 22;
                                    break;
                                }

                                data = null;

                                if ("value" in res.data) {
                                    data = res.data;
                                }

                                if (!data) {
                                    _context.next = 19;
                                    break;
                                }

                                _context.next = 16;
                                return Object(lib["y" /* setRefreshToken */])(data);

                            case 16:
                                return _context.abrupt('return', next(action));

                            case 19:
                                throw new Error("Refresh token fail");

                            case 20:
                                _context.next = 23;
                                break;

                            case 22:
                                throw new Error("Token is Expired");

                            case 23:
                                _context.next = 26;
                                break;

                            case 25:
                                return _context.abrupt('return', next(action));

                            case 26:
                                _context.next = 31;
                                break;

                            case 28:
                                _context.prev = 28;
                                _context.t0 = _context['catch'](0);
                                return _context.abrupt('return', window.location.replace('/sessionExpire'));

                            case 31:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 28]]);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = void 0;
            var entryType = entry.types[0];
            if (entryType.startsWith("CORE") || entryType.startsWith("O365")) {
                token = Object(lib["j" /* getBSRSToken */])();
            }
            // else if (entryType.startsWith("O365")) {
            //   const { service_token } = getServiceToken()
            //   token = service_token
            // }

            // if(entryType.startsWith("CORE")){
            //   token = getBSRSToken()
            // }else if(entry.types[0].startsWith("O365")){ 
            //   if(typeof(entry.tokentype) !== undefined && entry.tokentype === 'service' ){ 
            //     const { service_token } = getServiceToken()
            //     token = service_token
            //   }
            //   else token = getAccessToken()
            // }

            if (!token) return next(action);

            // entry.headers = {
            //     ...entry.headers,
            //     "Authorization": `Bearer ${token}`
            // }
            entry.headers = _extends({}, entry.headers);
            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
                entry.headers["Access-Control-Allow-Origin"] = "*";
                entry.headers["Access-Control-Allow-Methods"] = "DELETE, POST, GET, OPTIONS";
                entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With";
            }

            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);


var utils = {
	decode: function decode(dataStr) {
		try {
			if (typeof dataStr !== "string") {
				throw new Error("Data invalid.");
			}
			var dataBase64 = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.decode(dataStr);
			return decodeURIComponent(dataBase64);
		} catch (error) {
			return "";
		}
	},
	encode: function encode(dataStr) {
		try {
			if (typeof dataStr !== "string") {
				throw new Error("Data invalid.");
			}
			var dataUTF8 = encodeURIComponent(dataStr);
			return __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.encode(dataUTF8);
		} catch (error) {
			console.error(error);
			return "";
		}
	},
	arrayDiff: function arrayDiff(arrayA, arrayB) {
		if (!Array.isArray(arrayA)) {
			return [];
		}
		if (!Array.isArray(arrayB)) {
			return arrayA;
		}

		return arrayA.filter(function (a) {
			var b = arrayB.find(function (b) {
				return b === a;
			});
			return !b;
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(327);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Loading = function Loading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["f" /* Dimmer */],
        { active: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROFILE_CENTER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return O365_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTI_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return page_footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MIN_EXPIRE_TOKEN; });
// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://www.bainisysstg.com/o365'
// export const NOTI_API_ENDPOINT = 'https://www.bainisysstg.com/notification'

// SOR
// export const CORE_API_ENDPOINT = 'http://10.0.30.10:8011/core'
// export const O365_API_ENDPOINT = 'http://10.0.30.10:8011/o365'
// export const NOTI_API_ENDPOINT = 'http://10.0.30.10:8011/notification'

var PROFILE_CENTER_URL = 'https://backoffice.bsrsprofile.com/api';

// export const CORE_API_ENDPOINT = 'https://backend.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backend.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backend.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://backbns.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backbns.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backbns.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://backgg.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backgg.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backgg.rmbainisys.com/notification'

// Prod
var CORE_API_ENDPOINT = '/core';
var O365_API_ENDPOINT = '/o365';
var NOTI_API_ENDPOINT = '/notification';

// export const CORE_API_ENDPOINT = 'https://back25ex2010.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25ex2010.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25ex2010.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://back25ex2013.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25ex2013.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25ex2013.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'http://localhost:2800/core'
// export const O365_API_ENDPOINT = 'http://localhost:3100/o365'
// export const NOTI_API_ENDPOINT = 'http://localhost:2170/notification'

// export const CORE_API_ENDPOINT = 'https://back25o365.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25o365.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25o365.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://back25o365.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25o365.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25o365.rmbainisys.com/notification'

// CP test
// export const CORE_API_ENDPOINT = 'https://10.0.30.10:6500/core'
// export const O365_API_ENDPOINT = 'https://10.0.30.10:6500/o365'
// export const NOTI_API_ENDPOINT = 'https://10.0.30.10:6500/notification'

// SOR
// export const CORE_API_ENDPOINT = 'http://10.0.30.10:8012/core'
// export const O365_API_ENDPOINT = 'http://10.0.30.10:8012/o365'
// export const NOTI_API_ENDPOINT = 'http://10.0.30.10:8012/notification'

// SCG
// export const CORE_API_ENDPOINT = 'https://10.0.30.11:7021/core'
// export const O365_API_ENDPOINT = 'https://10.0.30.11:7021/o365'
// export const NOTI_API_ENDPOINT = 'https://10.0.30.11:7021/notification'

var page_footer = " © BAINISYS";

var MIN_EXPIRE_TOKEN = 5; //min

/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeZone */
/* unused harmony export timeFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateTimeDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return timeDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return groupFBSbyCatagory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dateFormatBetweenStartEnd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var dateDisplay = 'DD MMM YYYY';
var dateTimeDisplay = 'DD MMM YYYY HH:mm';
var timeDisplay = 'HH:mm';

var groupFBSbyCatagory = function groupFBSbyCatagory(fbsList) {
    var result = [];
    if (Array.isArray(fbsList) && fbsList.length > 0) {
        fbsList.forEach(function (element) {
            var fbCategoryId = element.fbCategoryId,
                fbCategory = element.fbCategory;

            var _ref = fbCategoryId ? fbCategory : null,
                name = _ref.name,
                _id = _ref._id;

            var findIndexCategory = result.findIndex(function (r) {
                return r.fbCategoryId === _id;
            });
            if (findIndexCategory > -1) {
                var data = result[findIndexCategory].data;
                result[findIndexCategory].data = data.concat(element);
            } else result.push({ fbCategoryId: _id, name: name, data: [element] });
        });
    }
    return result;
};

var dateFormatBetweenStartEnd = function dateFormatBetweenStartEnd(start, end) {
    if (!start || !end) return null;
    var dateString = "",
        timeString = "";

    if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(start).isSame(end, "day")) {
        dateString = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()(start).toDate()).format(dateDisplay).toString();
        timeString = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()(start).toDate()).format(timeDisplay).toString();
        timeString += " - " + __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()(end).toDate()).format(timeDisplay).toString();
        return { date: dateString, time: timeString, isSameDate: true };
    } else {
        var dateObj = {};
        dateObj.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()(start).toDate()).format(dateTimeDisplay).toString();
        dateObj.end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()(end).toDate()).format(dateTimeDisplay).toString();
        return _extends({}, dateObj, { isSameDate: false });
    }
};

/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(511);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__(908);
var jsonwebtoken_default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken);

// CONCATENATED MODULE: ./src/constant.js

var systemKey = {
	O365: "o365",
	GOOGLE: "google",
	EXCHANGE2010: "exchange2010",
	EXCHANGE2013: "exchange2013"
};

var dateTimeFormat = {
	displayFullDateTime: "DD MMMM YYYY HH:mm",
	displayDate: "DD MMMM YYYY",
	displayTime: "HH:mm",

	apiFullDateTime: "YYYY-MM-DDTHH:mm:ss",
	apiDate: "YYYY-MM-DD"
};


// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(330);
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// CONCATENATED MODULE: ./src/core/business/CookiesManager.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var cookiesKey = {
	IS_REMEMBER: "isRemember"
};

var CookiesManager_CookiesManager = function () {
	function CookiesManager() {
		_classCallCheck(this, CookiesManager);

		this.key = "rm_data";
		this.expires = 7;
		this.timeZone = "Asia/Bangkok";
	}

	_createClass(CookiesManager, [{
		key: 'encrypt',
		value: function encrypt(data) {
			var step1 = base64_default.a.encode(JSON.stringify(data)),
			    step2 = this.myEncode(step1);

			return step2;
		}
	}, {
		key: 'decrypt',
		value: function decrypt(data) {
			var step1 = this.myDecode(data);
			return JSON.parse(base64_default.a.decode(step1));
		}
	}, {
		key: 'myEncode',
		value: function myEncode(str) {
			try {
				var b64 = base64_default.a.encode(str);
				if (b64.length <= 20) {
					return b64;
				}

				var pre = b64.substr(0, 10),
				    sub = b64.substr(b64.length - 10, 10),
				    con = b64.substr(10, b64.length - 20);

				return con + pre + sub;
			} catch (error) {
				throw error;
			}
		}
	}, {
		key: 'myDecode',
		value: function myDecode(b64) {
			try {
				if (b64.length <= 20) {
					return base64_default.a.decode(b64);
				}

				var pre = b64.substr(b64.length - 20, 10),
				    sub = b64.substr(b64.length - 10, 10),
				    con = b64.substr(0, b64.length - 20);

				return base64_default.a.decode(pre + con + sub);
			} catch (error) {
				throw error;
			}
		}
	}, {
		key: 'setDataCookies',
		value: function setDataCookies(data) {
			try {
				if (data) {
					var expires = null;
					try {
						if (!!data[cookiesKey.IS_REMEMBER]) {
							expires = { expires: this.expires };
						}
					} catch (error) {}

					js_cookie_default.a.set(this.key, this.encrypt(data), expires);
				}
			} catch (error) {}
		}
	}, {
		key: 'getDataCookies',
		value: function getDataCookies() {
			try {
				var data = js_cookie_default.a.get(this.key);
				if (data) {
					var dataDecrypt = this.decrypt(data);
					this.resetExpireDate(dataDecrypt);
					return dataDecrypt;
				}
			} catch (error) {}

			return null;
		}
	}, {
		key: 'removeDataCookies',
		value: function removeDataCookies() {
			try {
				js_cookie_default.a.remove(this.key);
			} catch (error) {}

			return null;
		}
	}, {
		key: 'getData',
		value: function getData(key) {
			try {
				var cookiesData = this.getDataCookies();
				if (key in cookiesData) {
					return cookiesData[key];
				}

				return null;
			} catch (error) {
				return null;
			}
		}
	}, {
		key: 'setData',
		value: function setData(key, value) {
			try {
				var cookiesData = this.getDataCookies();
				if (!cookiesData) {
					cookiesData = {};
				}

				cookiesData[key] = value;
				this.setDataCookies(cookiesData);
			} catch (error) {}
		}
	}, {
		key: 'setDatas',
		value: function setDatas(datas) {
			try {
				if (!datas) {
					throw new Error("Invalid datas");
				}

				var cookiesData = this.getDataCookies();
				if (!cookiesData) {
					cookiesData = {};
				}

				for (var key in datas) {
					cookiesData[key] = datas[key];
				}

				this.setDataCookies(cookiesData);
			} catch (error) {}
		}
	}, {
		key: 'removeData',
		value: function removeData(key) {
			try {
				var cookiesData = this.getDataCookies();
				if (key in cookiesData) {
					delete cookiesData[key];
				}

				this.setDataCookies(cookiesData);
			} catch (error) {}
		}
	}, {
		key: 'removeAll',
		value: function removeAll() {
			try {
				this.removeDataCookies();
			} catch (error) {}
		}
	}, {
		key: 'hasData',
		value: function hasData(key) {
			try {
				var cookiesData = this.getDataCookies();
				return key in cookiesData;
			} catch (error) {
				return false;
			}
		}
	}, {
		key: 'resetExpireDate',
		value: function resetExpireDate(cookiesData) {
			try {
				if (!!cookiesData && cookiesData[cookiesKey.IS_REMEMBER] === true) {
					this.setDataCookies(cookiesData);
				}
			} catch (error) {}
		}
	}]);

	return CookiesManager;
}();

/* harmony default export */ var business_CookiesManager = (CookiesManager_CookiesManager);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(3);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/lib/auth.js
/* harmony export (immutable) */ __webpack_exports__["d"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["o"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeCookie;
/* unused harmony export getAccessToken */
/* unused harmony export getRoom */
/* unused harmony export getService */
/* harmony export (immutable) */ __webpack_exports__["b"] = getAllToken;
/* unused harmony export getExpiresToken */
/* harmony export (immutable) */ __webpack_exports__["s"] = setToken;
/* unused harmony export clearToken */
/* harmony export (immutable) */ __webpack_exports__["h"] = getServiceToken;
/* harmony export (immutable) */ __webpack_exports__["f"] = getIsUserActiveDirectory;
/* harmony export (immutable) */ __webpack_exports__["r"] = setServiceToken;
/* unused harmony export getIsRemember */
/* unused harmony export resetExpire */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setRefreshToken; });
/* harmony export (immutable) */ __webpack_exports__["l"] = getUserInfo;
/* harmony export (immutable) */ __webpack_exports__["k"] = getUserId;
/* unused harmony export getUserEmail */
/* harmony export (immutable) */ __webpack_exports__["c"] = getBSRSToken;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setBSRSToken; });
/* unused harmony export getLimitUser */
/* harmony export (immutable) */ __webpack_exports__["i"] = getSystem;
/* unused harmony export getCompanyCode */
/* harmony export (immutable) */ __webpack_exports__["j"] = getUserFirstName;
/* harmony export (immutable) */ __webpack_exports__["q"] = setRoomToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearBSRSToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = getResultPerPage;
/* unused harmony export getImport */
/* harmony export (immutable) */ __webpack_exports__["e"] = getIsSyncRoleAndPolicy;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var EXPIRES_ON = 'expires_on';
var REFRESH_TOKEN = 'refresh_token';
var REFRESH_TOKEN_EXPIRES_DATE = "REFRESH_TOKEN_EXPIRES_DATE";
var SERVICE_TOKEN = 'service_token';
var ROOM = 'room';
var API_URL = 'api_server_url';
var CLIENT_ID = 'client_id';
var SERVICE_TOKEN_EXPIRES = 'service_token_expires_on';
var IS_INTEGRATION = 'isIntegration';
var USER_ID = 'id';
var LIMIT_USERS = 'limitUser';
var FIRST_NAME = 'firstName';
var EMAIL = 'email';
var IS_USER_AD = 'isUserActiveDirectory';
var SYSTEM = 'system';
var COMPANY_CODE = 'companyCode';
var IS_REMEMBER = 'isRemember';

var IS_IMPORTUSERFROMO365 = 'isImportUserFromO365';
var IS_IMPORTUSERFROMEXCEL = 'isImportUserFromExcel';
var IS_IMPORTUSERFROMAD = 'isImportUserFromAD';

var IS_SYNCROLEANDPOLICY = 'isSyncRoleAndPolicy';

var expiresDay = 7;

function getCookie(key) {
    var bCookies = new business_CookiesManager();
    return bCookies.getData(key);
}

function setCookie(key, value, expires) {
    var bCookies = new business_CookiesManager();
    var data = {};
    data[key] = value;

    if (expires) {
        bCookies.expires = expires;
        data[IS_REMEMBER] = true;
    }

    bCookies.setDatas(data);
}

function removeCookie(key) {
    var bCookies = new business_CookiesManager();
    bCookies.removeData(key);
}

function getAccessToken() {
    return getCookie(ACCESS_TOKEN);
}

function getRoom() {
    return getCookie(ROOM);
}

function getService() {
    return getCookie({ CLIENT_ID: CLIENT_ID, API_URL: API_URL });
}

function getAllToken() {
    // if (!getCookie(BSRS_ACCESS_TOKEN)) return {}
    return {
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN),
        userId: getCookie(USER_ID),
        refreshTokenExpireDate: getCookie(REFRESH_TOKEN_EXPIRES_DATE)
    };
}

function getExpiresToken() {
    return getCookie(EXPIRES_ON);
}

function setToken(_ref) {
    var access_token = _ref.access_token,
        expires_on = _ref.expires_on,
        refresh_token = _ref.refresh_token;

    setCookie(ACCESS_TOKEN, access_token);
    setCookie(EXPIRES_ON, expires_on);
    setCookie(REFRESH_TOKEN, refresh_token);
}

function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
    removeCookie(REFRESH_TOKEN_EXPIRES_DATE);
    removeCookie(SERVICE_TOKEN);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(ROOM);
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);

    removeCookie(IS_IMPORTUSERFROMO365);
    removeCookie(IS_IMPORTUSERFROMEXCEL);
    removeCookie(IS_IMPORTUSERFROMAD);
}

function getServiceToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {};
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION)
    };
}

function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD);
}

function setServiceToken(_ref2) {
    var token = _ref2.token,
        expires_on = _ref2.expires_on;

    if ((typeof token === 'undefined' ? 'undefined' : _typeof(token)) !== undefined) setCookie(SERVICE_TOKEN, token);
    if ((typeof expires_on === 'undefined' ? 'undefined' : _typeof(expires_on)) !== undefined) setCookie(SERVICE_TOKEN_EXPIRES, expires_on);
}

function getIsRemember() {
    var isRemember = getCookie(IS_REMEMBER) === 'true' || getCookie(IS_REMEMBER) === true ? true : false;
    return isRemember;
}

function resetExpire() {
    var isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false;
    if (isRemember === true) {
        var keys = Object.keys(js_cookie_default.a.get());
        keys.forEach(function (key) {
            return setCookie(key, getCookie(key), expiresDay);
        });
    }
}

var setRefreshToken = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
        var _res$value, token, expires_on, refreshToken, refreshTokenExpiresDate, isRemember, expires, decode, exp;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!res.value) {
                            _context.next = 17;
                            break;
                        }

                        _res$value = res.value, token = _res$value.token, expires_on = _res$value.expires_on, refreshToken = _res$value.refreshToken, refreshTokenExpiresDate = _res$value.refreshTokenExpiresDate;
                        isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false;
                        expires = null;

                        if (isRemember === true) {
                            expires = expiresDay;
                        }
                        if (token) {
                            setCookie(BSRS_ACCESS_TOKEN, token, expires);
                        }
                        if (expires_on) {
                            setCookie(EXPIRES_ON, expires_on, expires);
                        }

                        if (!refreshToken) {
                            _context.next = 17;
                            break;
                        }

                        setCookie(REFRESH_TOKEN, refreshToken, expires);

                        if (!refreshTokenExpiresDate) {
                            _context.next = 13;
                            break;
                        }

                        setCookie(REFRESH_TOKEN_EXPIRES_DATE, refreshTokenExpiresDate, expires);
                        _context.next = 17;
                        break;

                    case 13:
                        _context.next = 15;
                        return jsonwebtoken_default.a.decode(refreshToken);

                    case 15:
                        decode = _context.sent;

                        if (!!decode) {
                            exp = moment_default.a.unix(decode.exp);

                            setCookie(REFRESH_TOKEN_EXPIRES_DATE, exp.format(dateTimeFormat.apiFullDateTime), expires);
                        }

                    case 17:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function setRefreshToken(_x) {
        return _ref3.apply(this, arguments);
    };
}();

function getUserInfo(access_token) {
    if (!access_token) return {};

    var _jwt$decode = jsonwebtoken_default.a.decode(access_token),
        iat = _jwt$decode.iat,
        exp = _jwt$decode.exp,
        appid = _jwt$decode.appid,
        name = _jwt$decode.name,
        email = _jwt$decode.unique_name;

    return {
        iat: iat,
        exp: exp,
        appid: appid,
        name: name,
        email: email
    };
}

function getUserId() {
    return getCookie(USER_ID);
}

function getUserEmail() {
    return getCookie(EMAIL);
}

function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN);
}

var setBSRSToken = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bsrsToken) {
        var isRemember, isIntegration, expires_on, token, refreshToken, refreshTokenExpiresDate, id, company, firstName, email, isUserActiveDirectory, system_key, companyCode, isImportUserFromO365, isImportUserFromExcel, isImportUserFromAD, isSyncRoleAndPolicy, limitUser, expires, setIsRemember, decode, exp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        isRemember = bsrsToken.isRemember, isIntegration = bsrsToken.isIntegration, expires_on = bsrsToken.expires_on, token = bsrsToken.token, refreshToken = bsrsToken.refreshToken, refreshTokenExpiresDate = bsrsToken.refreshTokenExpiresDate, id = bsrsToken.id, company = bsrsToken.company, firstName = bsrsToken.firstName, email = bsrsToken.email, isUserActiveDirectory = bsrsToken.isUserActiveDirectory, system_key = bsrsToken.system_key, companyCode = bsrsToken.companyCode, isImportUserFromO365 = bsrsToken.isImportUserFromO365, isImportUserFromExcel = bsrsToken.isImportUserFromExcel, isImportUserFromAD = bsrsToken.isImportUserFromAD, isSyncRoleAndPolicy = bsrsToken.isSyncRoleAndPolicy; //isUseActiveDirectory,

                        limitUser = 0, expires = null, setIsRemember = false;

                        if (company && company.limitUser) {
                            // limitUser = company.limitUser
                            if (Number.isInteger(parseInt(company.limitUser, 10))) {
                                limitUser = parseInt(company.limitUser, 10);
                            }
                        }

                        if (typeof isRemember === 'boolean' && isRemember === true) {
                            setIsRemember = true;
                            expires = expiresDay;
                        }

                        setCookie(BSRS_ACCESS_TOKEN, token, expires);
                        setCookie(REFRESH_TOKEN, refreshToken, expires);

                        if (!refreshToken) {
                            _context2.next = 17;
                            break;
                        }

                        console.log("0000", refreshTokenExpiresDate);

                        if (!refreshTokenExpiresDate) {
                            _context2.next = 12;
                            break;
                        }

                        setCookie(REFRESH_TOKEN_EXPIRES_DATE, refreshTokenExpiresDate, expires);
                        _context2.next = 17;
                        break;

                    case 12:
                        _context2.next = 14;
                        return jsonwebtoken_default.a.decode(refreshToken);

                    case 14:
                        decode = _context2.sent;

                        console.log("1111", decode);
                        if (!!decode) {
                            exp = moment_default.a.unix(decode.exp);

                            setCookie(REFRESH_TOKEN_EXPIRES_DATE, exp.format(dateTimeFormat.apiFullDateTime), expires);
                        }

                    case 17:
                        // setCookie(SERVICE_TOKEN, access_token, expires)
                        // setCookie(SERVICE_TOKEN_EXPIRES, expires_on, expires)
                        setCookie(EXPIRES_ON, expires_on, expires);
                        setCookie(IS_INTEGRATION, isIntegration, expires);
                        setCookie(USER_ID, id, expires);
                        setCookie(LIMIT_USERS, limitUser, expires);
                        setCookie(FIRST_NAME, firstName, expires);
                        setCookie(EMAIL, email, expires);
                        setCookie(IS_USER_AD, isUserActiveDirectory, expires);
                        setCookie(SYSTEM, system_key, expires);
                        setCookie(COMPANY_CODE, companyCode, expires);
                        setCookie(IS_REMEMBER, setIsRemember, expires);

                        setCookie(IS_IMPORTUSERFROMO365, typeof isImportUserFromO365 === 'boolean' ? isImportUserFromO365 : false, expires);
                        setCookie(IS_IMPORTUSERFROMEXCEL, typeof isImportUserFromExcel === 'boolean' ? isImportUserFromExcel : false, expires);
                        setCookie(IS_IMPORTUSERFROMAD, typeof isImportUserFromAD === 'boolean' ? isImportUserFromAD : false, expires);
                        setCookie(IS_SYNCROLEANDPOLICY, typeof isSyncRoleAndPolicy === 'boolean' ? isSyncRoleAndPolicy : false, expires);

                    case 31:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function setBSRSToken(_x2) {
        return _ref4.apply(this, arguments);
    };
}();

function getLimitUser() {
    var get = getCookie(LIMIT_USERS);
    var dataReturn = -1;
    if (get && Number.isInteger(parseInt(get, 10))) {
        dataReturn = parseInt(get, 10);
    }
    return dataReturn;
}

function getSystem() {
    var system = getCookie(SYSTEM);
    return system ? system : '';
}

function getCompanyCode() {
    return getCookie(COMPANY_CODE);
}

function getUserFirstName() {
    return getCookie(FIRST_NAME);
}

function setRoomToken(room, client_id, api_server_url) {
    setCookie(ROOM, room);
    setCookie(CLIENT_ID, client_id);
    setCookie(API_URL, api_server_url);
}

function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    // removeCookie(SERVICE_TOKEN)
    // removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);
    removeCookie(LIMIT_USERS);
    removeCookie(FIRST_NAME);
    removeCookie(EMAIL);
    removeCookie(IS_USER_AD);
    removeCookie(SYSTEM);
    removeCookie(COMPANY_CODE);
    removeCookie(IS_REMEMBER);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
    removeCookie(REFRESH_TOKEN_EXPIRES_DATE);

    removeCookie(IS_IMPORTUSERFROMO365);
    removeCookie(IS_IMPORTUSERFROMEXCEL);
    removeCookie(IS_IMPORTUSERFROMAD);
    removeCookie(IS_SYNCROLEANDPOLICY);
}

function getResultPerPage() {
    return 10;
}

function getImport() {
    var isImportUserFromO365 = false,
        isImportUserFromExcel = false,
        isImportUserFromAD = false;

    if (getCookie(IS_IMPORTUSERFROMO365) === 'true' || getCookie(IS_IMPORTUSERFROMO365) === true) {
        isImportUserFromO365 = true;
    }

    if (getCookie(IS_IMPORTUSERFROMEXCEL) === 'true' || getCookie(IS_IMPORTUSERFROMEXCEL) === true) {
        isImportUserFromExcel = true;
    }

    if (getCookie(IS_IMPORTUSERFROMAD) === 'true' || getCookie(IS_IMPORTUSERFROMAD) === true) {
        isImportUserFromAD = true;
    }

    return {
        isImportUserFromO365: isImportUserFromO365,
        isImportUserFromExcel: isImportUserFromExcel,
        isImportUserFromAD: isImportUserFromAD
    };
}

function getIsSyncRoleAndPolicy() {
    var isSyncRoleAndPolicy = false;

    if (getCookie(IS_SYNCROLEANDPOLICY) === 'true' || getCookie(IS_SYNCROLEANDPOLICY) === true) {
        isSyncRoleAndPolicy = true;
    }

    return isSyncRoleAndPolicy;
}

/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(17);

// CONCATENATED MODULE: ./src/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var src_error = ({
	errorMessage: errorMessage
});
// CONCATENATED MODULE: ./src/features/ui/actions.js
/* harmony export (immutable) */ __webpack_exports__["a"] = setError;





function setError(hasError) {
	var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


	var defaultError = {
		code: "00010000",
		message: src_error ? src_error["00010000"] : ""
	};

	if (typeof error === 'string' && error in src_error) {
		defaultError = {
			code: error,
			message: src_error[error]
		};
	} else if (error !== null && error !== undefined && error.code !== undefined && error.message !== undefined) {
		defaultError = error;
	} else if (error === null || hasError === false) {
		defaultError = null;
	}

	return {
		type: types["_465" /* SET_ERROR */],
		hasError: hasError,
		error: defaultError
	};
}

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(684);


/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(164);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__(689);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(891);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./src/features/ui/components/Root.js
var Root = __webpack_require__(893);
var Root_default = /*#__PURE__*/__webpack_require__.n(Root);

// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(328);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// EXTERNAL MODULE: ./src/wording/pages/login/ENG.json
var ENG = __webpack_require__(1314);
var ENG_default = /*#__PURE__*/__webpack_require__.n(ENG);

// EXTERNAL MODULE: ./src/wording/pages/button/ENG.json
var button_ENG = __webpack_require__(1315);
var button_ENG_default = /*#__PURE__*/__webpack_require__.n(button_ENG);

// EXTERNAL MODULE: ./src/wording/pages/header/ENG.json
var header_ENG = __webpack_require__(1316);
var header_ENG_default = /*#__PURE__*/__webpack_require__.n(header_ENG);

// EXTERNAL MODULE: ./src/wording/pages/room/ENG.json
var room_ENG = __webpack_require__(1317);
var room_ENG_default = /*#__PURE__*/__webpack_require__.n(room_ENG);

// EXTERNAL MODULE: ./src/wording/pages/advanceSearch/ENG.json
var advanceSearch_ENG = __webpack_require__(1318);
var advanceSearch_ENG_default = /*#__PURE__*/__webpack_require__.n(advanceSearch_ENG);

// EXTERNAL MODULE: ./src/wording/pages/location/ENG.json
var location_ENG = __webpack_require__(1319);
var location_ENG_default = /*#__PURE__*/__webpack_require__.n(location_ENG);

// EXTERNAL MODULE: ./src/wording/pages/user/ENG.json
var user_ENG = __webpack_require__(1320);
var user_ENG_default = /*#__PURE__*/__webpack_require__.n(user_ENG);

// EXTERNAL MODULE: ./src/wording/pages/role/ENG.json
var role_ENG = __webpack_require__(1321);
var role_ENG_default = /*#__PURE__*/__webpack_require__.n(role_ENG);

// EXTERNAL MODULE: ./src/wording/pages/profile/ENG.json
var profile_ENG = __webpack_require__(1322);
var profile_ENG_default = /*#__PURE__*/__webpack_require__.n(profile_ENG);

// EXTERNAL MODULE: ./src/wording/pages/bg/ENG.json
var bg_ENG = __webpack_require__(1323);
var bg_ENG_default = /*#__PURE__*/__webpack_require__.n(bg_ENG);

// EXTERNAL MODULE: ./src/wording/pages/facNfood/ENG.json
var facNfood_ENG = __webpack_require__(1324);
var facNfood_ENG_default = /*#__PURE__*/__webpack_require__.n(facNfood_ENG);

// EXTERNAL MODULE: ./src/wording/pages/iot/ENG.json
var iot_ENG = __webpack_require__(1325);
var iot_ENG_default = /*#__PURE__*/__webpack_require__.n(iot_ENG);

// EXTERNAL MODULE: ./src/wording/pages/event/ENG.json
var event_ENG = __webpack_require__(1326);
var event_ENG_default = /*#__PURE__*/__webpack_require__.n(event_ENG);

// EXTERNAL MODULE: ./src/wording/pages/order/ENG.json
var order_ENG = __webpack_require__(1327);
var order_ENG_default = /*#__PURE__*/__webpack_require__.n(order_ENG);

// EXTERNAL MODULE: ./src/wording/pages/setting/ENG.json
var setting_ENG = __webpack_require__(1328);
var setting_ENG_default = /*#__PURE__*/__webpack_require__.n(setting_ENG);

// EXTERNAL MODULE: ./src/wording/pages/report/ENG.json
var report_ENG = __webpack_require__(1329);
var report_ENG_default = /*#__PURE__*/__webpack_require__.n(report_ENG);

// EXTERNAL MODULE: ./src/wording/pages/Monitor/ENG.json
var Monitor_ENG = __webpack_require__(1330);
var Monitor_ENG_default = /*#__PURE__*/__webpack_require__.n(Monitor_ENG);

// EXTERNAL MODULE: ./src/wording/pages/validate/ENG.json
var validate_ENG = __webpack_require__(1331);
var validate_ENG_default = /*#__PURE__*/__webpack_require__.n(validate_ENG);

// EXTERNAL MODULE: ./src/wording/pages/modal/ENG.json
var modal_ENG = __webpack_require__(1332);
var modal_ENG_default = /*#__PURE__*/__webpack_require__.n(modal_ENG);

// EXTERNAL MODULE: ./src/wording/pages/error/ENG.json
var error_ENG = __webpack_require__(1333);
var error_ENG_default = /*#__PURE__*/__webpack_require__.n(error_ENG);

// EXTERNAL MODULE: ./src/wording/pages/integration/EN.json
var EN = __webpack_require__(1334);
var EN_default = /*#__PURE__*/__webpack_require__.n(EN);

// CONCATENATED MODULE: ./src/wording/en.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };























/* harmony default export */ var en = ({
    login: _extends({}, ENG_default.a),
    button: _extends({}, button_ENG_default.a),
    header: _extends({}, header_ENG_default.a),
    room: _extends({}, room_ENG_default.a),
    advanceSearch: _extends({}, advanceSearch_ENG_default.a),
    location: _extends({}, location_ENG_default.a),
    user: _extends({}, user_ENG_default.a),
    role: _extends({}, role_ENG_default.a),
    profile: _extends({}, profile_ENG_default.a),
    bg: _extends({}, bg_ENG_default.a),
    facNfood: _extends({}, facNfood_ENG_default.a),
    iot: _extends({}, iot_ENG_default.a),
    event: _extends({}, event_ENG_default.a),
    order: _extends({}, order_ENG_default.a),
    setting: _extends({}, setting_ENG_default.a),
    report: _extends({}, report_ENG_default.a),
    monitor: _extends({}, Monitor_ENG_default.a),
    validate: _extends({}, validate_ENG_default.a),
    modal: _extends({}, modal_ENG_default.a),
    error: _extends({}, error_ENG_default.a),
    integration: _extends({}, EN_default.a),
    noResult: "No Result",
    logo: "Devices Logo",
    home: "Home",
    name: "Name",
    fileSize: "File Size Limit = 10 MB",
    selectAll: "Select All",
    takePhoto: "Take Photo",
    uploadPhoto: "Upload Photo",
    deletePhoto: "Delete Photo"
});
// EXTERNAL MODULE: ./src/wording/pages/login/TH.json
var TH = __webpack_require__(1335);
var TH_default = /*#__PURE__*/__webpack_require__.n(TH);

// EXTERNAL MODULE: ./src/wording/pages/button/TH.json
var button_TH = __webpack_require__(1336);
var button_TH_default = /*#__PURE__*/__webpack_require__.n(button_TH);

// EXTERNAL MODULE: ./src/wording/pages/header/TH.json
var header_TH = __webpack_require__(1337);
var header_TH_default = /*#__PURE__*/__webpack_require__.n(header_TH);

// EXTERNAL MODULE: ./src/wording/pages/room/TH.json
var room_TH = __webpack_require__(1338);
var room_TH_default = /*#__PURE__*/__webpack_require__.n(room_TH);

// EXTERNAL MODULE: ./src/wording/pages/advanceSearch/TH.json
var advanceSearch_TH = __webpack_require__(1339);
var advanceSearch_TH_default = /*#__PURE__*/__webpack_require__.n(advanceSearch_TH);

// EXTERNAL MODULE: ./src/wording/pages/location/TH.json
var location_TH = __webpack_require__(1340);
var location_TH_default = /*#__PURE__*/__webpack_require__.n(location_TH);

// EXTERNAL MODULE: ./src/wording/pages/user/TH.json
var user_TH = __webpack_require__(1341);
var user_TH_default = /*#__PURE__*/__webpack_require__.n(user_TH);

// EXTERNAL MODULE: ./src/wording/pages/role/TH.json
var role_TH = __webpack_require__(1342);
var role_TH_default = /*#__PURE__*/__webpack_require__.n(role_TH);

// EXTERNAL MODULE: ./src/wording/pages/profile/TH.json
var profile_TH = __webpack_require__(1343);
var profile_TH_default = /*#__PURE__*/__webpack_require__.n(profile_TH);

// EXTERNAL MODULE: ./src/wording/pages/bg/TH.json
var bg_TH = __webpack_require__(1344);
var bg_TH_default = /*#__PURE__*/__webpack_require__.n(bg_TH);

// EXTERNAL MODULE: ./src/wording/pages/facNfood/TH.json
var facNfood_TH = __webpack_require__(1345);
var facNfood_TH_default = /*#__PURE__*/__webpack_require__.n(facNfood_TH);

// EXTERNAL MODULE: ./src/wording/pages/iot/TH.json
var iot_TH = __webpack_require__(1346);
var iot_TH_default = /*#__PURE__*/__webpack_require__.n(iot_TH);

// EXTERNAL MODULE: ./src/wording/pages/event/TH.json
var event_TH = __webpack_require__(1347);
var event_TH_default = /*#__PURE__*/__webpack_require__.n(event_TH);

// EXTERNAL MODULE: ./src/wording/pages/order/TH.json
var order_TH = __webpack_require__(1348);
var order_TH_default = /*#__PURE__*/__webpack_require__.n(order_TH);

// EXTERNAL MODULE: ./src/wording/pages/setting/TH.json
var setting_TH = __webpack_require__(1349);
var setting_TH_default = /*#__PURE__*/__webpack_require__.n(setting_TH);

// EXTERNAL MODULE: ./src/wording/pages/report/TH.json
var report_TH = __webpack_require__(1350);
var report_TH_default = /*#__PURE__*/__webpack_require__.n(report_TH);

// EXTERNAL MODULE: ./src/wording/pages/Monitor/TH.json
var Monitor_TH = __webpack_require__(1351);
var Monitor_TH_default = /*#__PURE__*/__webpack_require__.n(Monitor_TH);

// EXTERNAL MODULE: ./src/wording/pages/validate/TH.json
var validate_TH = __webpack_require__(1352);
var validate_TH_default = /*#__PURE__*/__webpack_require__.n(validate_TH);

// EXTERNAL MODULE: ./src/wording/pages/modal/TH.json
var modal_TH = __webpack_require__(1353);
var modal_TH_default = /*#__PURE__*/__webpack_require__.n(modal_TH);

// EXTERNAL MODULE: ./src/wording/pages/error/TH.json
var error_TH = __webpack_require__(1354);
var error_TH_default = /*#__PURE__*/__webpack_require__.n(error_TH);

// EXTERNAL MODULE: ./src/wording/pages/integration/TH.json
var integration_TH = __webpack_require__(1355);
var integration_TH_default = /*#__PURE__*/__webpack_require__.n(integration_TH);

// CONCATENATED MODULE: ./src/wording/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };























/* harmony default export */ var th = ({
    login: th__extends({}, TH_default.a),
    button: th__extends({}, button_TH_default.a),
    header: th__extends({}, header_TH_default.a),
    room: th__extends({}, room_TH_default.a),
    advanceSearch: th__extends({}, advanceSearch_TH_default.a),
    location: th__extends({}, location_TH_default.a),
    user: th__extends({}, user_TH_default.a),
    role: th__extends({}, role_TH_default.a),
    profile: th__extends({}, profile_TH_default.a),
    bg: th__extends({}, bg_TH_default.a),
    facNfood: th__extends({}, facNfood_TH_default.a),
    iot: th__extends({}, iot_TH_default.a),
    event: th__extends({}, event_TH_default.a),
    order: th__extends({}, order_TH_default.a),
    setting: th__extends({}, setting_TH_default.a),
    report: th__extends({}, report_TH_default.a),
    monitor: th__extends({}, Monitor_TH_default.a),
    validate: th__extends({}, validate_TH_default.a),
    modal: th__extends({}, modal_TH_default.a),
    error: th__extends({}, error_TH_default.a),
    integration: th__extends({}, integration_TH_default.a),
    noResult: "ไม่พบข้อมูล",
    logo: "สัญลักษณ์ในทุกอุปกรณ์",
    home: "หน้าหลัก",
    name: "ชื่อ",
    fileSize: "ขนาดไฟล์ต้องไม่เกิน 10 MB",
    selectAll: "เลือกทั้งหมด",
    takePhoto: "ถ่ายภาพ",
    uploadPhoto: "อัพโหลดรูปภาพ",
    deletePhoto: "ลบรูปภาพ"
});
// CONCATENATED MODULE: ./src/index.js











Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('th');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    return react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root_default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(894);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var es = __webpack_require__(230);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var react_redux_es = __webpack_require__(54);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(901);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(902);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(329);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(327);

// CONCATENATED MODULE: ./src/features/ui/selectors.js
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getError(state) {
    return state.ui.error;
}

function getHasBSRSLoginFail(state) {
    return state.ui.hasBSRSLoginFail === true;
}
// EXTERNAL MODULE: ./src/features/ui/actions.js + 1 modules
var actions = __webpack_require__(682);

// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(328);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// CONCATENATED MODULE: ./src/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ErrorMessageDialog_ErrorMessage = function (_React$Component) {
	_inherits(ErrorMessage, _React$Component);

	function ErrorMessage() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ErrorMessage);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
			_this.setState({ open: false });
			_this.props.clearError();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ErrorMessage, [{
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProp) {
			this.setState({ open: nextProp.hasError });
		}
	}, {
		key: 'render',
		value: function render() {
			var t = this.props.t;

			return react_default.a.createElement(
				dist_es["u" /* Modal */],
				{ size: "small", open: this.state.open, onClose: this.close },
				react_default.a.createElement(
					dist_es["u" /* Modal */].Header,
					null,
					t('error.systemMessage')
				),
				react_default.a.createElement(
					dist_es["u" /* Modal */].Content,
					null,
					this.props.hasError && this.props.error && this.props.error.code !== undefined && this.props.error.message !== undefined ? react_default.a.createElement(
						dist_es["u" /* Modal */].Description,
						null,
						react_default.a.createElement(
							dist_es["k" /* Grid */],
							null,
							react_default.a.createElement(
								dist_es["k" /* Grid */].Row,
								null,
								react_default.a.createElement(
									dist_es["k" /* Grid */].Column,
									{ width: 2 },
									t('error.code')
								),
								react_default.a.createElement(
									dist_es["k" /* Grid */].Column,
									{ width: 14 },
									this.props.error.code
								)
							),
							react_default.a.createElement(
								dist_es["k" /* Grid */].Row,
								null,
								react_default.a.createElement(
									dist_es["k" /* Grid */].Column,
									{ width: 2 },
									t('error.message')
								),
								react_default.a.createElement(
									dist_es["k" /* Grid */].Column,
									{ width: 14 },
									t('error.' + this.props.error.code).includes(this.props.error.code) ? this.props.error.message : t('error.' + this.props.error.code)
								)
							)
						)
					) : react_default.a.createElement(
						'p',
						null,
						t('error.00000000')
					)
				),
				react_default.a.createElement(
					dist_es["u" /* Modal */].Actions,
					null,
					react_default.a.createElement(
						dist_es["b" /* Button */],
						{ basic: true, color: 'blue', className: 'okButton', onClick: this.close,
							onClose: this.close },
						t('button.ok')
					)
				)
			);
		}
	}]);

	return ErrorMessage;
}(react_default.a.Component);

/* harmony default export */ var ErrorMessageDialog = (Object(Recompose["a" /* compose */])(Object(react_redux_es["connect"])(function (state, props) {
	return {
		hasError: getHasError(state),
		error: getError(state)
	};
}, function (dispatch) {
	return {
		clearError: function clearError() {
			dispatch(Object(actions["a" /* setError */])(false));
		}
	};
}))(Object(react_switch_lang["translate"])(ErrorMessageDialog_ErrorMessage)));
// CONCATENATED MODULE: ./src/features/ui/components/Loading.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// import { Dimmer, Loader, } from 'semantic-ui-react'



var Loading_LoadingComponent = function LoadingComponent(props) {
    return react_default.a.createElement('div', null);
    // props.isLoading ?
    // 	<Dimmer active>
    // 		<Loader size='large'>Loading</Loader>
    // 	</Dimmer>
    // 	:
    // ""
};

/* harmony default export */ var Loading = (Object(Recompose["a" /* compose */])(Object(react_redux_es["connect"])(function (state) {
    return {
        isLoading: getIsLoading(state)
    };
}), Object(Recompose["c" /* withProps */])(function (props) {
    return _extends({}, props);
}))(Loading_LoadingComponent));
// EXTERNAL MODULE: ./src/features/ui/components/Loadable.js
var Loadable = __webpack_require__(662);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(3);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/lib/index.js
var lib = __webpack_require__(165);

// CONCATENATED MODULE: ./src/lib/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Auth = {
	isAuthenticated: function isAuthenticated() {
		var allToken = Object(lib["i" /* getAllToken */])(),
		    refreshToken = allToken.refresh_token,
		    refreshTokenExpireDate = allToken.refreshTokenExpireDate;

		return !!refreshToken && moment_default()().isBefore(moment_default()(refreshTokenExpireDate));
	},
	isIntegration: function isIntegration() {
		return true;
	}
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			console.log("999", Auth.isAuthenticated(), props.match.url);
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/login' });
			}

			if (Auth.isIntegration() === false && props.match.url !== "/integration") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/integration' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/' });
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};

/* harmony default export */ var routePermission = ({
	PrivateRoute: routePermission_PrivateRoute,
	PublicRoute: routePermission_PublicRoute
});
// CONCATENATED MODULE: ./src/features/ui/components/Routes.js





var AsyncHome = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1842));
	}
});

var AsyncNotFound = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 1843));
	}
});

var AsyncLoginBSRS = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 1844));
	}
});

var AsyncSettingsIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1845));
	}
});

var AsyncAuthorizeO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 1848));
	}
});

var AsyncUserInfo = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1849));
	}
});

var AsyncUserChangePassword = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1850));
	}
});

var AsyncReportSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1851));
	}
});

var AsyncUserReport = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 1852));
	}
});

var AsyncRoomReportNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1853));
	}
});

var AsyncUserSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 1854));
	}
});

var AsyncRoomSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1855));
	}
});

var AsyncFacilitySummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 1856));
	}
});

var AsyncReserveNotUseByUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 1857));
	}
});

var AsyncReserveNotUseByRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 1858));
	}
});

var AsyncReportUserAttendance = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 1859));
	}
});

var AsyncFoodSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, 1860));
	}
});

var AsyncDeleteEventSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, 1861));
	}
});

var AsyncSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1862));
	}
});

var AsyncChangeSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1863));
	}
});

var AsyncListRoomsO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1864));
	}
});

var AsyncListRoomsCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1865));
	}
});

var AsyncListRoomsSubscribe = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1866));
	}
});

var AsyncCreateRoomNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1867));
	}
});

var AsyncUpdateRoomNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1868));
	}
});

var AsyncViewRoomCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1869));
	}
});

var AsyncListUsersCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1870));
	}
});

var AsyncListUsersO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1871));
	}
});

var AsyncListUsersAD = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1872));
	}
});

var AsyncCreateUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 1873));
	}
});

var AsyncUpdateUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1874));
	}
});

var AsyncViewUserCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1875));
	}
});

var AsyncAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1876));
	}
});

var AsyncAmenityUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 1877));
	}
});

var AsyncViewAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1878));
	}
});

var AsyncAmenityCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 1879));
	}
});

var AsyncBuildingCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1880));
	}
});
var AsyncBuildingUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1881));
	}
});
var AsyncViewBuilding = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1882));
	}
});
var AsyncBuilding = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1883));
	}
});

var AsyncBackgroundCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 1884));
	}
});
var AsyncBackgroundUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 1885));
	}
});
var AsyncViewBackground = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1886));
	}
});
var AsyncBackground = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1887));
	}
});

var AsyncFloorCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1888));
	}
});
var AsyncFloorUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1889));
	}
});
var AsyncViewFloor = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1890));
	}
});
var AsyncFloor = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1891));
	}
});

var AsyncZoneCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1892));
	}
});
var AsyncZoneUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1893));
	}
});
var AsyncViewZone = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1894));
	}
});
var AsyncZone = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1895));
	}
});

var AsyncFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1896));
	}
});

var AsyncFbsUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 1897));
	}
});

var AsyncViewFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1898));
	}
});

var AsyncFbsCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 1899));
	}
});

var AsyncListUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1900));
	}
});

var AsyncCreateUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 1901));
	}
});

var AsyncUpdateUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 1902));
	}
});

var AsyncViewUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1903));
	}
});

var AsyncCreateProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1904));
	}
});

var AsyncListProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1905));
	}
});

var AsyncUpdateProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1906));
	}
});

var AsyncViewProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1907));
	}
});

var AsyncIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1908));
	}
});

var AsyncReportOverview = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1909));
	}
});

var AsyncReportByRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1910));
	}
});

var AsyncReportByUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1911));
	}
});

var AsyncReportRoomDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1912));
	}
});

var AsyncReportUserDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1913));
	}
});

var AsyncReportOverviewDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1914));
	}
});

var AsyncReportOverviewUserDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1915));
	}
});

var AsyncTerm = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1916));
	}
});

var AsyncEditTerm = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1917));
	}
});

var AsyncFaq = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1918));
	}
});

var AsyncEditFaq = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1919));
	}
});

var AsyncContactUs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1920));
	}
});

var AsyncEditContactUs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1921));
	}
});

var AsyncFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1922));
	}
});

var AsyncUpdateFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 1923));
	}
});

var AsyncCreateFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 1924));
	}
});
var AsyncFbsCategoryView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1925));
	}
});

var AsyncExchangeIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1926));
	}
});

var AsyncGoogleIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1927));
	}
});

var AsyncSettingsGoogleIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1928));
	}
});

var AsyncSettingsExchangeIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1929));
	}
});

var AsyncRoomQRCode = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1930));
	}
});

var AsyncAdminViewEvents = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1931));
	}
});

var AsyncDisplayList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1932));
	}
});

var AsyncRoomDisableList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1933));
	}
});

var AsyncRoomDisableCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 1934));
	}
});

var AsyncRoomDisableUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 1935));
	}
});

var AsyncRoomDisableView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1936));
	}
});

var AsyncConcurrentList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1937));
	}
});

var AsyncRoleList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1938));
	}
});

var AsyncRoleCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 1939));
	}
});

var AsyncRoleView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1940));
	}
});

var AsyncRoleUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 1941));
	}
});

var AsyncRoomFormatList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1942));
	}
});

var AsyncRoomFormatListCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 1943));
	}
});

var AsyncRoomFormatListView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1944));
	}
});

var AsyncRoomFormatListUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 1945));
	}
});

var AsyncOrderFbsList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1946));
	}
});

var AsyncOrderFbsUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1947));
	}
});

var AsyncOrderFbsView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1948));
	}
});

var AsyncOrderCreateFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1949));
	}
});

var AsyncOrderCreateAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1950));
	}
});

var AsyncOrderAmenityList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1951));
	}
});

var AsyncOrderAmenityUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1952));
	}
});

var AsyncOrderAmenityView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1953));
	}
});

var AsyncReportFoodSummaryByEvent = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 1954));
	}
});

var AsyncReportFacilitySummaryByEvent = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 1955));
	}
});

var AsyncViewEventsOrder = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1956));
	}
});

var AsyncEventTypeList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1957));
	}
});

var AsyncEventTypeView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1958));
	}
});

var AsyncEventTypeCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 1959));
	}
});

var AsyncEventTypeUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1960));
	}
});

var LogoSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1961));
	}
});

var LogoUpdateSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1962));
	}
});

var SessionExpire = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 1963));
	}
});
/* harmony default export */ var Routes = (function () {
	return react_default.a.createElement(
		es["e" /* Switch */],
		null,
		react_default.a.createElement(routePermission.PrivateRoute, { exact: true, path: '/', component: AsyncHome }),
		react_default.a.createElement(routePermission.PublicRoute, { path: '/sessionExpire', component: SessionExpire }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/integration', component: AsyncIntegrations }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/exchangeIntegration', component: AsyncExchangeIntegrations }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/googleIntegration', component: AsyncGoogleIntegrations }),
		react_default.a.createElement(routePermission.PublicRoute, { path: '/login', component: AsyncLoginBSRS }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/integration', component: AsyncSettingsIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/googleIntegration', component: AsyncSettingsGoogleIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/exchangeIntegration', component: AsyncSettingsExchangeIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/term', component: AsyncTerm }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editterm/:lang', component: AsyncEditTerm }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/faq', component: AsyncFaq }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editfaq/:lang', component: AsyncEditFaq }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/contact', component: AsyncContactUs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editcontact/:lang', component: AsyncEditContactUs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting', component: AsyncSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/changesetting', component: AsyncChangeSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/system', component: AsyncListRoomsO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/core/qrcode/:email', component: AsyncRoomQRCode }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/core', component: AsyncListRoomsCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/subscribe', component: AsyncListRoomsSubscribe }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/create', component: AsyncCreateRoomNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/update/:email', component: AsyncUpdateRoomNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/view/:email', component: AsyncViewRoomCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/o365', component: AsyncListUsersO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/ad', component: AsyncListUsersAD }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/core', component: AsyncListUsersCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/create', component: AsyncCreateUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/update/:id', component: AsyncUpdateUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/view/:id', component: AsyncViewUserCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/list', component: AsyncListUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/create', component: AsyncCreateUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/update/:id', component: AsyncUpdateUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/view/:id', component: AsyncViewUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/concurrent', component: AsyncConcurrentList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/list', component: AsyncListProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/create', component: AsyncCreateProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/update/:id', component: AsyncUpdateProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/view/:id', component: AsyncViewProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/create', component: AsyncAmenityCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/update/:id', component: AsyncAmenityUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/view/:id', component: AsyncViewAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity', component: AsyncAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/create', component: AsyncBuildingCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/update/:id', component: AsyncBuildingUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/view/:id', component: AsyncViewBuilding }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building', component: AsyncBuilding }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/create', component: AsyncBackgroundCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/update/:id', component: AsyncBackgroundUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/view/:id', component: AsyncViewBackground }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background', component: AsyncBackground }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/create', component: AsyncFloorCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/update/:id', component: AsyncFloorUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/view/:id', component: AsyncViewFloor }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor', component: AsyncFloor }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/create', component: AsyncZoneCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/update/:id', component: AsyncZoneUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/view/:id', component: AsyncViewZone }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone', component: AsyncZone }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype/create', component: AsyncEventTypeCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype/update/:id', component: AsyncEventTypeUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype/view/:id', component: AsyncEventTypeView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype', component: AsyncEventTypeList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/view/:id', component: AsyncRoleView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/update/:id', component: AsyncRoleUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/list', component: AsyncRoleList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/create', component: AsyncRoleCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/update/:id', component: AsyncUpdateFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/create', component: AsyncCreateFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/:id', component: AsyncFbsCategoryView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory', component: AsyncFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/create', component: AsyncFbsCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/update/:id', component: AsyncFbsUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/view/:id', component: AsyncViewFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs', component: AsyncFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/authorize', component: AsyncAuthorizeO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/userInfo', component: AsyncUserInfo }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/changepassword/:id', component: AsyncUserChangePassword }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/overview/user/:range', component: AsyncReportOverviewUserDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/overview/room/:range', component: AsyncReportOverviewDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/user/:id', component: AsyncReportUserDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/room/:email', component: AsyncReportRoomDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/statussummary', component: AsyncReportSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/overview', component: AsyncReportOverview }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/byroom', component: AsyncReportByRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/byuser', component: AsyncReportByUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/roomreport', component: AsyncRoomReportNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/userreport', component: AsyncUserReport }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/usersummary', component: AsyncUserSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/roomsummary', component: AsyncRoomSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/deleteeventsummary', component: AsyncDeleteEventSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/foodsummary', component: AsyncFoodSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/facilitysummary', component: AsyncFacilitySummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/foodsummarybyevent', component: AsyncReportFoodSummaryByEvent }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/facilitysummarybyevent', component: AsyncReportFacilitySummaryByEvent }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/notuse/user', component: AsyncReserveNotUseByUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/notuse/room', component: AsyncReserveNotUseByRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/userattendance', component: AsyncReportUserAttendance }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/logo/update', component: LogoUpdateSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/logo', component: LogoSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/display', component: AsyncDisplayList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable/update/:id', component: AsyncRoomDisableUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable/view/:id', component: AsyncRoomDisableView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable/create', component: AsyncRoomDisableCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable', component: AsyncRoomDisableList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat/view/:id', component: AsyncRoomFormatListView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat/update/:id', component: AsyncRoomFormatListUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat/create', component: AsyncRoomFormatListCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat', component: AsyncRoomFormatList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderfbs/create/:icaluid/:roomemail', component: AsyncOrderCreateFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderfbs/update/:id/:roomemail', component: AsyncOrderFbsUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderfbs/view/:id/:roomemail', component: AsyncOrderFbsView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/order', component: AsyncOrderFbsList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderamenity/create/:icaluid/:roomemail', component: AsyncOrderCreateAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderamenity/update/:id/:roomemail', component: AsyncOrderAmenityUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderamenity/view/:id/:roomemail', component: AsyncOrderAmenityView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderamenity', component: AsyncOrderAmenityList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/events/order', component: AsyncViewEventsOrder }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/events', component: AsyncAdminViewEvents }),
		react_default.a.createElement(routePermission.PrivateRoute, { component: AsyncNotFound })
	);
});
// EXTERNAL MODULE: ./src/scss/index.scss
var scss = __webpack_require__(1312);
var scss_default = /*#__PURE__*/__webpack_require__.n(scss);

// CONCATENATED MODULE: ./src/features/ui/components/App.js


// import Header from './Header'

// import Footer from './Footer'
// import { Container } from 'semantic-ui-react'



/* harmony default export */ var App = (function () {
	return react_default.a.createElement(Routes, null)
	// <div className="application">
	// 	<div>
	// 		<Header />
	// 		<Container style={{ minHeight: '219px', marginBottom: '5rem' }}>
	// 			<Routes />
	// 		</Container>
	// 		<Footer />
	// 	</div>
	// </div>
	;
});
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js








var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
	return react_default.a.createElement(
		react_redux_es["Provider"],
		{ store: store },
		react_default.a.createElement(
			react_default.a.Fragment,
			null,
			react_default.a.createElement(
				es["a" /* BrowserRouter */],
				null,
				react_default.a.createElement(App, null)
			),
			react_default.a.createElement(ErrorMessageDialog, null),
			react_default.a.createElement(Loading, null)
		)
	);
});

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(903);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(146);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(904);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(659);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 228 modules
var redux_form_es = __webpack_require__(680);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var lib = __webpack_require__(1046);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(17);

// EXTERNAL MODULE: ./src/lib/index.js
var src_lib = __webpack_require__(165);

// CONCATENATED MODULE: ./src/features/auth/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var allToken = Object(src_lib["i" /* getAllToken */])();
var bsrsToken = Object(src_lib["j" /* getBSRSToken */])();
var serviceToken = Object(src_lib["o" /* getServiceToken */])();

var reducer_initialState = {
  token: allToken,
  bsrsToken: bsrsToken,
  user: Object(src_lib["s" /* getUserInfo */])(allToken.access_token),
  serviceToken: serviceToken
};

/* harmony default export */ var reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case types["_451" /* O365_REGISTER_SUCCESS */]:
      {
        return _extends({}, state, {
          token: _extends({}, action.payload.token),
          user: Object(src_lib["s" /* getUserInfo */])(action.payload.token.access_token)
        });
      }
    case types["c" /* BSRS_LOGIN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken
        });
      }
    case types["f" /* BSRS_SERVICE_TOKEN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken,
          serviceToken: action.payload.serviceToken
        });
      }
    case types["_412" /* LOGOUT */]:
      return _extends({}, state, {
        bsrsToken: undefined
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/features/ui/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var ui_reducer_initialState = {
    hasError: false,
    isLoading: false,
    error: null
};

/* harmony default export */ var ui_reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ui_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["_66" /* CORE_DELETE_ROLE_REQUEST */]:
        case types["_392" /* CORE_UPDATE_ROLE_REQUEST */]:
        case types["_9" /* CORE_CREATE_ROLE_REQUEST */]:
        case types["_3" /* CORE_CREATE_ORDER_REQUEST */]:
        case types["_297" /* CORE_LOAD_USER_INFO_REQUEST */]:
        case types["_450" /* O365_REGISTER_REQUEST */]:
        case types["_72" /* CORE_DELETE_ROOM_REQUEST */]:
        case types["_432" /* O365_LOAD_EVENTS_REQUEST */]:
        case types["_435" /* O365_LOAD_EVENT_REQUEST */]:
        case types["_447" /* O365_LOAD_USER_INFO_REQUEST */]:
        case types["_417" /* O365_CREATE_EVENT_REQUEST */]:
        case types["_426" /* O365_DELETE_EVENT_REQUEST */]:
        case types["_414" /* O365_ACCEPT_EVENT_REQUEST */]:
        case types["_456" /* O365_TENTATIVE_EVENT_REQUEST */]:
        case types["_423" /* O365_DECLINE_EVENT_REQUEST */]:
        case types["_206" /* CORE_LOAD_ORDERS_REQUEST */]:
        case types["_87" /* CORE_FIND_ROOM_REQUEST */]:
        case types["_299" /* CORE_LOAD_USER_REQUEST */]:
        case types["_407" /* CORE_UPDATE_USER_REQUEST */]:
        case types["_78" /* CORE_DELETE_USER_REQUEST */]:
        case types["_293" /* CORE_LOAD_USERS_REQUEST */]:
        case types["_251" /* CORE_LOAD_ROOMS_REQUEST */]:
        case types["_398" /* CORE_UPDATE_ROOM_REQUEST */]:
        case types["_260" /* CORE_LOAD_SETTING_INFO_REQUEST */]:
        case types["_266" /* CORE_LOAD_TERM_REQUEST */]:
        case types["_401" /* CORE_UPDATE_TERM_REQUEST */]:
        case types["_185" /* CORE_LOAD_FAQ_REQUEST */]:
        case types["_167" /* CORE_LOAD_CONTACT_US_REQUEST */]:
        case types["_224" /* CORE_LOAD_REPORTROOMSTATUS_REQUEST */]:
        case types["_239" /* CORE_LOAD_ROOMDETAIL_REQUEST */]:
        case types["b" /* BSRS_LOGIN_REQUEST */]:
        case types["_140" /* CORE_LOAD_ALL_CATEGORY_REQUEST */]:
        case types["_188" /* CORE_LOAD_FBSINFO_REQUEST */]:
        case types["_48" /* CORE_DELETE_FBS_REQUEST */]:
        case types["_203" /* CORE_LOAD_LOCATIONS_REQUEST */]:
        case types["_155" /* CORE_LOAD_AMENITYINFO_REQUEST */]:
        case types["_131" /* CORE_LOAD_ALLFLOOR_REQUEST */]:
        case types["_191" /* CORE_LOAD_FLOORINFO_REQUEST */]:
        case types["_125" /* CORE_LOAD_ALLBUILDING_REQUEST */]:
        case types["_161" /* CORE_LOAD_BUILDINGINFO_REQUEST */]:
        case types["_122" /* CORE_LOAD_ALLBACKGROUND_REQUEST */]:
        case types["_30" /* CORE_DELETE_BACKGROUND_REQUEST */]:
        case types["_158" /* CORE_LOAD_BACKGROUNDINFO_REQUEST */]:
        case types["_350" /* CORE_UPDATE_BACKGROUNDINFO_REQUEST */]:
        case types["I" /* CORE_CREATE_BACKGROUND_REQUEST */]:
        case types["_33" /* CORE_DELETE_BUILDING_REQUEST */]:
        case types["_353" /* CORE_UPDATE_BUILDINGINFO_REQUEST */]:
        case types["L" /* CORE_CREATE_BUILDING_REQUEST */]:
        case types["_54" /* CORE_DELETE_FLOOR_REQUEST */]:
        case types["_380" /* CORE_UPDATE_FLOORINFO_REQUEST */]:
        case types["_0" /* CORE_CREATE_FLOOR_REQUEST */]:
        case types["_134" /* CORE_LOAD_ALLZONE_REQUEST */]:
        case types["_81" /* CORE_DELETE_ZONE_REQUEST */]:
        case types["_305" /* CORE_LOAD_ZONEINFO_REQUEST */]:
        case types["_410" /* CORE_UPDATE_ZONEINFO_REQUEST */]:
        case types["_24" /* CORE_CREATE_ZONE_REQUEST */]:
        case types["_377" /* CORE_UPDATE_FB_CATEGORY_REQUEST */]:
        case types["_90" /* CORE_GET_CATEGORY_INFO_REQUEST */]:
        case types["X" /* CORE_CREATE_FB_CATEGORY_REQUEST */]:
        case types["_51" /* CORE_DELETE_FB_CATEGORY_REQUEST */]:
        case types["_15" /* CORE_CREATE_ROOM_REQUEST */]:
        case types["_441" /* O365_LOAD_ROOMS_REQUEST */]:
        case types["_253" /* CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST */]:
        case types["_429" /* O365_DELETE_ROOM_SUBSCRIBE_REQUEST */]:
        case types["_420" /* O365_CREATE_ROOM_SUBSCRIBE_REQUEST */]:
        case types["_128" /* CORE_LOAD_ALLFBS_REQUEST */]:
        case types["_374" /* CORE_UPDATE_FBSINFO_REQUEST */]:
        case types["U" /* CORE_CREATE_FBS_REQUEST */]:
        case types["_278" /* CORE_LOAD_USERGROUPS_REQUEST */]:
        case types["_197" /* CORE_LOAD_LIST_USERGROUPS_REQUEST */]:
        case types["_281" /* CORE_LOAD_USERGROUP_REQUEST */]:
        case types["_18" /* CORE_CREATE_USERGROUP_REQUEST */]:
        case types["_404" /* CORE_UPDATE_USERGROUP_REQUEST */]:
        case types["_75" /* CORE_DELETE_USERGROUP_REQUEST */]:
        case types["k" /* CORE_CHANGE_SETTING_REQUEST */]:
        case types["t" /* CORE_CHECK_AD_REQUEST */]:
        case types["_21" /* CORE_CREATE_USER_REQUEST */]:
        case types["h" /* CORE_CHANGE_PASSWORD_REQUEST */]:
        case types["_444" /* O365_LOAD_USERS_REQUEST */]:
        case types["_152" /* CORE_LOAD_ALL_USERSAD_REQUEST */]:
        case types["_146" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        case types["_6" /* CORE_CREATE_PROFILE_REQUEST */]:
        case types["_63" /* CORE_DELETE_PROFILE_REQUEST */]:
        case types["_221" /* CORE_LOAD_PROFILE_INFO_REQUEST */]:
        case types["_389" /* CORE_UPDATE_PROFILE_REQUEST */]:
        case types["_359" /* CORE_UPDATE_DEFAULTBACKGROUND_REQUEST */]:
        case types["_119" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
        case types["_27" /* CORE_DELETE_AMENITY_REQUEST */]:
        case types["_347" /* CORE_UPDATE_AMENITYINFO_REQUEST */]:
        case types["F" /* CORE_CREATE_AMENITY_REQUEST */]:
        case types["_227" /* CORE_LOAD_REPORTSUMMARY_REQUEST */]:
        case types["_329" /* CORE_SEARCH_ROOMS_REQUEST */]:
        case types["_326" /* CORE_SEARCH_FLOOR_REQUEST */]:
        case types["_335" /* CORE_SEARCH_ZONE_REQUEST */]:
        case types["_332" /* CORE_SEARCH_USERS_REQUEST */]:
        case types["_323" /* CORE_SEARCH_FBS_REQUEST */]:
        case types["n" /* CORE_CHECKIN_REQUEST */]:
        case types["_42" /* CORE_DELETE_EVENT_REQUEST */]:
        case types["q" /* CORE_CHECKOUT_REQUEST */]:
        case types["_308" /* CORE_RESET_PASSWORD_REQUEST */]:
        case types["_170" /* CORE_LOAD_DISPLAY_REQUEST */]:
        case types["_362" /* CORE_UPDATE_DISPLAY_REQUEST */]:
        case types["_149" /* CORE_LOAD_ALL_ROOMDISABLE_REQUEST */]:
        case types["_242" /* CORE_LOAD_ROOMDISABLE_REQUEST */]:
        case types["_12" /* CORE_CREATE_ROOMDISABLE_REQUEST */]:
        case types["_395" /* CORE_UPDATE_ROOMDISABLE_REQUEST */]:
        case types["_69" /* CORE_DELETE_ROOMDISABLE_REQUEST */]:
        case types["_36" /* CORE_DELETE_CONCURRENT_REQUEST */]:
        case types["C" /* CORE_CHECK_TMS_REQUEST */]:
        case types["z" /* CORE_CHECK_CMR_REQUEST */]:
        case types["w" /* CORE_CHECK_BOT_REQUEST */]:
        case types["_212" /* CORE_LOAD_ORDER_AMENITY_REQUEST */]:
        case types["_438" /* O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST */]:
        case types["_311" /* CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST */]:
        case types["_317" /* CORE_SEARCH_BUILDING_REQUEST */]:
        case types["_314" /* CORE_SEARCH_AMENITY_REQUEST */]:
        case types["_216" /* CORE_LOAD_ORDER_FBS_INFO_REQUEST */]:
        case types["_272" /* CORE_LOAD_TOPROOMRESERVE_REQUEST */]:
        case types["_275" /* CORE_LOAD_TOPUSERRESERVE_REQUEST */]:
        case types["_320" /* CORE_SEARCH_EVENTTYPE_REQUEST */]:
        case types["_453" /* O365_RESEND_EVENT_PIN_REQUEST */]:
            return reducer__extends({}, state, {
                isLoading: true,
                hasError: false,
                error: null
            });
        case types["_67" /* CORE_DELETE_ROLE_SUCCESS */]:
        case types["_10" /* CORE_CREATE_ROLE_SUCCESS */]:
        case types["_4" /* CORE_CREATE_ORDER_SUCCESS */]:
        case types["_298" /* CORE_LOAD_USER_INFO_SUCCESS */]:
        case types["_451" /* O365_REGISTER_SUCCESS */]:
        case types["_433" /* O365_LOAD_EVENTS_SUCCESS */]:
        case types["_436" /* O365_LOAD_EVENT_SUCCESS */]:
        case types["_448" /* O365_LOAD_USER_INFO_SUCCESS */]:
        case types["_418" /* O365_CREATE_EVENT_SUCCESS */]:
        case types["_427" /* O365_DELETE_EVENT_SUCCESS */]:
        case types["_415" /* O365_ACCEPT_EVENT_SUCCESS */]:
        case types["_457" /* O365_TENTATIVE_EVENT_SUCCESS */]:
        case types["_424" /* O365_DECLINE_EVENT_SUCCESS */]:
        case types["_207" /* CORE_LOAD_ORDERS_SUCCESS */]:
        case types["_88" /* CORE_FIND_ROOM_SUCCESS */]:
        case types["_73" /* CORE_DELETE_ROOM_SUCCESS */]:
        case types["_300" /* CORE_LOAD_USER_SUCCESS */]:
        case types["_408" /* CORE_UPDATE_USER_SUCCESS */]:
        case types["_79" /* CORE_DELETE_USER_SUCCESS */]:
        case types["_294" /* CORE_LOAD_USERS_SUCCESS */]:
        case types["_255" /* CORE_LOAD_ROOMS_SUCCESS */]:
        case types["_399" /* CORE_UPDATE_ROOM_SUCCESS */]:
        case types["_261" /* CORE_LOAD_SETTING_INFO_SUCCESS */]:
        case types["_267" /* CORE_LOAD_TERM_SUCCESS */]:
        case types["_402" /* CORE_UPDATE_TERM_SUCCESS */]:
        case types["_186" /* CORE_LOAD_FAQ_SUCCESS */]:
        case types["_168" /* CORE_LOAD_CONTACT_US_SUCCESS */]:
        case types["_225" /* CORE_LOAD_REPORTROOMSTATUS_SUCCESS */]:
        case types["_240" /* CORE_LOAD_ROOMDETAIL_SUCCESS */]:
        case types["_141" /* CORE_LOAD_ALL_CATEGORY_SUCCESS */]:
        case types["_189" /* CORE_LOAD_FBSINFO_SUCCESS */]:
        case types["_49" /* CORE_DELETE_FBS_SUCCESS */]:
        case types["_204" /* CORE_LOAD_LOCATIONS_SUCCESS */]:
        case types["_156" /* CORE_LOAD_AMENITYINFO_SUCCESS */]:
        case types["_132" /* CORE_LOAD_ALLFLOOR_SUCCESS */]:
        case types["_192" /* CORE_LOAD_FLOORINFO_SUCCESS */]:
        case types["_126" /* CORE_LOAD_ALLBUILDING_SUCCESS */]:
        case types["_162" /* CORE_LOAD_BUILDINGINFO_SUCCESS */]:
        case types["_123" /* CORE_LOAD_ALLBACKGROUND_SUCCESS */]:
        case types["_31" /* CORE_DELETE_BACKGROUND_SUCCESS */]:
        case types["_159" /* CORE_LOAD_BACKGROUNDINFO_SUCCESS */]:
        case types["_351" /* CORE_UPDATE_BACKGROUNDINFO_SUCCESS */]:
        case types["J" /* CORE_CREATE_BACKGROUND_SUCCESS */]:
        case types["_34" /* CORE_DELETE_BUILDING_SUCCESS */]:
        case types["_354" /* CORE_UPDATE_BUILDINGINFO_SUCCESS */]:
        case types["M" /* CORE_CREATE_BUILDING_SUCCESS */]:
        case types["_55" /* CORE_DELETE_FLOOR_SUCCESS */]:
        case types["_381" /* CORE_UPDATE_FLOORINFO_SUCCESS */]:
        case types["_1" /* CORE_CREATE_FLOOR_SUCCESS */]:
        case types["_135" /* CORE_LOAD_ALLZONE_SUCCESS */]:
        case types["_82" /* CORE_DELETE_ZONE_SUCCESS */]:
        case types["_306" /* CORE_LOAD_ZONEINFO_SUCCESS */]:
        case types["_411" /* CORE_UPDATE_ZONEINFO_SUCCESS */]:
        case types["_25" /* CORE_CREATE_ZONE_SUCCESS */]:
        case types["_378" /* CORE_UPDATE_FB_CATEGORY_SUCCESS */]:
        case types["_91" /* CORE_GET_CATEGORY_INFO_SUCCESS */]:
        case types["Y" /* CORE_CREATE_FB_CATEGORY_SUCCESS */]:
        case types["_52" /* CORE_DELETE_FB_CATEGORY_SUCCESS */]:
        case types["_16" /* CORE_CREATE_ROOM_SUCCESS */]:
        case types["_442" /* O365_LOAD_ROOMS_SUCCESS */]:
        case types["_254" /* CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS */]:
        case types["_430" /* O365_DELETE_ROOM_SUBSCRIBE_SUCCESS */]:
        case types["_421" /* O365_CREATE_ROOM_SUBSCRIBE_SUCCESS */]:
        case types["_129" /* CORE_LOAD_ALLFBS_SUCCESS */]:
        case types["_375" /* CORE_UPDATE_FBSINFO_SUCCESS */]:
        case types["V" /* CORE_CREATE_FBS_SUCCESS */]:
        case types["_279" /* CORE_LOAD_USERGROUPS_SUCCESS */]:
        case types["_198" /* CORE_LOAD_LIST_USERGROUPS_SUCCESS */]:
        case types["_282" /* CORE_LOAD_USERGROUP_SUCCESS */]:
        case types["_19" /* CORE_CREATE_USERGROUP_SUCCESS */]:
        case types["_405" /* CORE_UPDATE_USERGROUP_SUCCESS */]:
        case types["_76" /* CORE_DELETE_USERGROUP_SUCCESS */]:
        case types["l" /* CORE_CHANGE_SETTING_SUCCESS */]:
        case types["u" /* CORE_CHECK_AD_SUCCESS */]:
        case types["_22" /* CORE_CREATE_USER_SUCCESS */]:
        case types["i" /* CORE_CHANGE_PASSWORD_SUCCESS */]:
        case types["_445" /* O365_LOAD_USERS_SUCCESS */]:
        case types["_153" /* CORE_LOAD_ALL_USERSAD_SUCCESS */]:
        case types["_147" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        case types["_7" /* CORE_CREATE_PROFILE_SUCCESS */]:
        case types["_64" /* CORE_DELETE_PROFILE_SUCCESS */]:
        case types["_222" /* CORE_LOAD_PROFILE_INFO_SUCCESS */]:
        case types["_390" /* CORE_UPDATE_PROFILE_SUCCESS */]:
        case types["_360" /* CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS */]:
        case types["_120" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
        case types["_28" /* CORE_DELETE_AMENITY_SUCCESS */]:
        case types["_348" /* CORE_UPDATE_AMENITYINFO_SUCCESS */]:
        case types["G" /* CORE_CREATE_AMENITY_SUCCESS */]:
        case types["_228" /* CORE_LOAD_REPORTSUMMARY_SUCCESS */]:
        case types["_330" /* CORE_SEARCH_ROOMS_SUCCESS */]:
        case types["_327" /* CORE_SEARCH_FLOOR_SUCCESS */]:
        case types["_336" /* CORE_SEARCH_ZONE_SUCCESS */]:
        case types["_333" /* CORE_SEARCH_USERS_SUCCESS */]:
        case types["_324" /* CORE_SEARCH_FBS_SUCCESS */]:
        case types["o" /* CORE_CHECKIN_SUCCESS */]:
        case types["_46" /* CORE_DELETE_EVENT_SUCCESS */]:
        case types["r" /* CORE_CHECKOUT_SUCCESS */]:
        case types["_309" /* CORE_RESET_PASSWORD_SUCCESS */]:
        case types["_171" /* CORE_LOAD_DISPLAY_SUCCESS */]:
        case types["_363" /* CORE_UPDATE_DISPLAY_SUCCESS */]:
        case types["_150" /* CORE_LOAD_ALL_ROOMDISABLE_SUCCESS */]:
        case types["_243" /* CORE_LOAD_ROOMDISABLE_SUCCESS */]:
        case types["_13" /* CORE_CREATE_ROOMDISABLE_SUCCESS */]:
        case types["_396" /* CORE_UPDATE_ROOMDISABLE_SUCCESS */]:
        case types["_70" /* CORE_DELETE_ROOMDISABLE_SUCCESS */]:
        case types["_37" /* CORE_DELETE_CONCURRENT_SUCCESS */]:
        case types["D" /* CORE_CHECK_TMS_SUCCESS */]:
        case types["A" /* CORE_CHECK_CMR_SUCCESS */]:
        case types["x" /* CORE_CHECK_BOT_SUCCESS */]:
        case types["_213" /* CORE_LOAD_ORDER_AMENITY_SUCCESS */]:
        case types["_439" /* O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS */]:
        case types["_312" /* CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS */]:
        case types["_318" /* CORE_SEARCH_BUILDING_SUCCESS */]:
        case types["_315" /* CORE_SEARCH_AMENITY_SUCCESS */]:
        case types["_217" /* CORE_LOAD_ORDER_FBS_INFO_SUCCESS */]:
        case types["_273" /* CORE_LOAD_TOPROOMRESERVE_SUCCESS */]:
        case types["_276" /* CORE_LOAD_TOPUSERRESERVE_SUCCESS */]:
        case types["_321" /* CORE_SEARCH_EVENTTYPE_SUCCESS */]:
        case types["_454" /* O365_RESEND_EVENT_PIN_SUCCESS */]:
        case types["_393" /* CORE_UPDATE_ROLE_SUCCESS */]:
            return reducer__extends({}, state, {
                isLoading: false
                // hasError: false,
                // error: null,
            });
        case types["_65" /* CORE_DELETE_ROLE_FAILURE */]:
        case types["_2" /* CORE_CREATE_ORDER_FAILURE */]:
        case types["_296" /* CORE_LOAD_USER_INFO_FAILURE */]:
        case types["_446" /* O365_LOAD_USER_INFO_FAILURE */]:
        case types["_434" /* O365_LOAD_EVENT_FAILURE */]:
        case types["_431" /* O365_LOAD_EVENTS_FAILURE */]:
        case types["_416" /* O365_CREATE_EVENT_FAILURE */]:
        case types["_425" /* O365_DELETE_EVENT_FAILURE */]:
        case types["_413" /* O365_ACCEPT_EVENT_FAILURE */]:
        case types["_455" /* O365_TENTATIVE_EVENT_FAILURE */]:
        case types["_422" /* O365_DECLINE_EVENT_FAILURE */]:
        case types["_205" /* CORE_LOAD_ORDERS_FAILURE */]:
        case types["_86" /* CORE_FIND_ROOM_FAILURE */]:
        case types["_71" /* CORE_DELETE_ROOM_FAILURE */]:
        case types["_295" /* CORE_LOAD_USER_FAILURE */]:
        case types["_406" /* CORE_UPDATE_USER_FAILURE */]:
        case types["_77" /* CORE_DELETE_USER_FAILURE */]:
        case types["_292" /* CORE_LOAD_USERS_FAILURE */]:
        case types["_250" /* CORE_LOAD_ROOMS_FAILURE */]:
        case types["_397" /* CORE_UPDATE_ROOM_FAILURE */]:
        case types["_259" /* CORE_LOAD_SETTING_INFO_FAILURE */]:
        case types["_265" /* CORE_LOAD_TERM_FAILURE */]:
        case types["_400" /* CORE_UPDATE_TERM_FAILURE */]:
        case types["_184" /* CORE_LOAD_FAQ_FAILURE */]:
        case types["_166" /* CORE_LOAD_CONTACT_US_FAILURE */]:
        case types["_223" /* CORE_LOAD_REPORTROOMSTATUS_FAILURE */]:
        case types["_238" /* CORE_LOAD_ROOMDETAIL_FAILURE */]:
        case types["a" /* BSRS_LOGIN_FAILURE */]:
        case types["_139" /* CORE_LOAD_ALL_CATEGORY_FAILURE */]:
        case types["_187" /* CORE_LOAD_FBSINFO_FAILURE */]:
        case types["_47" /* CORE_DELETE_FBS_FAILURE */]:
        case types["_199" /* CORE_LOAD_LOCATIONS_FAILURE */]:
        case types["_154" /* CORE_LOAD_AMENITYINFO_FAILURE */]:
        case types["_130" /* CORE_LOAD_ALLFLOOR_FAILURE */]:
        case types["_190" /* CORE_LOAD_FLOORINFO_FAILURE */]:
        case types["_124" /* CORE_LOAD_ALLBUILDING_FAILURE */]:
        case types["_160" /* CORE_LOAD_BUILDINGINFO_FAILURE */]:
        case types["_121" /* CORE_LOAD_ALLBACKGROUND_FAILURE */]:
        case types["_29" /* CORE_DELETE_BACKGROUND_FAILURE */]:
        case types["_157" /* CORE_LOAD_BACKGROUNDINFO_FAILURE */]:
        case types["_349" /* CORE_UPDATE_BACKGROUNDINFO_FAILURE */]:
        case types["H" /* CORE_CREATE_BACKGROUND_FAILURE */]:
        case types["_32" /* CORE_DELETE_BUILDING_FAILURE */]:
        case types["_352" /* CORE_UPDATE_BUILDINGINFO_FAILURE */]:
        case types["K" /* CORE_CREATE_BUILDING_FAILURE */]:
        case types["_53" /* CORE_DELETE_FLOOR_FAILURE */]:
        case types["_379" /* CORE_UPDATE_FLOORINFO_FAILURE */]:
        case types["Z" /* CORE_CREATE_FLOOR_FAILURE */]:
        case types["_133" /* CORE_LOAD_ALLZONE_FAILURE */]:
        case types["_80" /* CORE_DELETE_ZONE_FAILURE */]:
        case types["_304" /* CORE_LOAD_ZONEINFO_FAILURE */]:
        case types["_409" /* CORE_UPDATE_ZONEINFO_FAILURE */]:
        case types["_23" /* CORE_CREATE_ZONE_FAILURE */]:
        case types["_376" /* CORE_UPDATE_FB_CATEGORY_FAILURE */]:
        case types["_89" /* CORE_GET_CATEGORY_INFO_FAILURE */]:
        case types["W" /* CORE_CREATE_FB_CATEGORY_FAILURE */]:
        case types["_50" /* CORE_DELETE_FB_CATEGORY_FAILURE */]:
        case types["_14" /* CORE_CREATE_ROOM_FAILURE */]:
        case types["_440" /* O365_LOAD_ROOMS_FAILURE */]:
        case types["_252" /* CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE */]:
        case types["_428" /* O365_DELETE_ROOM_SUBSCRIBE_FAILURE */]:
        case types["_419" /* O365_CREATE_ROOM_SUBSCRIBE_FAILURE */]:
        case types["_127" /* CORE_LOAD_ALLFBS_FAILURE */]:
        case types["_373" /* CORE_UPDATE_FBSINFO_FAILURE */]:
        case types["T" /* CORE_CREATE_FBS_FAILURE */]:
        case types["_277" /* CORE_LOAD_USERGROUPS_FAILURE */]:
        case types["_196" /* CORE_LOAD_LIST_USERGROUPS_FAILURE */]:
        case types["_280" /* CORE_LOAD_USERGROUP_FAILURE */]:
        case types["_17" /* CORE_CREATE_USERGROUP_FAILURE */]:
        case types["_403" /* CORE_UPDATE_USERGROUP_FAILURE */]:
        case types["_74" /* CORE_DELETE_USERGROUP_FAILURE */]:
        case types["j" /* CORE_CHANGE_SETTING_FAILURE */]:
        case types["s" /* CORE_CHECK_AD_FAILURE */]:
        case types["_20" /* CORE_CREATE_USER_FAILURE */]:
        case types["g" /* CORE_CHANGE_PASSWORD_FAILURE */]:
        case types["_443" /* O365_LOAD_USERS_FAILURE */]:
        case types["_151" /* CORE_LOAD_ALL_USERSAD_FAILURE */]:
        case types["_145" /* CORE_LOAD_ALL_PROFILE_FAILURE */]:
        case types["_5" /* CORE_CREATE_PROFILE_FAILURE */]:
        case types["_62" /* CORE_DELETE_PROFILE_FAILURE */]:
        case types["_220" /* CORE_LOAD_PROFILE_INFO_FAILURE */]:
        case types["_388" /* CORE_UPDATE_PROFILE_FAILURE */]:
        case types["_358" /* CORE_UPDATE_DEFAULTBACKGROUND_FAILURE */]:
        case types["_118" /* CORE_LOAD_ALLAMENITY_FAILURE */]:
        case types["_26" /* CORE_DELETE_AMENITY_FAILURE */]:
        case types["_346" /* CORE_UPDATE_AMENITYINFO_FAILURE */]:
        case types["E" /* CORE_CREATE_AMENITY_FAILURE */]:
        case types["_226" /* CORE_LOAD_REPORTSUMMARY_FAILURE */]:
        case types["_328" /* CORE_SEARCH_ROOMS_FAILURE */]:
        case types["_325" /* CORE_SEARCH_FLOOR_FAILURE */]:
        case types["_334" /* CORE_SEARCH_ZONE_FAILURE */]:
        case types["_331" /* CORE_SEARCH_USERS_FAILURE */]:
        case types["_322" /* CORE_SEARCH_FBS_FAILURE */]:
        case types["m" /* CORE_CHECKIN_FAILURE */]:
        case types["_41" /* CORE_DELETE_EVENT_FAILURE */]:
        case types["p" /* CORE_CHECKOUT_FAILURE */]:
        case types["_307" /* CORE_RESET_PASSWORD_FAILURE */]:
        case types["_169" /* CORE_LOAD_DISPLAY_FAILURE */]:
        case types["_361" /* CORE_UPDATE_DISPLAY_FAILURE */]:
        case types["_148" /* CORE_LOAD_ALL_ROOMDISABLE_FAILURE */]:
        case types["_241" /* CORE_LOAD_ROOMDISABLE_FAILURE */]:
        case types["_11" /* CORE_CREATE_ROOMDISABLE_FAILURE */]:
        case types["_394" /* CORE_UPDATE_ROOMDISABLE_FAILURE */]:
        case types["_68" /* CORE_DELETE_ROOMDISABLE_FAILURE */]:
        case types["_35" /* CORE_DELETE_CONCURRENT_FAILURE */]:
        case types["B" /* CORE_CHECK_TMS_FAILURE */]:
        case types["y" /* CORE_CHECK_CMR_FAILURE */]:
        case types["v" /* CORE_CHECK_BOT_FAILURE */]:
        case types["_208" /* CORE_LOAD_ORDER_AMENITY_FAILURE */]:
        case types["_437" /* O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE */]:
        case types["_136" /* CORE_LOAD_ALL_AD_LIST_FAILURE */]:
        case types["_101" /* CORE_IMPORT_USER_AD_FAILURE */]:
        case types["_310" /* CORE_SEARCH_ALL_FBS_CATEGORY_FAILURE */]:
        case types["_316" /* CORE_SEARCH_BUILDING_FAILURE */]:
        case types["_313" /* CORE_SEARCH_AMENITY_FAILURE */]:
        case types["_215" /* CORE_LOAD_ORDER_FBS_INFO_FAILURE */]:
        case types["_271" /* CORE_LOAD_TOPROOMRESERVE_FAILURE */]:
        case types["_274" /* CORE_LOAD_TOPUSERRESERVE_FAILURE */]:
        case types["_319" /* CORE_SEARCH_EVENTTYPE_FAILURE */]:
        case types["_452" /* O365_RESEND_EVENT_PIN_FAILURE */]:
        case types["_8" /* CORE_CREATE_ROLE_FAILURE */]:
        case types["_391" /* CORE_UPDATE_ROLE_FAILURE */]:
            return reducer__extends({}, state, {
                isLoading: false,
                hasError: true,
                error: action.payload.data
            });
        case types["_465" /* SET_ERROR */]:
            return reducer__extends({}, state, {
                hasError: action.hasError,
                error: action.error
            });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/features/settings/integration/reducer.js
var integration_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var noMessage = {
    success: "",
    error: ""
};
var _initialState = integration_reducer__extends({
    step: 1,
    o365: {
        tenant_id: "",
        client_id: ""
    }
}, noMessage);

/* harmony default export */ var integration_reducer = ({
    initialState: function initialState() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {

            case types["_110" /* CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID */]:
                {
                    return _initialState;
                }

            case types["_111" /* CORE_INTEGRATION_O365_GO_ADMIN_CONSENT */]:
                {
                    var _action$payload = action.payload,
                        step = _action$payload.step,
                        client_id = _action$payload.client_id;

                    return integration_reducer__extends({
                        step: step,
                        o365: integration_reducer__extends({}, state.o365, {
                            client_id: client_id
                        })
                    }, noMessage);
                }

            case types["_112" /* CORE_INTEGRATION_O365_GO_SAVE_DATA */]:
                {
                    var _action$payload2 = action.payload,
                        _step = _action$payload2.step,
                        _client_id = _action$payload2.client_id,
                        tenant_id = _action$payload2.tenant_id;

                    return integration_reducer__extends({
                        step: _step,
                        o365: {
                            tenant_id: tenant_id,
                            client_id: _client_id
                        }
                    }, noMessage);
                }

            case types["_107" /* CORE_INTEGRATION_O365_ADD_CLIENT_ID */]:
                {
                    var _action$payload3 = action.payload,
                        _step2 = _action$payload3.step,
                        _client_id2 = _action$payload3.client_id;

                    return integration_reducer__extends({
                        step: _step2,
                        o365: integration_reducer__extends({}, state.o365, {
                            client_id: _client_id2
                        })
                    }, noMessage);
                }

            case types["_108" /* CORE_INTEGRATION_O365_ADMIN_CONSENT */]:
                {
                    var _action$payload4 = action.payload,
                        _step3 = _action$payload4.step,
                        _tenant_id = _action$payload4.tenant_id;

                    return integration_reducer__extends({
                        step: _step3,
                        o365: integration_reducer__extends({}, state.o365, {
                            tenant_id: _tenant_id
                        })
                    }, noMessage);
                }
            case types["_114" /* CORE_INTEGRATION_O365_SUCCESS */]:
                return integration_reducer__extends({}, _initialState, {
                    success: "Connect Successfully"
                });

            case types["_109" /* CORE_INTEGRATION_O365_FAILURE */]:
                return integration_reducer__extends({}, _initialState, {
                    step: 3,
                    success: "",
                    error: "Connect failed. Please check your data"
                });
            default:
                return state;
        }
    },
    ini: function ini() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_96" /* CORE_GET_INTEGRATION_REQUEST */]:
                return _initialState;

            case types["_97" /* CORE_GET_INTEGRATION_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    integrationInfo: function integrationInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_94" /* CORE_GET_INTEGRATION_INFO_REQUEST */]:
                return _initialState;

            case types["_95" /* CORE_GET_INTEGRATION_INFO_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/rooms/reducer.js


var rooms_reducer_initialState = [];
/* harmony default export */ var rooms_reducer = ({
    roomsO365: function roomsO365() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_441" /* O365_LOAD_ROOMS_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_442" /* O365_LOAD_ROOMS_SUCCESS */]:
                return action.payload;
            case types["_438" /* O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST */]:
                return false;
            case types["_439" /* O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS */]:
                if (action.payload && Array.isArray(action.payload)) return true;else return false;
            default:
                return state;
        }
    },
    roomsCore: function roomsCore() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_251" /* CORE_LOAD_ROOMS_REQUEST */]:
            case types["_329" /* CORE_SEARCH_ROOMS_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_255" /* CORE_LOAD_ROOMS_SUCCESS */]:
            case types["_330" /* CORE_SEARCH_ROOMS_SUCCESS */]:
                if (action.payload) return action.payload;else return [];
            default:
                return state;
        }
    },
    vcList: function vcList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        switch (action.type) {
            case types["_302" /* CORE_LOAD_VC_LIST_REQUEST */]:
                return [];
            case types["_303" /* CORE_LOAD_VC_LIST_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    roomCore: function roomCore() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_87" /* CORE_FIND_ROOM_REQUEST */]:
                return {};
            case types["_88" /* CORE_FIND_ROOM_SUCCESS */]:
                if (action.payload) return action.payload;else return {};
            default:
                return state;
        }
    },
    roomsSubscribe: function roomsSubscribe() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_253" /* CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_254" /* CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS */]:
                if (action.payload) return action.payload;else return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/report/reducer.js


var report_reducer_initialState = [];
/* harmony default export */ var report_reducer = ({
  coreRoom: function coreRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_201" /* CORE_LOAD_LOCATIONS_REPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_202" /* CORE_LOAD_LOCATIONS_REPORT_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var locations = [];
          for (var i = 0; i < payload.length; i++) {
            locations.push({
              value: payload[i].email,
              key: i,
              text: payload[i].name,
              name: payload[i].name
            });
          }
          return locations;
        } else return [{}];

      default:
        return state;
    }
  },
  statusSum: function statusSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_227" /* CORE_LOAD_REPORTSUMMARY_REQUEST */]:
        return state;

      case types["_228" /* CORE_LOAD_REPORTSUMMARY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomReports: function roomReports() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_230" /* CORE_LOAD_REPORT_REQUEST */]:
        return report_reducer_initialState;
      case types["_231" /* CORE_LOAD_REPORT_SUCCESS */]:
        var data = [];
        if (action.payload !== '') {
          var actionlog = action.payload;
          actionlog.data.forEach(function (payload) {
            var createEvent = false;
            var updateEvent = false;
            var deleteEvent = false;
            var type = payload.meta.type;
            if (type === "CREATE_EVENT") createEvent = true;else if (type === "UPDATE_EVENT") updateEvent = true;else deleteEvent = true;
            data.push({
              startDateTimeThai: payload.meta.data.startDateTimeThai,
              endDateTimeThai: payload.meta.data.endDateTimeThai,
              organizerAddress: payload.meta.data.organizer.emailAddress.name,
              subject: payload.meta.data.subject,
              _id: payload._id,
              createEvent: createEvent,
              updateEvent: updateEvent,
              deleteEvent: deleteEvent,
              message: payload.meta.message,
              meetnow: payload.meta.meetnow ? true : false
            });
          });
          return data;
        }
        return action.payload;

      default:
        return state;
    }
  },
  userReport: function userReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_284" /* CORE_LOAD_USERREPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_285" /* CORE_LOAD_USERREPORT_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data
        });
        return status;

      default:
        return state;
    }
  },
  roomReport: function roomReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_245" /* CORE_LOAD_ROOMREPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_246" /* CORE_LOAD_ROOMREPORT_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data
        });
        return status;

      default:
        return state;
    }
  },
  userSum: function userSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_287" /* CORE_LOAD_USERSUMMARY_REQUEST */]:
        return report_reducer_initialState;

      case types["_288" /* CORE_LOAD_USERSUMMARY_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data,
          summary: payload.summary
        });
        return status;

      default:
        return state;
    }
  },
  roomSum: function roomSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_248" /* CORE_LOAD_ROOMSUMMARY_REQUEST */]:
        return report_reducer_initialState;

      case types["_249" /* CORE_LOAD_ROOMSUMMARY_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data,
          summary: payload.summary
        });
        return status;

      default:
        return state;
    }
  },
  userStatus: function userStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_263" /* CORE_LOAD_STATUSUSER_REQUEST */]:
        return report_reducer_initialState;

      case types["_264" /* CORE_LOAD_STATUSUSER_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  userSummary: function userSummary() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_290" /* CORE_LOAD_USERSUM_REQUEST */]:
        return report_reducer_initialState;

      case types["_291" /* CORE_LOAD_USERSUM_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomsStatus: function roomsStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_224" /* CORE_LOAD_REPORTROOMSTATUS_REQUEST */]:
        return report_reducer_initialState;

      case types["_225" /* CORE_LOAD_REPORTROOMSTATUS_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomTemp: function roomTemp() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_257" /* CORE_LOAD_ROOMTEMP_REQUEST */]:
        return report_reducer_initialState;

      case types["_258" /* CORE_LOAD_ROOMTEMP_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  topRoom: function topRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_272" /* CORE_LOAD_TOPROOMRESERVE_REQUEST */]:
        return report_reducer_initialState;

      case types["_273" /* CORE_LOAD_TOPROOMRESERVE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  topUser: function topUser() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_275" /* CORE_LOAD_TOPUSERRESERVE_REQUEST */]:
        return report_reducer_initialState;

      case types["_276" /* CORE_LOAD_TOPUSERRESERVE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomDetail: function roomDetail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_239" /* CORE_LOAD_ROOMDETAIL_REQUEST */]:
        return state;

      case types["_240" /* CORE_LOAD_ROOMDETAIL_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/user/reducer.js


var user_reducer_initialState = [];

/* harmony default export */ var user_reducer = ({
  users: function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_293" /* CORE_LOAD_USERS_REQUEST */]:
      case types["_332" /* CORE_SEARCH_USERS_REQUEST */]:
        return [];
      case types["_294" /* CORE_LOAD_USERS_SUCCESS */]:
      case types["_333" /* CORE_SEARCH_USERS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  usersO365: function usersO365() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_444" /* O365_LOAD_USERS_REQUEST */]:
        return [];
      case types["_445" /* O365_LOAD_USERS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  usersAD: function usersAD() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_152" /* CORE_LOAD_ALL_USERSAD_REQUEST */]:
        return [];
      case types["_153" /* CORE_LOAD_ALL_USERSAD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  user: function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_297" /* CORE_LOAD_USER_INFO_REQUEST */]:
        return {};
      case types["_298" /* CORE_LOAD_USER_INFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  resetPassword: function resetPassword() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_308" /* CORE_RESET_PASSWORD_REQUEST */]:
        return {};
      case types["_309" /* CORE_RESET_PASSWORD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  importUserO365: function importUserO365() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
      case types["_143" /* CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST */]:
        return [];
      case types["_144" /* CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  usersADList: function usersADList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_137" /* CORE_LOAD_ALL_AD_LIST_REQUEST */]:
        return "REQUEST";
      case types["_138" /* CORE_LOAD_ALL_AD_LIST_SUCCESS */]:
        var result = [];
        if (Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_136" /* CORE_LOAD_ALL_AD_LIST_FAILURE */]:
        return user_reducer_initialState;
      default:
        return state;
    }
  }
});
// EXTERNAL MODULE: ./src/core/utility/utils.js
var utils = __webpack_require__(661);

// CONCATENATED MODULE: ./src/features/setting/reducer.js
var setting_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// const initialState = []

/* harmony default export */ var setting_reducer = ({
  setting: function setting() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_260" /* CORE_LOAD_SETTING_INFO_REQUEST */]:
        return state;
      case types["_261" /* CORE_LOAD_SETTING_INFO_SUCCESS */]:
        var setting = {};
        // return action.payload
        if (!!action.payload) {
          var payload = action.payload;
          setting = setting_reducer__extends({}, payload);
          if (!!payload.activeDirectoryAdminPassword) {
            setting.activeDirectoryAdminPassword = utils["a" /* default */].decode(payload.activeDirectoryAdminPassword);
          }
          if (!!payload.cmr_password) {
            setting.cmr_password = utils["a" /* default */].decode(payload.cmr_password);
          }
          if (!!payload.tms_password) {
            setting.tms_password = utils["a" /* default */].decode(payload.tms_password);
          }
          if (!!payload.ewsPassword) {
            setting.ewsPassword = utils["a" /* default */].decode(payload.ewsPassword);
          }
        }
        return setting;
      default:
        return state;
    }
  },
  AD: function AD() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["t" /* CORE_CHECK_AD_REQUEST */]:
        return {};
      case types["u" /* CORE_CHECK_AD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  TMS: function TMS() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["C" /* CORE_CHECK_TMS_REQUEST */]:
        return 'request';
      case types["D" /* CORE_CHECK_TMS_SUCCESS */]:
        if (action) {
          if (typeof action.payload === 'boolean') return action.payload;else {
            if (action.payload.toLowerCase() === 'true') return true;else return false;
          }
        } else return false;
      case types["B" /* CORE_CHECK_TMS_FAILURE */]:
        return false;
      default:
        return state;
    }
  },
  BOT: function BOT() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["w" /* CORE_CHECK_BOT_REQUEST */]:
        return 'request';
      case types["x" /* CORE_CHECK_BOT_SUCCESS */]:
        if (action) {
          if (typeof action.payload === 'boolean') return action.payload;else {
            if (action.payload.toLowerCase() === 'true') return true;else return false;
          }
        } else return false;
      case types["v" /* CORE_CHECK_BOT_FAILURE */]:
        return false;
      default:
        return state;
    }
  },
  CMR: function CMR() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["z" /* CORE_CHECK_CMR_REQUEST */]:
        return 'request';
      case types["A" /* CORE_CHECK_CMR_SUCCESS */]:
        if (action) {
          if (typeof action.payload === 'boolean') return action.payload;else {
            if (action.payload.toLowerCase() === 'true') return true;else return false;
          }
        } else return false;
      case types["y" /* CORE_CHECK_CMR_FAILURE */]:
        return false;
      default:
        return state;
    }
  },
  timezone: function timezone() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_269" /* CORE_LOAD_TIMEZOZE_REQUEST */]:
        return [];
      case types["_270" /* CORE_LOAD_TIMEZOZE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  integrationData: function integrationData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_194" /* CORE_LOAD_INTEGRATION_DATA_REQUEST */]:
        return null;
      case types["_195" /* CORE_LOAD_INTEGRATION_DATA_SUCCESS */]:
        return action.payload;
      case types["_193" /* CORE_LOAD_INTEGRATION_DATA_FAILURE */]:
        return null;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/amenity/reducer.js


var amenity_reducer_initialState = [];
/* harmony default export */ var amenity_reducer = ({
  amenity: function amenity() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_119" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
      case types["_314" /* CORE_SEARCH_AMENITY_REQUEST */]:
        return amenity_reducer_initialState;

      case types["_120" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
      case types["_315" /* CORE_SEARCH_AMENITY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  amenityMaster: function amenityMaster() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "REQUEST";
    var action = arguments[1];

    switch (action.type) {
      case types["_119" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
        return "REQUEST";
      case types["_120" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_118" /* CORE_LOAD_ALLAMENITY_FAILURE */]:
        return [];
      default:
        return state;
    }
  },
  amenityInfo: function amenityInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_155" /* CORE_LOAD_AMENITYINFO_REQUEST */]:
        return amenity_reducer_initialState;

      case types["_156" /* CORE_LOAD_AMENITYINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/term/reducer.js


var term_reducer_initialState = {};
/* harmony default export */ var term_reducer = ({
  term: function term() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : term_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_266" /* CORE_LOAD_TERM_REQUEST */]:
      case types["_401" /* CORE_UPDATE_TERM_REQUEST */]:
        return term_reducer_initialState;

      case types["_267" /* CORE_LOAD_TERM_SUCCESS */]:
      case types["_402" /* CORE_UPDATE_TERM_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/faq/reducer.js


var faq_reducer_initialState = {};
/* harmony default export */ var faq_reducer = ({
  faq: function faq() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : faq_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_185" /* CORE_LOAD_FAQ_REQUEST */]:
      case types["_371" /* CORE_UPDATE_FAQ_REQUEST */]:
        return faq_reducer_initialState;

      case types["_186" /* CORE_LOAD_FAQ_SUCCESS */]:
      case types["_372" /* CORE_UPDATE_FAQ_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/contact/reducer.js


var contact_reducer_initialState = {};
/* harmony default export */ var contact_reducer = ({
  contactus: function contactus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : contact_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_167" /* CORE_LOAD_CONTACT_US_REQUEST */]:
      case types["_356" /* CORE_UPDATE_CONTACT_US_REQUEST */]:
        return contact_reducer_initialState;

      case types["_168" /* CORE_LOAD_CONTACT_US_SUCCESS */]:
      case types["_357" /* CORE_UPDATE_CONTACT_US_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/profile/reducer.js


var profile_reducer_initialState = [];
/* harmony default export */ var profile_reducer = ({
  profileList: function profileList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profile_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_146" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        return profile_reducer_initialState;
      case types["_147" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  profileInfo: function profileInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profile_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_221" /* CORE_LOAD_PROFILE_INFO_REQUEST */]:
        return profile_reducer_initialState;
      case types["_222" /* CORE_LOAD_PROFILE_INFO_SUCCESS */]:
        if (action.payload) return action.payload;else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/usergroup/reducer.js


var usergroup_reducer_initialState = [];
/* harmony default export */ var usergroup_reducer = ({
  usergroups: function usergroups() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : usergroup_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_278" /* CORE_LOAD_USERGROUPS_REQUEST */]:
      case types["_197" /* CORE_LOAD_LIST_USERGROUPS_REQUEST */]:
        return usergroup_reducer_initialState;
      case types["_279" /* CORE_LOAD_USERGROUPS_SUCCESS */]:
      case types["_198" /* CORE_LOAD_LIST_USERGROUPS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  usergroup: function usergroup() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : usergroup_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_281" /* CORE_LOAD_USERGROUP_REQUEST */]:
        return {};
      case types["_282" /* CORE_LOAD_USERGROUP_SUCCESS */]:
        if (action.payload) return action.payload;else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/action/reducer.js


var action_reducer_initialState = [];
/* harmony default export */ var action_reducer = ({
  actions: function actions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : action_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_116" /* CORE_LOAD_ACTIONS_REQUEST */]:
        return action_reducer_initialState;
      case types["_117" /* CORE_LOAD_ACTIONS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/fbs/reducer.js


var fbs_reducer_initialState = [];
/* harmony default export */ var fbs_reducer = ({
  fbs: function fbs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_128" /* CORE_LOAD_ALLFBS_REQUEST */]:
      case types["_323" /* CORE_SEARCH_FBS_REQUEST */]:
        return [];
      case types["_129" /* CORE_LOAD_ALLFBS_SUCCESS */]:
      case types["_324" /* CORE_SEARCH_FBS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  fbsMaster: function fbsMaster() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "REQUEST";
    var action = arguments[1];

    switch (action.type) {
      case types["_128" /* CORE_LOAD_ALLFBS_REQUEST */]:
        return [];
      case types["_129" /* CORE_LOAD_ALLFBS_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_127" /* CORE_LOAD_ALLFBS_FAILURE */]:
        return [];
      default:
        return state;
    }
  },
  fbsInfo: function fbsInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_188" /* CORE_LOAD_FBSINFO_REQUEST */]:
        return {};
      case types["_189" /* CORE_LOAD_FBSINFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }

});
// CONCATENATED MODULE: ./src/features/location/building/reducer.js


var building_reducer_initialState = [];
/* harmony default export */ var building_reducer = ({
  building: function building() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : building_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_125" /* CORE_LOAD_ALLBUILDING_REQUEST */]:
      case types["_317" /* CORE_SEARCH_BUILDING_REQUEST */]:
        return building_reducer_initialState;

      case types["_126" /* CORE_LOAD_ALLBUILDING_SUCCESS */]:
      case types["_318" /* CORE_SEARCH_BUILDING_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  buildingInfo: function buildingInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : building_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_161" /* CORE_LOAD_BUILDINGINFO_REQUEST */]:
        return building_reducer_initialState;

      case types["_162" /* CORE_LOAD_BUILDINGINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/floor/reducer.js


var floor_reducer_initialState = [];
/* harmony default export */ var floor_reducer = ({
  floor: function floor() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floor_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_131" /* CORE_LOAD_ALLFLOOR_REQUEST */]:
      case types["_326" /* CORE_SEARCH_FLOOR_REQUEST */]:
        return floor_reducer_initialState;

      case types["_132" /* CORE_LOAD_ALLFLOOR_SUCCESS */]:
      case types["_327" /* CORE_SEARCH_FLOOR_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  floorInfo: function floorInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floor_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_191" /* CORE_LOAD_FLOORINFO_REQUEST */]:
        return floor_reducer_initialState;
      case types["_192" /* CORE_LOAD_FLOORINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/zone/reducer.js


var zone_reducer_initialState = [];
/* harmony default export */ var zone_reducer = ({
  zone: function zone() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : zone_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_134" /* CORE_LOAD_ALLZONE_REQUEST */]:
      case types["_335" /* CORE_SEARCH_ZONE_REQUEST */]:
        return zone_reducer_initialState;

      case types["_135" /* CORE_LOAD_ALLZONE_SUCCESS */]:
      case types["_336" /* CORE_SEARCH_ZONE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  zoneInfo: function zoneInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : zone_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_305" /* CORE_LOAD_ZONEINFO_REQUEST */]:
        return {};
      case types["_306" /* CORE_LOAD_ZONEINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/background/reducer.js


var background_reducer_initialState = [];
/* harmony default export */ var background_reducer = ({
  background: function background() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : background_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_122" /* CORE_LOAD_ALLBACKGROUND_REQUEST */]:
        return background_reducer_initialState;

      case types["_123" /* CORE_LOAD_ALLBACKGROUND_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  backgroundInfo: function backgroundInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_158" /* CORE_LOAD_BACKGROUNDINFO_REQUEST */]:
        return {};

      case types["_159" /* CORE_LOAD_BACKGROUNDINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/fbCategory/reducer.js


var fbCategory_reducer_initialState = [];
/* harmony default export */ var fbCategory_reducer = ({
  fbCategoryInfo: function fbCategoryInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbCategory_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_90" /* CORE_GET_CATEGORY_INFO_REQUEST */]:
        return {};

      case types["_91" /* CORE_GET_CATEGORY_INFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  fbCategory: function fbCategory() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbCategory_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_140" /* CORE_LOAD_ALL_CATEGORY_REQUEST */]:
      case types["_311" /* CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST */]:
        return fbCategory_reducer_initialState;

      case types["_141" /* CORE_LOAD_ALL_CATEGORY_SUCCESS */]:
      case types["_312" /* CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/events/reducer.js


var events_reducer_initialState = [];
/* harmony default export */ var events_reducer = ({
    events: function events() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_432" /* O365_LOAD_EVENTS_REQUEST */]:
                return [];

            case types["_433" /* O365_LOAD_EVENTS_SUCCESS */]:
                var eventList = [];
                if (Array.isArray(action.payload)) {
                    eventList = action.payload;
                }
                return eventList;
            default:
                return state;
        }
    },
    checkIn: function checkIn() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["n" /* CORE_CHECKIN_REQUEST */]:
                return false;

            case types["o" /* CORE_CHECKIN_SUCCESS */]:
                return true;

            default:
                return state;
        }
    },
    checkOut: function checkOut() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["q" /* CORE_CHECKOUT_REQUEST */]:
                return false;

            case types["r" /* CORE_CHECKOUT_SUCCESS */]:
                return true;

            default:
                return state;
        }
    },
    deleteEvent: function deleteEvent() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["_42" /* CORE_DELETE_EVENT_REQUEST */]:
                return false;

            case types["_46" /* CORE_DELETE_EVENT_SUCCESS */]:
                return true;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/display/reducer.js


var display_reducer_initialState = [];
/* harmony default export */ var display_reducer = ({

  allDisplay: function allDisplay() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_170" /* CORE_LOAD_DISPLAY_REQUEST */]:
        return [];
      case types["_171" /* CORE_LOAD_DISPLAY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },

  displayInfo: function displayInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      // case CORE_GET_IOT_INFO_REQUEST:
      //   return {}

      // case CORE_GET_IOT_INFO_SUCCESS:
      //   return action.payload

      default:
        return state;
    }
  }

});
// CONCATENATED MODULE: ./src/features/profilecenter/reducer.js


var profilecenter_reducer_initialState = {};
/* harmony default export */ var profilecenter_reducer = ({
    profileCenterInfo: function profileCenterInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profilecenter_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_458" /* PROFILE_CENTER_LOAD_INFO_REQUEST */]:
                return profilecenter_reducer_initialState;
            case types["_459" /* PROFILE_CENTER_LOAD_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    profileUpdateStatus: function profileUpdateStatus() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["_460" /* PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST */]:
                return profilecenter_reducer_initialState;
            case types["_461" /* PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/roomDisable/reducer.js


var roomDisable_reducer_initialState = [];
/* harmony default export */ var roomDisable_reducer = ({
  roomDisableList: function roomDisableList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomDisable_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_149" /* CORE_LOAD_ALL_ROOMDISABLE_REQUEST */]:
        return [];
      case types["_150" /* CORE_LOAD_ALL_ROOMDISABLE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  roomDisable: function roomDisable() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomDisable_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_242" /* CORE_LOAD_ROOMDISABLE_REQUEST */]:
        return {};
      case types["_243" /* CORE_LOAD_ROOMDISABLE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/concurrent/reducer.js


/* harmony default export */ var concurrent_reducer = ({
    concurrents: function concurrents() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_164" /* CORE_LOAD_CONCURRENT_REQUEST */]:
                return [];

            case types["_165" /* CORE_LOAD_CONCURRENT_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/roles/reducer.js


var roles_reducer_initialState = [];
/* harmony default export */ var roles_reducer = ({
    roles: function roles() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roles_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_233" /* CORE_LOAD_ROLES_REQUEST */]:
                return roles_reducer_initialState;
            case types["_234" /* CORE_LOAD_ROLES_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    role: function role() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_236" /* CORE_LOAD_ROLE_INFO_REQUEST */]:
                return roles_reducer_initialState;
            case types["_237" /* CORE_LOAD_ROLE_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/roomformat/reducer.js


var roomformat_reducer_initialState = [];
/* harmony default export */ var roomformat_reducer = ({
    eventRoomFormat: function eventRoomFormat() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomformat_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_182" /* CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST */]:
                return roomformat_reducer_initialState;

            case types["_183" /* CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    eventRoomFormatInfo: function eventRoomFormatInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomformat_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_180" /* CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST */]:
                return {};

            case types["_181" /* CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/order/reducer.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var order_reducer_initialState = [];
/* harmony default export */ var order_reducer = ({
    orderFbs: function orderFbs() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_218" /* CORE_LOAD_ORDER_FBS_REQUEST */]:
                return order_reducer_initialState;

            case types["_219" /* CORE_LOAD_ORDER_FBS_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    orderFbsInfo: function orderFbsInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_216" /* CORE_LOAD_ORDER_FBS_INFO_REQUEST */]:
                return {};

            case types["_217" /* CORE_LOAD_ORDER_FBS_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    orderAmenity: function orderAmenity() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_212" /* CORE_LOAD_ORDER_AMENITY_REQUEST */]:
                return order_reducer_initialState;

            case types["_213" /* CORE_LOAD_ORDER_AMENITY_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    orderAmenityInfo: function orderAmenityInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_210" /* CORE_LOAD_ORDER_AMENITY_INFO_REQUEST */]:
                return {};

            case types["_211" /* CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    avaibleOrder: function avaibleOrder() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "REQUEST";
        var action = arguments[1];

        switch (action.type) {
            case types["_99" /* CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST */]:
                return "REQUEST";
            case types["_100" /* CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    return action.payload;
                } else return {};
            case types["_98" /* CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/eventType/reducer.js


var eventType_reducer_initialState = [];
/* harmony default export */ var eventType_reducer = ({
    allEventType: function allEventType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventType_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_176" /* CORE_LOAD_EVENTTYPE_REQUEST */]:
            case types["_320" /* CORE_SEARCH_EVENTTYPE_REQUEST */]:
                return eventType_reducer_initialState;
            case types["_177" /* CORE_LOAD_EVENTTYPE_SUCCESS */]:
            case types["_321" /* CORE_SEARCH_EVENTTYPE_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    eventType: function eventType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_174" /* CORE_LOAD_EVENTTYPE_INFO_REQUEST */]:
                return {};
            case types["_175" /* CORE_LOAD_EVENTTYPE_INFO_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/reducers.js

































/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["c" /* reducer */],
    notifications: Object(lib["reducer"])(),
    auth: reducer,
    ui: ui_reducer,
    integration: integration_reducer.initialState,
    ini: integration_reducer.ini,
    integrationInfo: integration_reducer.integrationInfo,
    roomsO365: rooms_reducer.roomsO365,
    roomsCore: rooms_reducer.roomsCore,
    roomsSubscribe: rooms_reducer.roomsSubscribe,
    roomCore: rooms_reducer.roomCore,
    allRoomReport: report_reducer.coreRoom,
    roomReport: report_reducer.roomReport,
    users: user_reducer.users,
    usersO365: user_reducer.usersO365,
    usersAD: user_reducer.usersAD,
    user: user_reducer.user,
    setting: setting_reducer.setting,
    statusSum: report_reducer.statusSum,
    userReport: report_reducer.userReport,
    roomReports: report_reducer.roomReports,
    userSum: report_reducer.userSum,
    roomSum: report_reducer.roomSum,
    amenity: amenity_reducer.amenity,
    amenityMaster: amenity_reducer.amenityMaster,
    amenityInfo: amenity_reducer.amenityInfo,
    fbs: fbs_reducer.fbs,
    fbsMaster: fbs_reducer.fbsMaster,
    fbsInfo: fbs_reducer.fbsInfo,
    fbCategory: fbCategory_reducer.fbCategory,
    profileList: profile_reducer.profileList,
    profileInfo: profile_reducer.profileInfo,
    usergroups: usergroup_reducer.usergroups,
    usergroup: usergroup_reducer.usergroup,
    actions: action_reducer.actions,
    userStatus: report_reducer.userStatus,
    userSummary: report_reducer.userSummary,
    // roomSummary : reportReducer.roomSummary,
    roomTemp: report_reducer.roomTemp,
    topRoom: report_reducer.topRoom,
    topUser: report_reducer.topUser,
    roomDetail: report_reducer.roomDetail,
    roomsStatus: report_reducer.roomsStatus,
    term: term_reducer.term,
    faq: faq_reducer.faq,
    contactus: contact_reducer.contactus,
    building: building_reducer.building,
    buildingInfo: building_reducer.buildingInfo,
    floor: floor_reducer.floor,
    floorinfo: floor_reducer.floorInfo,
    zone: zone_reducer.zone,
    zoneInfo: zone_reducer.zoneInfo,
    background: background_reducer.background,
    backgroundInfo: background_reducer.backgroundInfo,
    fbCategoryInfo: fbCategory_reducer.fbCategoryInfo,
    AD: setting_reducer.AD,
    TMS: setting_reducer.TMS,
    CMR: setting_reducer.CMR,
    BOT: setting_reducer.BOT,
    timezone: setting_reducer.timezone,
    integrationData: setting_reducer.integrationData,
    events: events_reducer.events,
    checkIn: events_reducer.checkIn,
    checkOut: events_reducer.checkOut,
    deleteEvent: events_reducer.deleteEvent,
    resetPassword: user_reducer.resetPassword,
    allDisplay: display_reducer.allDisplay,
    displayInfo: display_reducer.displayInfo,
    profileCenterInfo: profilecenter_reducer.profileCenterInfo,
    profileUpdateStatus: profilecenter_reducer.profileUpdateStatus,
    roomDisableList: roomDisable_reducer.roomDisableList,
    roomDisable: roomDisable_reducer.roomDisable,
    vcList: rooms_reducer.vcList,
    concurrents: concurrent_reducer.concurrents,
    roles: roles_reducer.roles,
    role: roles_reducer.role,
    eventRoomFormat: roomformat_reducer.eventRoomFormat,
    eventRoomFormatInfo: roomformat_reducer.eventRoomFormatInfo,
    orderFbs: order_reducer.orderFbs,
    orderFbsInfo: order_reducer.orderFbsInfo,
    orderAmenity: order_reducer.orderAmenity,
    orderAmenityInfo: order_reducer.orderAmenityInfo,

    avaibleOrder: order_reducer.avaibleOrder,

    allEventType: eventType_reducer.allEventType,
    eventType: eventType_reducer.eventType,
    importUserO365: user_reducer.importUserO365,
    usersADList: user_reducer.usersADList
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 955:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 957:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 958:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 963:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[683]);


// WEBPACK FOOTER //
// app.2a3a3571941b82f71f92.js